<script>
import { ref } from "vue";
import Multiselect from "@vueform/multiselect";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import useVuelidate from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import Loader from "../components/loader";
import api from "@/axios";
import moment from "moment";
import Swal from "sweetalert2";
import { useMagicKeys, whenever } from "@vueuse/core";
import { Workbook } from "exceljs";
import { exportDataGrid } from "devextreme/excel_exporter";
import { saveAs } from "file-saver-es";
import DxButton from "devextreme-vue/button";
import DxToolbar, { DxItem } from "devextreme-vue/toolbar";
import DropZone from "@/components/widgets/dropZone.vue";
// import VueEasyLightbox from "vue-easy-lightbox";
import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxStateStoring,
  DxGroupPanel,
  DxGrouping,
  DxPager,
  DxFilterRow,
  DxRemoteOperations,
} from "devextreme-vue/data-grid";
import {getBaseUrl} from "@/helpers/baseUrl";
import {resolveTabelaPreco} from "@/helpers/tabelaPreco";
import {cubagemItem} from "@/helpers/cubagem";
import {arredonda2, calculaDescontoVolume, totalComDesconto} from "@/helpers/descontoVolume";
import isMobileMixin from "@/helpers/isMobile";
import {reservarAbaPdf, entregarPdf, descartarAbaPdf} from "@/helpers/arquivoPdf";

export default {
  components: {
    Layout,
    PageHeader,
    Loader,
    Multiselect,
    DxToolbar,
    DxItem,
    DxButton,
    DxDataGrid,
    DxColumn,
    DxColumnChooser,
    DxColumnFixing,
    DxSelection,
    DxExport,
    DxStateStoring,
    DxGroupPanel,
    DxGrouping,
    DxPager,
    DxFilterRow,
    DxRemoteOperations,
    DropZone,
    // VueEasyLightbox
  },
  mixins: [isMobileMixin],
  setup() {
    let dropzoneFile = ref("");
    const drop = (e) => {
      dropzoneFile.value = e.dataTransfer.files[0];
    };
    return { dropzoneFile, drop, v$: useVuelidate() };
  },
  data() {
    return {
      dtlistPesqNatureza: [],
      showErrosLotes: false,
      dtListLotes: [],
      listErroLote: [],
      transportadora: [],

      imgSmall: false,

      paramOrctoIsolado: false,
      paramOrctoConfParcFin: false,
      showModalCarga: false,
      submitCodCarga: false,
      loadingCargas: false,
      cargasData: null,

      paramSugereItens: false,
      showModalSugereItens: false,
      orctoItensSugeridos: false,
      submittedItensSugeridos: false,
      sugereItensPendente: false,
      carregandoSugereItens: false,

      // desconto por volume (descontoproduto): resumo gravado pelo backend e
      // regras para a prévia na sugestão de itens
      descontoVolume: null,
      showDetalheDescVol: false,
      descVolRegras: [],
      descVolPrevia: [],
      // o desconto por volume não é automático: só com o flag do orçamento ligado
      descVolAplicaSug: false,
      salvandoDescVolAplica: false,
      // banner do desconto na sugestão: recolhe ao rolar a lista, expande no clique
      descVolRolado: false,
      descVolExpandido: false,

      submittedPeriodo: false,
      valorTotalFinanc: 0,

      submitOrctoFinanc: false,
      showModalOrctoFinan: false,
      orctoFinanData: {},
      orctoFinansData: {},

      cotaFreteListData: {},

      loadingCotarFrete: false,
      showModalCotarFrete: false,
      showModalDesconto: false,
      messageValidacaoItem: "",
      margemBrutaOrcto: 0,

      showSelecionarEnder: false,
      showModalAuditoria: false,
      showModalTransp: false,
      showModalFrete: false,
      submitOrctoItem: false,

      loadingCliente: false,
      loadingCondPgto: false,
      loadingFormaPgto: false,
      loadingRepres: false,
      loadingPedTipo: false,
      loadingOrctoItem: false,
      loadingTransp: false,
      loadingFinanc: false,

      dtListPesqCli: [],
      dtListPesqCondPgto: [],
      dtListPesqFormaPgto: [],
      dtListPesqRepres: [],
      dtlistPesqPedTipo: [],
      dtlistPesqOrctoItem: [],
      dtListPesqTransp: [],
      dtListPesqFreteCota: [],
      dtListPesqConta: [],

      showModalCliente: false,
      showModalCondPgto: false,
      showModalDataOrcamento: false,
      showModalFormaPgto: false,
      showModalRepres: false,
      showModalPedTipo: false,
      showModalOrctoItem: false,
      showModalObs: false,
      showModalAcao: false,

      idRow: null,
      idProd: null,
      Prod: null,

      // ---- layout mobile ----
      showModalAcoesMobile: false,
      mobileItensSelecionados: [],

      currentTab: "ItensOrcamento", // Aba inicial
      tabs: [
        { name: "ItensOrcamento", label: "Itens Orçamento" },
        { name: "SaldosConferencia", label: "Saldos de Conferência" },
        { name: "OSRelacionadas", label: "OS Relacionadas" },
      ],

      orctoData: {
        id: 0,
        status: "EL",
        formapgto: "10",
        condpgto: "10",
        cliente: "",
        //tipo: "20",
        tipo: 1, //Id de venda de mercadoria de 'natureza'
        dtemissao: new Date(),
      },
      clienteData: null,
      condPgtoData: {
        codigo: "10",
        descricao: "30 / 60 Dias",
      },
      formaPgtoData: {
        codigo: "10",
        descricao: "Boleto",
      },
      pedTipoData: {
        codigo: "20",
        descricao: "Venda Estabelecimento",
      },
      pessoaEnderData: {},
      represData: {},
      // representante gravado no orçamento: base para avisar se a troca muda a tabela de preço
      represSalvo: { codigo: null, data: null },
      transpData: {},
      freteCotaData: {},
      orctoItemData: {},
      orctoItensData: null,
      countOrctoItens: 0,
      qtdTotalItens: 0,

      errosValid: null,
      itensData: null,

      idData: 0,
      updating: true,
      title: "Orçamento",
      items: [
        {
          text: "Orçamentos",
          href: "/orcamentos/list",
        },
        {
          text: "Orçamento",
          active: true,
        },
      ],
      wmsos: [],
      wmsositens: [],

      showModalAddCampanha: false,
      dtListCampanhas: [],
      campanhaData: {},
      campanhaSelected: {},
      flagCampanhaParam: false,

      submittedAnexo: false,

      showModalIndicaPedido: false,
      dtListPedidos: [],
      flagAgregacaoPedido: false,
      naturezaData: {},
      orctoSalvo: false,
      showModalNatureza: false,

      showModalFinanceiroData: false,
      financeiroData: {
        condpgto: null,
        formapgto: null,
        banco: null,
        consutil: false,
      },

      showModalErro: false,
      errorMessage: "",

      showModalAssociaLotes: false,
      dtListAssociaLote: [],
      updatingReserva: false,
      showModalMsgUpdating: false,
      disableButton: false,
      empresaData: {}
    };
  },
  validations: {
    orctoItemData: {
      produto: {
        required: helpers.withMessage(
            "Campo produto obrigatório, favor preencher.",
            required
        ),
      },
      qtd: {
        required: helpers.withMessage(
            "Campo quantidade obrigatório, favor preencher.",
            required
        ),
      },
      vlrunitliq: {
        required: helpers.withMessage(
            "Campo valor unitário obrigatório, favor preencher.",
            required
        ),
      },
      vlrtotalliq: {
        required: helpers.withMessage(
            "Campo valor total obrigatório, favor preencher.",
            required
        ),
      },
    },
  },
  watch: {
    "orctoItemData.qtd": {
      handler() {
        this.calculaTotalItem();
      },
    },
    "orctoItemData.vlrunitliq": {
      handler() {
        this.calculaTotalItem();
      },
    },
    showModalFinanceiroData: {
      handler(aberto) {
        if (!aberto && this.sugereItensPendente) {
          this.sugereItensPendente = false;
          this.abreModalSugereItens();
        }
      },
    },
    showModalSugereItens: {
      handler(aberto) {
        this.descVolRolado = false;
        this.descVolExpandido = false;
        if (!aberto) {
          this.carregandoSugereItens = false;
        }
      },
    },
  },

  computed: {
    descVolCompacto() {
      return this.descVolRolado && !this.descVolExpandido;
    },

    totaisSug() {
      const totais = {itens: 0, qtd: 0, cub: 0, vlr: 0};
      (this.orctoItensSugeridos || []).forEach((item) => {
        const qtd = parseFloat(item.qtd) || 0;
        if (qtd > 0) {
          totais.itens++;
        }
        totais.qtd += qtd;
        totais.cub += parseFloat(item.cubtot) || 0;
        totais.vlr += parseFloat(item.vlrtotalliq) || 0;
      });
      return totais;
    },

    descVolPreviaAtingidas() {
      return (this.descVolPrevia || []).filter((r) => r.atingida);
    },

    descVolPreviaProximas() {
      return (this.descVolPrevia || []).filter((r) => !r.atingida);
    },

    // regra não atingida mais perto da faixa, para a mensagem resumida
    descVolProxima() {
      const regras = this.descontoVolume?.regras || [];
      return regras.find((r) => !r.atingida) || null;
    },
    dataGrid: function () {
      return this.$refs.dataGridRefKey?.instance ?? null;
    },

    /**
     * Regra usada pelos botões de editar/excluir item: replica a condição
     * que já existia espalhada pelo template.
     */
    podeEditarItens: function () {
      return this.paramOrctoConfParcFin === true
        ? this.orctoData.status === "EL"
        : this.orctoData.status === "EL" || this.orctoData.status === "CP";
    },

    /**
     * Resolve qual tabela de preço vale para este orçamento: a do representante
     * (codtab1 nas condições à vista / curto prazo, codtab2 nas demais).
     * Sem o campo preenchido não há tabela e nada é bloqueado.
     * Espelha a regra de App\Services\TabelaPrecoService no backend.
     */
    tabPrecoResolvida: function () {
      return resolveTabelaPreco(this.clienteData, this.condPgtoData, this.represData);
    },

    podeAdicionarItem: function () {
      return this.tabPrecoResolvida.ok;
    },
  },

  beforeUnmount() {
    document.body.classList.remove("pagina-orcamentos");
  },

  mounted() {
    // Habilita os ajustes de layout mobile restritos às telas de orçamento
    document.body.classList.add("pagina-orcamentos");

    const keys = useMagicKeys();
    whenever(keys.alt_s, () => {
      if (
          this.paramOrctoConfParcFin === true
              ? this.orctoData.status === "EL"
              : this.orctoData.status === "EL" || this.orctoData.status === "CP"
      ) {
        this.salvarOrcamento();
      }
    });
    whenever(keys.alt_i, () => {
      this.imprimirOrcamento();
    });
    whenever(keys.alt_n, () => {
      if (
          this.paramOrctoConfParcFin === true
              ? this.orctoData.status === "EL"
              : this.orctoData.status === "EL" || this.orctoData.status === "CP"
      ) {
        this.novoProduto();
      }
    });

    this.$watch(
        "orctoItensSugeridos",
        function () {
          this.calculaTotalItemSug();
        },
        { deep: true }
    );

    console.log("mounted_orcamento_editar_0");
    let rota = this.$route.path;
    // console.log(rota)
    let ultimaBarra = rota.lastIndexOf("/");
    if (ultimaBarra) {
      this.idData = parseInt(rota.substring(ultimaBarra + 1));
    }
    console.log(`idData: ${this.idData}`);

    if (this.idData > 0) {
      this.carregarDados();
    } else {
      this.title = `Criando Novo Orçamento`;
      this.updating = false;
      let emprAtu = localStorage.getItem("empratu");
      this.orctoData.empresa = emprAtu;

      this.abreModalClienteSeSemCliente();

      api.get(`${getBaseUrl()}api/orctodf`).then((res) => {
        console.log("res defaults");
        console.log(res);
        this.freteCotaData = res.data[0];
        if (this.freteCotaData && this.freteCotaData.id) {
          this.orctoData.segto = res.data[0].codigo;
          this.dtListPesqFreteCota = [
            {
              codigo: this.freteCotaData.codigo,
              nome: this.freteCotaData.nome,
            },
          ];
        }
      });
    }
  },

  methods: {
    reconsiderarSaldoItens(){
      console.log('reconsiderarSaldoItens')

      let itens = this.itensSelecionados()

      if (itens.length === 0) {
        this.avisaSemItemSelecionado()
        return
      }

      let validados = true
      itens.forEach((item) => {
        if(!item.desconsidsaldo){
          validados = false
        }
      })

      if(!validados){
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Todos os itens já estão sendo considerados!",
          showConfirmButton: false,
          timer: 2500,
        })
      } else {
        console.log('revalidar todos os itens')

        api.post(`${getBaseUrl()}api/reconsidsaldoorctoitem`, {
          iddata: this.orctoData.id
        }).then((res) => {
          console.log("then axioss reconsidsaldoorctoitem");
          console.log(res.data)
          // console.log(JSON.stringify(res.data))


          if(res.data.success) {
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: res.data.message,
              showConfirmButton: false,
              timer: 2500,
            }).then(() => {
              this.carregarDados()
            })
          } else {
            Swal.fire({
              position: "top-end",
              icon: "danger",
              title: "Erro no processamento",
              showConfirmButton: false,
              timer: 2500,
            }).then(() => {
              this.carregarDados()
            })
          }
        })
      }
    },

    desconsiderarSaldoItens(){
      console.log('desconsiderarSaldoItens')

      let itens = this.itensSelecionados()

      if (itens.length === 0) {
        this.avisaSemItemSelecionado()
        return
      }

      api.post(`${getBaseUrl()}api/desconsidsaldoorctoitem`, {
        itens: itens
      }).then((res) => {
        console.log("then axioss desconsidsaldoorctoitem");
        console.log(res.data)
        // console.log(JSON.stringify(res.data))

        if(res.data.success) {
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: res.data.message,
            showConfirmButton: false,
            timer: 2500,
          }).then(() => {
            this.carregarDados()
          })
        } else {
          Swal.fire({
            position: "top-end",
            icon: "danger",
            title: "Erro no processamento",
            showConfirmButton: false,
            timer: 2500,
          }).then(() => {
            this.carregarDados()
          })
        }
      })
    },

    gerarReservaSaldos(){
      console.log('gerarReservaSaldos')

      /*
      * Antes de realizar qualquer disparo, verificar se todos os lotes foram definidos
      */
      let validado = true
      this.dtListAssociaLote.forEach(item => {
        if(!item.lote || item.lote < 1) {
          validado = false
        }
      })

      if(!validado) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Todos os itens devem estar com lotes definidos!",
          showConfirmButton: false,
          timer: 3500,
        })
      } else {
        this.updatingReserva = true

        api.post(`${getBaseUrl()}api/reservasaldoloteswmsos`, {
          itens: this.dtListAssociaLote
        }).then((res) => {
          console.log("then axioss reservasaldolotes");
          console.log(res.data)
          // console.log(JSON.stringify(res.data))

          this.showModalAssociaLotes = false
          this.updatingReserva = false

          if(res.data.success) {
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: res.data.message,
              showConfirmButton: false,
              timer: 2500,
            }).then(() => {
              this.carregarDados()
            })
          }
        })
      }
    },

    criaMovAjtFromOrcto() {
      console.log('criaMovAjtFromOrcto')
      this.updating = true;
      api.get(`${getBaseUrl()}api/criaorctomovajt`, {
        params: {
          idData: this.idData,
        }
      }).then((res) => {
        console.log('then axios criaorctomovajt')
        console.log(res.data)
        //console.log(JSON.stringify(res.data))

        this.showModalMsgUpdating = false

        if (res.data.success) {
          let movajt_id = res.data.movajt_id

          Swal.fire({
            position: "top-end",
            icon: "success",
            text: res.data.message ?? "Ajuste criado com sucesso!",
            showConfirmButton: false,
            timer: 2500,
          }).then(() => {
            let route = this.$router.resolve(`/movajuste/editar/${movajt_id}`);
            window.open(route.href, '_blank');
          });
        }else{
          Swal.fire({
            position: "top-end",
            icon: "error",
            text: res.data.error ?? "Criação de Ajuste Falhou!",
            showConfirmButton: false,
            timer: 3000,
          }).then(() => {
            this.carregarDados()
          });
        }
      })
          .then(() => {
            this.updating = false;
          })
    },

    removerNatureza(){
      if (this.orctoData.status !== 'EL'){
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de orçamento não permite alteração",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          return
        });
      }

      console.log('delete natureza')
      this.orctoData.tipo = null
      this.salvarOrcamento()
    },

    editarNaturezas(){
      console.log('redirect to naturezas')

      let route = this.$router.resolve("/naturezas/list")
      window.open(route.href, '_blank')
    },

    escolheuNatureza(value, option){
      console.log('escolheuNatureza')

      let idNatureza = value ?? this.orctoData.tipo
      let naturezaSelecionada = option

      if (!naturezaSelecionada && Array.isArray(this.dtlistPesqNatureza)) {
        naturezaSelecionada = this.dtlistPesqNatureza.find((natureza) => natureza.id === idNatureza)
      }

      if (!naturezaSelecionada) {
        this.loadingPedTipo = false
        return
      }

      console.log('natureza selected:')
      console.log(naturezaSelecionada)

      this.naturezaData = naturezaSelecionada
      this.loadingPedTipo = false
      this.orctoData.tipo = naturezaSelecionada.id
      if (this.orctoData.tipo) {
        this.salvarOrcamento()
        //this.showModalNatureza = false
      }
    },

    removerPedAssoc(){
      //console.log('removerPedAssoc')
      Swal.fire({
          position: 'center',
          icon: 'info',
          title: 'Desassociando Orçamento do Pedido!',
          showConfirmButton: false,
          timer: 2000
        }).then(() => {
          this.orctoData.agregped_id = null
          this.salvarOrcamento()
        })
    },

    escolheuPedido(){
      //console.log('escolheuPedido')

      this.salvarOrcamento()
      this.showModalIndicaPedido = false
    },

    pesqPedido(evt){
      console.log('pesqPedido')
      console.log('evt')
      console.log(evt)

      let query = evt
      console.log(query.length)
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/pesqped`, {
          params: {
            q: query,
          }
        }).then((res) => {
          console.log('then axios pesqPedido')
          console.log(res.data)

          this.dtListPedidos = res.data ?? []
        })
      }
    },

    pesqConta(evt){
      console.log('pesqFinConta')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/ccontapesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqConta = res.data
          this.dtListPesqConta.sort((a,b) => a.codigo - b.codigo);
        });
      }
    },

    escolheuConta() {
      console.log('selectedContaData', this.financeiroData.banco_id)
      this.loadingConta = true;
      this.loadingFinanc = true;
      console.log(this.financeiroData.banco_id);
      api.get(`${getBaseUrl()}api/cconta`, {
        params: { iddata: this.financeiroData.banco_id },
      }).then((res) => {
        console.log("then axios");
        // console.log(res.data);
        this.ContaData = res.data[0];

        this.loadingConta = false;
        this.loadingFinanc = false;
        this.financeiroData.banco_id = this.ContaData.id;
        this.financeiroData.banco = this.ContaData.banco;
      });
    },

    editarFinanceiro() {
      console.log('editarFinanceiro')

      this.abreModalFinanceiro();
    },

    abreModalFinanceiro() {
      console.log('abreModalFinanceiro')

      this.carregarCondPgtoDisponiveis();
      this.carregarFormaPgtoDisponiveis(true);
      this.showModalFinanceiroData = true;

      /**
       * Abre já a lista de condições de pagamento disponíveis.
       */
      this.$nextTick(() => {
        setTimeout(() => {
          const selectCondPgto = this.$refs.selectCondPgtoFinanceiro;

          if (selectCondPgto && typeof selectCondPgto.open === 'function') {
            selectCondPgto.open();
          }
        }, 400);
      });
    },

    carregarCondPgtoDisponiveis() {
      console.log('carregarCondPgtoDisponiveis')

      this.loadingCondPgto = true;

      api.get(`${getBaseUrl()}api/cpgtopesq`, {
        params: { q: "" },
      })
          .then((res) => {
            const lista = res.data || [];

            /**
             * Mantém a condição atual na lista caso ela não venha na consulta.
             */
            if (
                this.condPgtoData &&
                this.condPgtoData.id &&
                !lista.some((item) => item.codigo === this.condPgtoData.codigo)
            ) {
              lista.unshift({
                id: this.condPgtoData.id,
                codigo: this.condPgtoData.codigo,
                descricao: this.condPgtoData.descricao,
              });
            }

            this.dtListPesqCondPgto = lista;
            this.loadingCondPgto = false;
          })
          .catch(() => {
            this.loadingCondPgto = false;
          });
    },

    carregarFormaPgtoDisponiveis(sugerirBoleto = false) {
      console.log('carregarFormaPgtoDisponiveis')

      api.get(`${getBaseUrl()}api/fpgtopesq`, {
        params: { q: "" },
      })
          .then((res) => {
            const lista = res.data || [];

            /**
             * Mantém a forma atual na lista caso ela não venha na consulta.
             */
            if (
                this.formaPgtoData &&
                this.formaPgtoData.id &&
                !lista.some((item) => item.codigo === this.formaPgtoData.codigo)
            ) {
              lista.unshift({
                id: this.formaPgtoData.id,
                codigo: this.formaPgtoData.codigo,
                descricao: this.formaPgtoData.descricao,
              });
            }

            this.dtListPesqFormaPgto = lista;

            /**
             * Orçamento ainda sem forma de pagamento: já sugere boleto.
             */
            if (sugerirBoleto && !(this.formaPgtoData && this.formaPgtoData.id)) {
              const boleto = lista.find((item) => /boleto/i.test(item.descricao || ''));

              if (boleto) {
                this.orctoData.formapgto = boleto.codigo;
                this.escolheuFormaPgto();
              }
            }
          });
    },

    confirmarFinanceiro() {
      console.log('confirmarFinanceiro')

      const financeiroData = this.financeiroData

      this.financeiroData.condpgto = financeiroData.condpgto
      this.financeiroData.formapgto = financeiroData.formapgto
      this.financeiroData.banco = financeiroData.banco
      this.financeiroData.consutil = financeiroData.consutil

      this.showModalFinanceiroData = false

      this.salvarOrcamento()
    },

    removerCampanha(){
      console.log('remove campain')

      this.orctoData.codcampanha = null
      this.campanhaData = {}
      this.campanhaSelected = {}

      this.salvarOrcamento()
    },

    selectedFile(){
      this.dropzoneFile = document.querySelector(".dropzoneFile").files[0]

      let arquivoEmMegas = this.dropzoneFile.size / 1000000;
      if (arquivoEmMegas > 2) {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Panilha não pode passar 2 megas!",
          showConfirmButton: false,
          timer: 4000,
        }).then(() => {
          this.showModalImportarMovAjt = false;
        });
      }
    },

    validaImportacaoCampanha() {
      if (!this.campanhaData.descricao) {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Campo descrição obrigatório!",
          showConfirmButton: false,
          timer: 2500,
        }).then(() => {
          this.submittedAnexo = false;
        });
      } else {
        this.confirmarImportacaoCampanha();
      }
    },

    confirmarImportacaoCampanha() {
      this.submittedAnexo = true;
      if (this.dropzoneFile.name) {
        this.showModalAtuLogo = false;
        this.updating = true;

        let arquivo = document.querySelector(".dropzoneFile").files[0];
        console.log(arquivo);

        let arquivoEmMegas = arquivo.size / 1000;

        if (arquivoEmMegas > 300) {
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Arquivo não pode ultrapassar 300 Kb!",
            showConfirmButton: false,
            timer: 4000,
          }).then(() => {
            this.submittedAnexo = false;
            this.dropzoneFile = "";
            this.carregarDados();
          });
        } else {
          let formData = new FormData();
          formData.append("iddata", this.idData);
          formData.append("campanha_descricao", this.campanhaData.descricao);
          formData.append("campanha_codigo", this.campanhaData.codigo);
          formData.append("filename", arquivo.name);
          formData.append("file", arquivo);

          api
            .post(`${getBaseUrl()}api/postcamp`, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((res) => {
              console.log("then axios postcamp");
              console.log(res.data);

              if (res.data.success) {
                Swal.fire({
                  position: "top-end",
                  icon: "success",
                  title: "Campanha inserida com sucesso!",
                  showConfirmButton: false,
                  timer: 2000,
                })
                  .then(() => {
                    this.campanhaData = {};
                    this.carregarDados();
                  })
                  .then(() => {
                    Swal.fire({
                      position: "top-end",
                      icon: "warning",
                      title: "Associe a campanha desejada ao orçamento!",
                      showConfirmButton: false,
                      timer: 3000,
                    });
                  });
              } else {
                Swal.fire({
                  position: "center",
                  icon: "error",
                  title: "Processamento falhou!",
                  text: res.data.error,
                  showConfirmButton: false,
                  timer: 5000,
                }).then(() => {
                  this.dropzoneFile = "";
                  this.showModalAddCampanha = false;
                  this.campanhaData = {};
                  this.carregarDados();
                });
              }
            })
            .catch((err) => {
              console.log("erro axios");
              // console.log(err)
              // console.log(err.response)
              // console.log(err.response.data.errors)
              let erros = err.response.data.errors;
              console.log(erros);
              console.log(typeof erros);
              let listaErros = [];
              Object.keys(erros).forEach((key) => {
                console.log(key, erros[key]);
                listaErros.push({
                  titulo: key,
                  mensagem: erros[key],
                });
              });
              this.showModalAddCampanha = false;
              this.errosValid = listaErros;
              this.updating = false;
              this.campanhaData = {};
              this.carregarDados();
            });
        }
      }
    },

    pesqCampanha(evt) {
      console.log("pesqCampanha");
      console.log("evt");
      console.log(evt);

      let query = evt;
      console.log(query.length);
      if (query.length > 1) {
        api
          .get(`${getBaseUrl()}api/pesqcamp`, {
            params: {
              q: query,
              orcamento_id: this.idData,
            },
          })
          .then((res) => {
            console.log("then axios pesqlotes");
            console.log(res.data);

            this.dtListCampanhas = res.data.campanhaList ?? [];
          });
      }
    },

    escolheuCampanha(evt) {
      console.log("escolheuCampanha");
      //console.log(`${typeof evt} - ${JSON.stringify(evt)}`)

      this.orctoData.codcampanha = evt;
      console.log(`codcampanha: ${this.orctoData.codcampanha}`);

      Swal.fire({
        position: "top-end",
        icon: "success",
        title: "Campanha adicionada!",
        showCancelButton: false,
        showConfirmButton: false,
        timer: 1500,
      }).then(() => {
        this.showModalAddCampanha = false;
        this.salvarOrcamento();
      });
    },

    pesqLotes(evt) {
      console.log("pesqLotes");
      console.log("evt");
      console.log(evt);

      let query = evt;
      console.log(query.length);
      if (query.length > 1) {
        api
          .get(`${getBaseUrl()}api/pesqlotes`, {
            params: {
              q: query,
              produto_id: this.orctoItemData["produto_id"],
              qtd: this.orctoItemData["qtd"],
            },
          })
          .then((res) => {
            console.log("then axios pesqlotes");
            console.log(res.data);

            this.dtListLotes = res.data;
            console.log("dtListLotes");
            console.log(this.dtListLotes);
          });
      }
    },

    escolheuLote(evt) {
      console.log("escolheuLote");
      console.log(evt);
    },

    formataLotes(orctoItemData) {
      console.log("formataLotes");

      const strToArr = orctoItemData.lotes.split(",").map((s) => s.trim());

      let orctoitem = this.orctoItensData.forEach((value) => {
        return value.produto_id === orctoItemData.produt_id;
      });

      if (orctoitem) {
        orctoitem.lotes = strToArr;
      }
    },

    calculaTotalItemSug() {
      console.log("calculaTotalItemSug");
      const sugeridos = this.orctoItensSugeridos || [];

      /**
       * Prévia do desconto por volume: os itens já gravados no orçamento também
       * somam para a faixa do produto/grupo. O preço final é gravado pelo backend.
       */
      const calc = calculaDescontoVolume(
          [
            ...(this.orctoItensData || []).map((i) => ({chave: `o${i.id}`, produto: i.produto, grupo: i.grupo, qtd: i.qtd})),
            ...sugeridos.map((i, idx) => ({chave: `s${idx}`, produto: i.produto, grupo: i.grupo, qtd: i.qtd})),
          ],
          this.descVolRegras
      );

      sugeridos.forEach((value, idx) => {
        const qtd = parseFloat(value.qtd) || 0;
        const regra = qtd > 0 ? calc.itens[`s${idx}`] : null;
        const perc = regra && this.descVolAplicaSug ? parseFloat(regra.desconto) || 0 : 0;
        const vlrunit = parseFloat(value.vlrunitliq) || 0;

        value.descvolprevperc = perc;
        value.descvolprevregra = regra ? regra.codigo : null;
        value.vlrtotalliq = totalComDesconto(qtd, vlrunit, perc);
        value.cubtot = qtd * (parseFloat(value.cubunt) || 0);
      });

      this.descVolPrevia = calc.regras.filter((r) => r.qtdatual > 0);
    },

    carregaRegrasDescVol() {
      api.get(`${getBaseUrl()}api/orctodescvolregras`, {
        params: {iddata: this.idData},
      })
          .then((res) => {
            this.descVolRegras = Array.isArray(res.data) ? res.data : [];
            if (this.orctoItensSugeridos) {
              this.calculaTotalItemSug();
            }
          })
          .catch(() => {
            this.descVolRegras = [];
          });
    },

    // histerese para o banner não ficar abrindo/fechando no limite da rolagem
    onScrollSugLista(evt) {
      const topo = evt.target.scrollTop;
      if (topo > 40) {
        this.descVolRolado = true;
      } else if (topo < 5) {
        this.descVolRolado = false;
        this.descVolExpandido = false;
      }
    },

    toggleDetalheDescVol() {
      this.showDetalheDescVol = !this.showDetalheDescVol;
    },

    /**
     * Liga/desliga o desconto por volume do orçamento. O backend reaplica
     * (ou desfaz) o desconto nos itens já gravados.
     */
    gravaDescVolAplica(aplica) {
      this.salvandoDescVolAplica = true;
      return api
          .post(`${getBaseUrl()}api/orctodescvolaplica`, {
            iddata: this.idData,
            aplica: aplica,
          })
          .then((res) => {
            this.orctoData.descvolaplica = aplica;
            this.descontoVolume = res.data[0] || this.descontoVolume;
          })
          .catch((e) => {
            Swal.fire({
              position: "center",
              icon: "error",
              title: e.response?.data?.message || "Não foi possível alterar o desconto por volume.",
              showConfirmButton: true,
            });
            throw e;
          })
          .finally(() => {
            this.salvandoDescVolAplica = false;
          });
    },

    alteraDescVolAplica(aplica) {
      this.gravaDescVolAplica(aplica)
          .then(() => this.carregarDados())
          .catch(() => {});
    },

    alteraVlrUnitSug(field, valor) {
      console.log("alteraVlrUnitSug");
      field.vlrunitliq = this.parseDecimalPtBr(valor);
      // sem a marca o backend grava o preço de tabela e ignora o valor da tela
      field.vlrunitdigitado = true;
      this.calculaTotalItemSug();
      // reexibe o valor formatado mesmo quando o número informado não muda
      this.$forceUpdate();
    },

    copiaQtdUltima(field) {
      console.log("copiaQtdUltima");
      field.qtd = field.qtdultima;
      this.normalizaQtdSug(field, true);
    },

    // seleciona todo o conteúdo ao focar (o setTimeout preserva a seleção
    // depois do mouseup do clique)
    selecionaConteudo(evt) {
      const input = evt.target;
      setTimeout(() => input.select(), 0);
    },

    // enter no campo quantidade leva o foco para a quantidade da linha abaixo
    focoProximaQtdSug(field, index) {
      this.normalizaQtdSug(field, true);
      const proximo = this.orctoItensSugeridos[index + 1];
      if (!proximo) {
        return;
      }
      this.$nextTick(() => {
        const input = document.getElementById(`sug_qtd${proximo.produto_id}`);
        if (input) {
          input.focus();
          input.select();
        }
      });
    },

    // não permite quantidade negativa; no blur o campo vazio volta para zero
    normalizaQtdSug(field, saindoDoCampo = false) {
      const qtd = parseFloat(field.qtd);
      if (qtd < 0 || (saindoDoCampo && isNaN(qtd))) {
        field.qtd = 0;
      }
      this.calculaTotalItemSug();
    },

    deletarItemSug(indexVol) {
      console.log("deletarItemSug");
      console.log(indexVol);
      this.orctoItensSugeridos.splice(indexVol, 1);
    },

    abrirModalCarga() {
      this.submitCodCarga = false;
      this.showModalCarga = true;
      this.loadingCargas = true;
      if (
        this.paramOrctoConfParcFin === true
          ? this.orctoData.status === "EL"
          : this.orctoData.status === "EL" || this.orctoData.status === "CP"
      ) {
        api
          .get(`${getBaseUrl()}api/orctocargas`, {
            params: { iddata: this.idData },
          })
          .then((res) => {
            console.log("resData orctoCargas");
            console.log(res.data[0]);
            this.cargasData = res.data[0];
            this.loadingCargas = false;
          });
      }
    },

    selectTab(tab) {
      this.currentTab = tab;
    },

    confCodCarga() {
      console.log("confCodCarga");

      if (!this.orctoData.carga || `${this.orctoData.carga}`.trim() === "") {
        this.submitCodCarga = true;
        return;
      }

      this.submitCodCarga = false;
      this.showModalCarga = false;
      this.updating = true;

      this.salvarOrcamento();
    },

    fecharOrcamento() {
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Fechar orçamento",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        showConfirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then((result) => {
        if (result.value) {
          api
            .get(`${getBaseUrl()}api/quitarorcto`, {
              params: {
                iddata: this.idData,
              },
            })
            .then((res) => {
              console.log("then fecharOrcamento");
              console.log(res.data);

              let flag = res.data.success ?? false;

              if (flag) {
                Swal.fire({
                  position: "top-end",
                  icon: "success",
                  text: res.data.message,
                  showCancelButton: false,
                  showConfirmButton: false,
                  timer: 2500,
                }).then(() => {
                  this.atualizaPagina();
                });
              } else {
                Swal.fire({
                  position: "top-end",
                  icon: "error",
                  text: res.data.error,
                  showCancelButton: false,
                  showConfirmButton: false,
                  timer: 2500,
                }).then(() => {
                  this.atualizaPagina();
                });
              }
            })
            .catch((e) => {
              console.log("error");
              console.log(e);
            });
        }
      });
    },

    deletarOrctoSugestao(data) {
      console.log("deletarOrctoSugestao");
      this.orctoItensSugeridos.splice(
        this.orctoItensSugeridos.indexOf(data),
        1
      );
    },

    confSugestao() {
      console.log("confSugestao");
      this.showModalSugereItens = false;
      this.updating = true;
      let itensSugFinal = [];
      this.orctoItensSugeridos.forEach((value) => {
        value["orcamento_id"] = this.idData;
        if (value.qtd > 0) {
          // campos de prévia não vão para o backend: ele aplica o desconto por volume
          // eslint-disable-next-line no-unused-vars
          const { qtdultima, descvolprevperc, descvolprevregra, ...itemSug } = value;
          itensSugFinal.push(itemSug);
        }
      });
      // console.log('itensSugFinal')
      // console.log(itensSugFinal)
      // grava antes o flag do desconto por volume: a inclusão dos itens já o respeita
      const gravaFlag = this.descVolAplicaSug !== !!this.orctoData.descvolaplica
          ? this.gravaDescVolAplica(this.descVolAplicaSug).catch(() => {})
          : Promise.resolve();

      gravaFlag
        .then(() => api.post(`${getBaseUrl()}api/orctoitens`, {
          orctoItensData: itensSugFinal,
        }))
        .then((res) => {
          console.log("then axios");
          console.log(res);

          /**
           * Os sugeridos entram com o preço da tabela do representante, não com o
           * preço histórico. Os que não têm preço na tabela são descartados.
           */
          const semPreco = res.data[1]?.sempreco || [];

          if (semPreco.length > 0) {
            const tabSug = res.data[1].tabpreco ? ` na tabela ${res.data[1].tabpreco}` : "";
            let html = `<p class="mb-1 text-start">Itens não incluídos por falta de preço${tabSug}:</p><ul class="text-start">`;
            semPreco.forEach((item) => {
              html += `<li>${item.produto} - ${item.descprod}</li>`;
            });
            html += "</ul>";

            Swal.fire({
              position: "center",
              icon: "warning",
              title: "Itens sem preço cadastrado",
              html: html,
              showConfirmButton: true,
            });
          } else {
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações salvas com sucesso!",
              showConfirmButton: false,
              timer: 2000,
            });
          }

          this.carregarDados();
        });
    },

    redirecionaPedido(idOs) {
      console.log("redirecting to pedido");

      const url = this.$router.resolve({
        path: `/wmsos/saidaeditarnova/${idOs}`,
      }).href;
      window.open(url, "_blank");
    },

    atualizaPagina() {
      window.location.reload();
    },

    excluirFinanc() {
      console.log("excluirFinanc");
      this.showModalOrctoFinan = false;

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then((result) => {
        if (result.value) {
          this.updating = true;
          api
            .delete(`${getBaseUrl()}api/orctofinanc`, {
              params: {
                iddata: this.orctoFinanData.id,
              },
            })
            .then((res) => {
              console.log("then axios delete");
              console.log(res.data);
              this.carregarDados();
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Informações excluídas com sucesso!",
                showConfirmButton: false,
                timer: 1500,
              });
            });
        }
      });
    },

    alteraPagamento(dataSel) {
      console.log("alteraPagamento");
      this.orctoFinanData = dataSel;
      this.dtListPesqFormaPgto = [
        {
          codigo: dataSel.formapgto,
          descricao: dataSel.formapgtodesc,
        },
      ];
      this.showModalOrctoFinan = true;
    },

    novoPagamento() {
      console.log("exibirPagamentos");
      this.orctoFinanData = {};
      this.submitOrctoFinanc = false;
      this.showModalOrctoFinan = true;
    },

    escolherFrete(cotafrt_id, transpcnpj, valorFrete) {
      console.log("escolherFrete");
      console.log(valorFrete);
      this.orctoData.valorfrt = valorFrete;
      this.orctoData.cotafrt_id = cotafrt_id;
      this.orctoData.transp = transpcnpj;
      this.showModalCotarFrete = false;
      console.log('oct')
      console.log(this.orctoData)
      this.salvarOrcamento();

      Swal.fire({
        position: "top-end",
        icon: "success",
        title: "Frente selecionado com sucesso!",
        showConfirmButton: false,
        timer: 1500,
      }).then(() => {
        this.atualizaPagina();
      });
    },

    cotarFrete() {
      console.log("cotarFrete");
      this.showModalCotarFrete = true;
      this.loadingCotarFrete = true;

      api
        .get(`${getBaseUrl()}api/cotarfreteocto`, {
          params: { iddata: this.idData },
        })
        .then((res) => {
          console.log("res cotarFrete");
          console.log(res.data[0]);

          if (!res.data["SDT_WSRetorno"]) {
            Swal.fire({
              position: "top-end",
              icon: "error",
              title: res.data[0],
              showConfirmButton: false,
              timer: 5000,
            }).then(() => {
              // this.atualizaPagina()
            });
          } else {
            console.log(res.data["SDT_WSRetorno"]["Resultados"]);
            // console.log(res.data[0]['SDT_WSRetorno'])
            this.cotaFreteListData = res.data["SDT_WSRetorno"]["Resultados"];

            // ordenar array pela WSOut_Frete_Val
            this.cotaFreteListData = this.cotaFreteListData
              .slice()
              .sort(function (a, b) {
                return a.WSOut_Frete_Val - b.WSOut_Frete_Val;
              });

            let menorValor = 999999;
            let menorPrazo = 999999;
            this.cotaFreteListData.forEach((value) => {
              if (value.WSOut_Frete_Val < menorValor) {
                menorValor = value.WSOut_Frete_Val;
              }
              if (value.WSOut_Prazo_Dias < menorPrazo) {
                menorPrazo = value.WSOut_Prazo_Dias;
              }

              value.WSOut_Frete_Val = parseFloat(value.WSOut_Frete_Val);
            });

            this.cotaFreteListData.forEach((value) => {
              if (value.WSOut_Frete_Val === menorValor) {
                value["menorvalor"] = true;
              }
              if (value.WSOut_Prazo_Dias === menorPrazo) {
                value["menorprazo"] = true;
              }
            });

            this.loadingCotarFrete = false;
          }
        });
    },

    auditoria() {
      console.log("auditoria");
      this.showModalAuditoria = true;
    },

    focusProdOrctoItem() {
      this.$refs.focusThis.focus();
    },

    imprimirOrcamento() {
      this.updating = true;

      // A aba precisa ser reservada agora, dentro do clique: quando o PDF ficar
      // pronto o browser mobile já não abre nada por conta própria.
      const abaPdf = reservarAbaPdf(this.isMobile);

      api
        .get(`${getBaseUrl()}api/orctopdf`, {
          responseType: "blob",
          params: { iddata: this.idData },
        })
        .then((res) => {
          entregarPdf(res.data, `Orcamento ${this.idData}.pdf`, abaPdf);
        })
        .catch((err) => {
          console.log("erro axios imprimirOrcamento");
          console.log(err);
          descartarAbaPdf(abaPdf);
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: "Não foi possível gerar o PDF do orçamento!",
            showConfirmButton: false,
            timer: 4000,
          });
        })
        .finally(() => {
          this.updating = false;
        });
    },

    copiarOrcamento() {
      console.log("copiarOrcamento");
      this.updating = true;
      api
        .post(`${getBaseUrl()}api/orctocopy`, {
          iddata: this.idData,
        })
        .then((res) => {
          console.log("then axios copiar");
          console.log(res.data[0].id);
          //this.orctoData = res.data

          this.idData = res.data[0].id;
          this.$router.replace({ path: `/orcamento/editar/${this.idData}` });
          this.carregarDados();

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Orçamento copiado com sucesso!",
            showConfirmButton: false,
            timer: 1500,
          });
        });
    },

    redirecionarOrcamentoWMS() {
      console.log("redirecionarOrcamentoWMS");
      this.updating = true;
      api.post(`${getBaseUrl()}api/recionaorcamentowmseconopro`, {
        iddata: this.idData,
      }).then((res) => {
        console.log("then axios redirecionarOrcamentoWMS");
        console.log(res.data);
        this.updating = false;
        if (res.data.success) {
          Swal.fire({
            position: "top-end",
            icon: "success",
            title:
              res.data.message || "Redirecionamento realizado com sucesso!",
            showConfirmButton: false,
            timer: 2500,
          });
        } else {
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: res.data.error || "Erro ao realizar redirecionamento!",
            showConfirmButton: false,
            timer: 4000,
          });
        }
      }).catch((err) => {
        console.log("erro axios redirecionarOrcamentoWMS");
        console.log(err);
        this.updating = false;
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: "Erro na comunicação com o servidor!",
          showConfirmButton: false,
          timer: 4000,
        });
      });
    },

    copiarOrcamento02() {
      console.log("copiarOrcamento02");
      this.updating = true;
      api
        .post(`${getBaseUrl()}api/orctocopy02`, {
          iddata: this.idData,
        })
        .then((res) => {
          console.log("then axios copiar");
          console.log(res.data[0].id);
          //this.orctoData = res.data

          this.idData = res.data[0].id;
          this.$router.replace({ path: `/orcamento/editar/${this.idData}` });
          this.carregarDados();

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Orçamento copiado com sucesso!",
            showConfirmButton: false,
            timer: 1500,
          });
        });
    },

    deletarOrctoItem(iditem) {
      console.log("deletarOrctoItem");
      console.log(iditem);

      if (
        this.paramOrctoConfParcFin === true
          ? this.orctoData.status === "EL"
          : this.orctoData.status === "EL" || this.orctoData.status === "CP"
      ) {
        Swal.fire({
          position: "center",
          icon: "question",
          title: "Exclusão de Registro",
          text: "Esta operação é irreversível, tem certeza que deseja continuar?",
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          showConfirmButton: true,
        }).then((result) => {
          if (result.value) {
            this.updating = true;
            api
              .delete(`${getBaseUrl()}api/orctoitem`, {
                params: {
                  iddata: iditem,
                },
              })
              .then((res) => {
                console.log("then axios delete");
                console.log(res.data);
                this.carregarDados();
                Swal.fire({
                  position: "top-end",
                  icon: "success",
                  title: "Informações excluídas com sucesso!",
                  showConfirmButton: false,
                  timer: 1500,
                });
              });
          }
        });
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de orçamento não permite alteração",
          showConfirmButton: false,
          timer: 1500,
        });
      }

      this.showModalAcao = false;
    },

    calculaTotalItem() {
      console.log("calculaTotalItem");

      // let desc = this.orctoItemData.desconto
      // valores sempre com 2 casas: total = qtd x unitário já arredondado
      let quant = this.orctoItemData.qtd;
      let vlrUnit = arredonda2(this.orctoItemData.vlrunitliq);
      let vlrUnitTab = arredonda2(this.orctoItemData.vlrunitbrt);
      let percDesc = 0;

      if (quant > 0 && vlrUnit > 0) {
        if (vlrUnit !== vlrUnitTab) {
          percDesc = (1 - vlrUnit / vlrUnitTab) * 100;
        }

        let valorTotalItem = arredonda2(quant * vlrUnit);

        console.log("valorTotalItem");
        console.log(valorTotalItem);

        // this.orctoItemData.desconto = percDesc
        this.orctoItemData.vlrtotalbrt = arredonda2(vlrUnitTab * quant);
        this.orctoItemData.vlrtotalliq = valorTotalItem;

        if (percDesc > 1000) {
          this.messageValidacaoItem =
            "Margem máxima de desconto atingida (30%), favor corrigir antes de confirmar";
        } else {
          this.messageValidacaoItem = "";
        }

        this.orctoItemData.pesobrttot = this.orctoItemData.pesobrtun * quant;
        this.orctoItemData.pesoliqtot = this.orctoItemData.pesoliqun * quant;
        this.orctoItemData.cubtot = this.orctoItemData.cubunt * quant;
      }
    },

    confOrctoItem() {
      console.log("confOrctoItem: " + this.idData);
      this.v$.$touch();
      this.submitOrctoItem = true;

      if (this.v$.$invalid) {
        return;
      } else {
        console.log("formSubmit_validado");
        this.loadingOrctoItem = true;

        console.log(`item: ${this.orctoItemData}`);
        api.post(`${getBaseUrl()}api/orctoitem`, {
            orctoItemData: this.orctoItemData,
          }).then((res) => {
            console.log("then axios");
            console.log(res);
            this.produtoData = res.data[0];
            this.updating = false;

            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações salvas com sucesso!",
              showConfirmButton: false,
              timer: 2000,
            });
            this.loadingOrctoItem = false;
            this.showModalOrctoItem = false;
            this.carregarDados();
            // this.atualizaPagina()
          }).catch((err) => {
            console.log("erro axios");
            // console.log(err)
            console.log(err.response);
            console.log(err.response.data.errors);
            let erros = err.response.data.errors;
            console.log(erros);
            console.log(typeof erros);
            let listaErros = [];
            Object.keys(erros).forEach((key) => {
              console.log(key, erros[key]);
              listaErros.push({
                titulo: key,
                mensagem: erros[key],
              });
            });
            this.errosValid = listaErros;
            this.updating = false;
            this.loadingOrctoItem = false;
            this.activeTab = 0;

            /**
             * O item continua na tela quando o backend recusa a precificação,
             * então o motivo precisa aparecer por cima do modal.
             */
            if (erros.tabpreco) {
              Swal.fire({
                position: "center",
                icon: "warning",
                title: "Item não incluído",
                text: [].concat(erros.tabpreco).join(" "),
                showConfirmButton: true,
              });
            }
            // this.atualizaPagina()
          });
      }
    },

    confOrctoFinanc() {
      console.log("confOrctoFinanc: " + this.idData);
      this.v$.$touch();
      this.submitOrctoFinanc = true;
      if (!this.orctoFinanData.valor && !this.orctoFinanData.formapgto) {
        return;
      } else {
        console.log("submitOrctoFinanc_validado");
        this.orctoFinanData.orcamento_id = this.idData;
        this.updating = true;
        api
          .post(`${getBaseUrl()}api/orctofinanc`, {
            orctoFinancData: this.orctoFinanData,
          })
          .then((res) => {
            console.log("then axios");
            console.log(res);
            // this.produtoData = res.data[0]
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações salvas com sucesso!",
              showConfirmButton: false,
              timer: 1500,
            });
            this.updating = false;
            this.showModalOrctoFinan = false;
            this.carregarDados();
          })
          .catch((err) => {
            console.log("erro axios");
            // console.log(err)
            console.log(err.response);
            console.log(err.response.data.errors);
            let erros = err.response.data.errors;
            console.log(erros);
            console.log(typeof erros);
            let listaErros = [];
            Object.keys(erros).forEach((key) => {
              console.log(key, erros[key]);
              listaErros.push({
                titulo: key,
                mensagem: erros[key],
              });
            });
            this.errosValid = listaErros;
            this.updating = false;
          });
      }
    },

    novoProduto() {
      console.log("novoProduto: " + this.idData);

      if (this.idData === 0) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Favor salvar o orçamento antes de adicionar item",
          showConfirmButton: false,
          timer: 1500,
        });
        return;
      }

      /**
       * Sem cliente e condição de pagamento não há tabela de preço definida,
       * logo o item não teria preço válido.
       */
      if (!this.podeAdicionarItem) {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Dados de precificação pendentes",
          text: this.tabPrecoResolvida.motivo,
          confirmButtonText: "Informar agora",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
        }).then((result) => {
          if (result.value) {
            if (!this.clienteData || !this.clienteData.id) {
              this.showModalCliente = true;
            } else {
              this.abreModalFinanceiro();
            }
          }
        });
        return;
      }

      this.orctoItemData = {};
      this.showModalOrctoItem = true;
    },

    detalhesProduto(idProd) {
      console.log("detalhesProduto: " + idProd);

      // this.$router.push(`/produto/editar/${idProd}`);

      let route = this.$router.resolve({ path: `/produto/editar/${idProd}` });
      window.open(route.href);

      this.showModalAcao = false;
    },

    editarProduto(idProd) {
      console.log("editarProduto: " + idProd);

      if (
        this.paramOrctoConfParcFin === true
          ? this.orctoData.status === "EL"
          : this.orctoData.status === "EL" || this.orctoData.status === "CP"
      ) {
        this.showModalOrctoItem = true;
        this.loadingOrctoItem = true;

        api.get(`${getBaseUrl()}api/orctoitem`, {
            params: { iddata: idProd },
          }).then((res) => {
            console.log("then axios editarProduto");
            console.log(res.data[0]);

            this.orctoItemData = res.data[0];

            if (this.orctoItemData.imgs) {
              let imgTrat = this.orctoItemData.imgs.split(",");
              this.orctoItemData.img1 = `${getBaseUrl() + '_IMG'}/peq/${imgTrat[0]}`;
            }

            this.loadingOrctoItem = false;

            this.dtListLotes = this.orctoItemData["lote"] ?? [];

            console.log("item");
            console.log(this.orctoItemData);
          });
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de orçamento não permite alteração",
          showConfirmButton: false,
          timer: 1500,
        });
      }

      this.showModalAcao = false;
    },

    confirmarOrcamento() {
      console.log("confirmarOrcamento: " + this.idData);
      //console.log(this.orctoData.condpgto);
      //console.log(this.condPgtoData);
      //console.log(this.orctoData.formapgto);
      //console.log(this.formaPgtoData);

      this.disableButton = false

      if (!this.orctoData.carga || `${this.orctoData.carga}`.trim() === "") {
        this.showModalMsgUpdating = false
        this.disableButton = false

        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Código de carga não informado",
          text: "Informe o código de carga antes de confirmar o orçamento.",
          showConfirmButton: true,
          confirmButtonText: "Informar carga",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
        }).then((result) => {
          if (result.isConfirmed) {
            this.abrirModalCarga();
          }
        });

        return;
      }

      Swal.fire({
        position: "center",
        icon: "info",
        title: "Validando os dados para confirmação do orçamento!",
        showConfirmButton: false,
        timer: 1500,
      });

      if (
          this.orctoFinansData.length > 0 &&
          this.orctoData.valorliq !== this.valorTotalFinanc
      ) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Valor financeiro deve ser igual a valor líquido de orçamento, favor corrigir.",
          showConfirmButton: false,
          timer: 2500,
        });
        this.showModalMsgUpdating = false
        this.disableButton = false
      } else {
        if (!this.orctoItensData || this.orctoItensData.length <= 0) {
          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: "Favor adicionar produto ao orçamento antes de confirmar",
            showConfirmButton: false,
            timer: 1500,
          });
          this.showModalMsgUpdating = false
          this.disableButton = false
        } else {
          this.updating = true
              api
                .get(`${getBaseUrl()}api/validaorctoitems`, {
                  params: {
                    iddata: this.idData,
                  },
                }).then((res) => {
                  //console.log("then validaorctoitems");
                  //console.log(JSON.stringify(res.data));
                  this.showModalMsgUpdating = false
                  let validacaoItens = res.data;
                  this.updating = false

                  if (!validacaoItens.empresaParam) {
                    console.log("skip validação saldo");

                  this.dispararConfirmOrcamento();
                } else {
                  if (validacaoItens.contemWmsos !== undefined && validacaoItens.contemWmsos !== null && validacaoItens.contemWmsos) {
                    Swal.fire({
                      position: "center",
                      icon: "warning",
                      title: "Atenção",
                      text: "Ordens de saída pendentes!",
                      showConfirmButton: true,
                      showCancelButton: true,
                      confirmButtonText: "Redirecionar",
                      cancelButtonText: "Cancelar"
                    }).then((confirmed) => {
                      if (confirmed.isConfirmed) {
                        let wmsos_id = validacaoItens.wmsosExistente
                        if(wmsos_id !== null && wmsos_id !== undefined && wmsos_id < 0) {
                          Swal.fire({
                            position: "center",
                            icon: "error",
                            title: "Error",
                            text: "Redirecionamento falhou!",
                            showConfirmButton: false,
                            showCancelButton: false,
                            timer: 2500,
                          }).then(() => {
                            this.carregarDados()
                            this.disableButton = false
                            this.showModalMsgUpdating = false
                            return
                          });
                        }

                        /***Redirecionando em caso de sucesso*/
                        this.$router.push("/wmsos/saidaeditarnova/" + wmsos_id)
                      } else {
                        this.disableButton = false
                      }
                    });
                  }else{
                    if (validacaoItens.flagSaldoLoteIndisponivel) {
                      Swal.fire({
                        position: "center",
                        icon: "error",
                        title: "Lote indisponível",
                        text: "O lote indicado não possui mais saldo disponível, favor editar o item e confirmar novamente",
                        showConfirmButton: true,
                        timer: 10000,
                      }).then(() => {
                        console.log("lotes indisponiveis");
                        this.showErrosLotes = true;
                        this.listErroLote = res.data.lotesIndisponiveis;
                        this.disableButton = false
                        this.showModalMsgUpdating = false
                      });
                    } else {
                      if (!validacaoItens.flagNegativo) {
                        this.dispararConfirmOrcamento();
                      } else {
                        if (validacaoItens.flagNegativo && validacaoItens.flagConfLoteWmsos) {
                          Swal.fire({
                            position: "center",
                            icon: "error",
                            title: "Gerar Ajuste de entrada?",
                            text: "Sua empresa possui parâmetro de conferências lotes ativada! Saldo de entrada é obrigatório!",
                            showConfirmButton: true,
                            confirmButtonText: "Criar",
                            showCancelButton: true,
                            cancelButtonText: "Não",
                          }).then(check => {
                            if(check.isConfirmed) {
                              console.log('criar movajt')
                              this.criaMovAjtFromOrcto()
                              this.carregarDados()
                              this.showModalMsgUpdating = false
                            } else {
                              this.disableButton = false
                            }
                          })
                        }else{
                          Swal.fire({
                            position: "center",
                            icon: "error",
                            title: "Itens sem estoque disponível!",
                            text: "Deseja realizar uma entrada?",
                            showConfirmButton: true,
                            confirmButtonText: "Sim",
                            showCancelButton: true,
                            cancelButtonText: "Não"
                          }).then((check) => {
                            if (check.isConfirmed) {
                              this.showModalMsgUpdating = true
                              this.criaMovAjtFromOrcto()
                              this.carregarDados()
                            } else {

                              this.listErroLote = []
                              this.showModalMsgUpdating = false

                              /*
                              * Validando lotes dos itens
                              */
                              console.log('validando lotes')
                              this.orctoItensData.forEach((item) => {
                                if(item.deflote && (item.lote === null || item.lote === "")){
                                  this.listErroLote.push(
                                      {'sequenc': item.sequenc, 'codprod': item.produto, 'descprod': item.descprod}
                                  )
                                }
                              })

                              if(this.listErroLote.length > 0){
                                console.log('produto sem lote definido!')

                                Swal.fire({
                                  position: "top-end",
                                  icon: "warning",
                                  title: "Produtos sem lote definido!",
                                  showConfirmButton: false,
                                  timer: 2500,
                                })

                                this.showModalMsgUpdating = false
                                this.showErrosLotes = true
                                this.disableButton = false
                                return
                              }

                              Swal.fire({
                                position: "center",
                                icon: "error",
                                title: "Confirmação de orçamento cancelada!",
                                text: "Valide o estoque antes de dar continuidade aos fluxos de saída!",
                                confirmButton: false,
                                timer: 5000,
                              });
                              this.disableButton = false
                            }
                          });
                        }
                      }
                    }
                  }
                }
              })
              .catch(error => {
                console.error("Erro na comunicação da API:", error);
                this.updating = false
                this.disableButton = false
              });
        }
      }
    },

    dispararConfirmOrcamento() {
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Confirmação de Orçamento",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then((result) => {
        if (result.value) {
          this.updating = true;
          this.showModalMsgUpdating = true

          api.post(`${getBaseUrl()}api/orctoconfnovo`, {
              //focusnfeorctoconf | orctoconf
              iddata: this.idData,
            }).then((res) => {
              this.showModalMsgUpdating = false
              console.log("then axios confirmarOrcamento");
              console.log(res.data);
              //console.log(JSON.stringify(res.data));
              this.disableButton = false

              /*
              * Validando nova associação de lote
               */
              if (!res.data.success && res.data?.tipoErro === 'lote') {
                console.log('error associação de lote')

                Swal.fire({
                  position: "top-end",
                  icon: "error",
                  title: res.data.error,
                  showConfirmButton: false,
                  timer: 4000,
                }).then(() => {
                  this.dtListAssociaLote = res.data.itensError
                  console.log(JSON.stringify(this.dtListAssociaLote))

                  if(this.dtListAssociaLote.length > 1) {
                    this.showModalAssociaLotes = true
                  }
                });
              } else {
                let idRedirecionamento = res.data.id;

                if (this.paramOrctoIsolado) {
                  Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Orçamento confirmado com sucesso",
                    text: "Encaminhando para lista de orçamentos!",
                    showConfirmButton: false,
                    timer: 4000,
                  }).then(() => {
                    this.orctoData.status = "CO";
                    this.$router.push(`/orcamentos/list`);
                  });
                } else {
                  if (res.data.success === true) {
                    if (res.data.processo === "wmsos") {
                      Swal.fire({
                        position: "top-end",
                        icon: "success",
                        title: "Orçamento confirmado com sucesso",
                        text: "Encaminhando para conferência de saída!",
                        showConfirmButton: false,
                        timer: 4000,
                      }).then(() => {
                        console.log("redirecting to wmsos...");

                        //this.$router.replace({ path: `/wmsos/saidaeditarnova/${idRedirecionamento}`});
                        this.$router.push({ path: `/wmsos/saidaeditarnova/${idRedirecionamento}`});
                      });
                    } else if (res.data.processo === "pedido") {
                      Swal.fire({
                        position: "top-end",
                        icon: "success",
                        title: "Orçamento confirmado com sucesso",
                        text: "Encaminhando para o novo pedido que foi criado!",
                        showConfirmButton: false,
                        timer: 4000,
                      }).then(() => {
                        console.log("redirecting to pedido...");
                        this.$router.push(
                            `/pedido/detalhe/${idRedirecionamento}`
                        );
                      });
                    }
                  } else {
                    Swal.fire({
                      position: "top-end",
                      icon: "error",
                      title: res.data.msg ?? "Erro ao confirmar o orçamento!",
                      text: res.data[1],
                      showConfirmButton: false,
                      timer: 2500,
                    }).then(() => {
                      this.updating = false;
                      this.errorMessage = res.data.errorValidacaoProduto
                      this.showModalErro = true
                    });
                  }
                }
              }
            });
          }
      });
    },

    reverterCancelarOrcto() {
      if (this.idData > 0) {
        this.updating = true;

        api
            .post(`${getBaseUrl()}api/orctorevert`, {
              iddata: this.idData,
            })
            .then((res) => {
              console.log("then axios");
              console.log(res.data);
              this.orctoData = res.data[0];
              this.updating = false;

              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Orçamento revertido com sucesso!",
                showConfirmButton: false,
                timer: 1500,
              });
            });
      }
    },

    cancelarOrcamento() {
      console.log("cancelarOrcamento: " + this.idData);
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Cancelamento de Orçamento",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then((result) => {
        if (result.value) {
          if (this.idData > 0) {
            this.updating = true;
            api
                .post(`${getBaseUrl()}api/orctocanc`, {
                  iddata: this.idData,
                })
                .then((res) => {
                  console.log("then axios");
                  console.log(res);
                  this.orctoData = res.data[0];
                  this.updating = false;
                  Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Orçamento cancelado com sucesso!",
                    showConfirmButton: false,
                    timer: 1500,
                  });
                });
          } else {
            this.$router.go(-1);
          }
        }
      });
    },

    /*nomeStatus(stsIn) {
      let result = 'Não Definido'
      switch (stsIn) {
        case 'EL':
          result = 'Elabotação'
          break
        case 'FA':
          result = 'Faturado'
          break
        case 'CA':
          result = 'Cancelado'
          break
      }
      return result
    },*/

    alteraObs() {
      console.log("alteraObs");
      if (
          this.paramOrctoConfParcFin === true
              ? this.orctoData.status === "EL"
              : this.orctoData.status === "EL" || this.orctoData.status === "CP"
      ) {
        this.showModalObs = true;
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de orçamento não permite alteração",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },

    alteraTransp() {
      console.log("alteraTransp");
      if (
          this.paramOrctoConfParcFin === true
              ? this.orctoData.status === "EL"
              : this.orctoData.status === "EL" || this.orctoData.status === "CP"
      ) {
        this.showModalTransp = true;
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de orçamento não permite alteração",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },

    alteraFrete() {
      console.log("alteraFrete");
      if (
          this.paramOrctoConfParcFin === true
              ? this.orctoData.status === "EL"
              : this.orctoData.status === "EL" || this.orctoData.status === "CP"
      ) {
        this.showModalFrete = true;
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de orçamento não permite alteração",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },

    alteraDesconto() {
      console.log("alteraDesconto");
      if (
          this.paramOrctoConfParcFin === true
              ? this.orctoData.status === "EL"
              : this.orctoData.status === "EL" || this.orctoData.status === "CP"
      ) {
        this.showModalDesconto = true;
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de orçamento não permite alteração",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },

    carregarDados() {
      api
          .get(`${getBaseUrl()}api/orcamento`, {
            params: { iddata: this.idData },
          })
          .then((res) => {
            console.log("then axios carregarDados");
            console.log(res.data);

            this.orctoData = res.data[0];
            this.clienteData = res.data[1];
            this.pedTipoData = res.data[2];
            this.formaPgtoData = res.data[3];
            this.condPgtoData = res.data[4];
            this.orctoItensData = res.data[5];
            // console.log(`orctoItensData: ${JSON.stringify(this.orctoItensData)}`)
            this.represData = res.data[6];
            this.represSalvo = { codigo: this.orctoData.repres || null, data: res.data[6] };
            this.pessoaEnderData = res.data[7];
            this.freteCotaData = res.data[8];
            this.orctoFinansData = res.data[9];
            this.wmsos = res.data[10];
            this.wmsositens = res.data[11];

            if (res.data[13]) {
              this.campanhaSelected = res.data[13];
            }

            this.flagCampanhaParam = this.orctoData.flagCampanha;

            if(res.data[14]){
              this.flagAgregacaoPedido = res.data[14]
            }

            if (res.data[15]){
              this.naturezaData = res.data[15]
            }

            if (res.data[16]){
              this.transportadora = res.data[16]
            }

            this.empresaData = res.data[17]
            console.log(`empresaData: ${JSON.stringify(this.empresaData)}`)

            let totalFinanc = 0;
            this.orctoFinansData.forEach((value) => {
              totalFinanc += value.valor;
            });
            this.valorTotalFinanc = totalFinanc;

            if (this.freteCotaData && this.freteCotaData.id) {
              this.dtListPesqFreteCota = [
                {
                  codigo: this.freteCotaData.codigo,
                  nome: this.freteCotaData.nome,
                },
              ];
            }

            if (this.condPgtoData && this.condPgtoData.id){
              this.dtListPesqCondPgto = [
                {
                  id: this.condPgtoData.id,
                  codigo: this.condPgtoData.codigo,
                  descricao: this.condPgtoData.descricao,
                }
              ];

              this.financeiroData.condpgto = this.condPgtoData.codigo;
            }

            if (this.formaPgtoData && this.formaPgtoData.id){
              this.dtListPesqFormaPgto = [
                {
                  id: this.formaPgtoData.id,
                  codigo: this.formaPgtoData.codigo,
                  descricao: this.formaPgtoData.descricao,
                }
              ]

              this.financeiroData.formapgto = this.formaPgtoData.codigo;
            }

            this.countOrctoItens = this.orctoItensData?.length ?? 0;

            let valorTotal = 0;
            let qtdTotalItens = 0;
            let margemTotal = 0;

            if (this.countOrctoItens > 0) {
              this.orctoItensData.forEach((value) => {
                if (value.imgs) {
                  let imgTrat = value.imgs.split(",");
                  value.img1 = `${getBaseUrl() + '_IMG'}/peq/${imgTrat[0]}`;
                }

                // console.log(value.vlrtotalliq);
                valorTotal += parseFloat(value.vlrtotalliq) || 0;
                qtdTotalItens += parseFloat(value.qtd) || 0;

                if (value.margem) {
                  margemTotal += parseFloat(value.margem) || 0;
                }
              });
            }

            res.data[12].forEach((valueParam) => {
              if (valueParam) {

                //console.log("valueParam");
                //console.log(valueParam);

                if (valueParam.valor === "ORCTO_ISOL") {
                  this.paramOrctoIsolado = true;
                } else if (valueParam.valor === "CONF_PARC_FIN") {
                  this.paramOrctoConfParcFin = true;
                } else if (valueParam.valor === "SUGERE_ITENS_ORCTO") {
                  this.paramSugereItens = true;
                }
              }
            });

            this.valorTotalItens = valorTotal;
            this.qtdTotalItens = qtdTotalItens;
            this.margemBrutaOrcto = margemTotal;

            // resumo das regras de desconto por volume (recalculado pelo backend a cada carga)
            this.descontoVolume = res.data[18] || null;

            this.idData = this.orctoData.id;
            this.title = `${this.orctoData.empresa} - Editar Orçamento (${this.orctoData.id}) ${this.clienteData ? this.clienteData.nome : ""}`;
            this.updating = false;

            this.abreModalClienteSeSemCliente();

            if (
                this.paramSugereItens === true &&
                this.orctoData.cliente &&
                this.orctoData.cliente !== "" &&
                (!this.orctoItensData || this.orctoItensData.length === 0)
            ) {
              //console.log("this.paramSugereItens");
              //console.log(this.paramSugereItens);

              if (this.faltaDadosPagamento()) {
                /**
                 * Cliente selecionado sem condição/forma de pagamento definida:
                 * abre primeiro os dados financeiros e só depois a sugestão de itens.
                 */
                this.sugereItensPendente = true;
                this.$nextTick(() => {
                  this.abreModalFinanceiro();
                });
              } else {
                this.abreModalSugereItens();
              }
            }
          });
    },

    faltaDadosPagamento() {
      return !(this.condPgtoData && this.condPgtoData.id) ||
          !(this.formaPgtoData && this.formaPgtoData.id);
    },

    abreModalSugereItens() {
      /**
       * Evita abrir/carregar a sugestão duas vezes quando o salvamento
       * dos dados financeiros recarrega o orçamento.
       */
      if (this.showModalSugereItens || this.carregandoSugereItens) {
        return;
      }

      this.carregandoSugereItens = true;
      this.descVolAplicaSug = !!this.orctoData.descvolaplica;
      this.carregaRegrasDescVol();

      api.get(`${getBaseUrl()}api/cliultitens`, {
        params: {
          coddata: this.orctoData.cliente,
          /**
           * Define a tabela de preço usada para precificar a sugestão,
           * igual à do item que será criado.
           */
          condpgto: this.orctoData.condpgto,
          repres: this.orctoData.repres,
        },
      })
          .then((resitens) => {
            console.log("then axios_cliultitens");
            console.log(resitens.data);

            const itens = resitens.data[0] || [];

            if (itens.length === 0) {
              this.carregandoSugereItens = false;
              return;
            }

            this.showModalSugereItens = true;
            this.orctoItensSugeridos = itens.map(
                (item) => ({
                  ...item,
                  qtdultima: item.qtd,
                  qtd: 0,
                  vlrtotalliq: 0,
                  cubunt: parseFloat(item.cubunt) || 0,
                  cubtot: 0,
                })
            );

            setTimeout(() => {
              const campo = document.getElementById("sug_qtd" + itens[0].produto_id);

              if (campo) {
                campo.focus();
              }
            }, 1500);
          })
          .catch(() => {
            this.carregandoSugereItens = false;
          });
    },

    abreModalClienteSeSemCliente() {
      if (this.orctoData.cliente && this.orctoData.cliente !== "") {
        return;
      }

      if (
          this.paramOrctoConfParcFin === true
              ? this.orctoData.status === "EL"
              : this.orctoData.status === "EL" || this.orctoData.status === "CP"
      ) {
        this.$nextTick(() => {
          this.showModalCliente = true;
        });
      }
    },

    selecionaCli() {
      console.log("selecionaCli");
      if (
          this.paramOrctoConfParcFin === true
              ? this.orctoData.status === "EL"
              : this.orctoData.status === "EL" || this.orctoData.status === "CP"
      ) {
        this.showModalCliente = true;

        // Recarrega os últimos pedidos do cliente atual: sem isso a tabela
        // ficava com o resultado da última consulta feita na tela.
        if (this.orctoData.cliente) {
          this.escolheuCli();
        }
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de orçamento não permite alteração",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },

    editaDataOrcamento() {
      console.log("editaDataOrcamento");
      if (
          this.paramOrctoConfParcFin === true
              ? this.orctoData.status === "EL"
              : this.orctoData.status === "EL" || this.orctoData.status === "CP"
      ) {
        this.showModalDataOrcamento = true;
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de orçamento não permite alteração",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },

    selecionaFormaPgto() {
      console.log("selecionaFormaPgto");
      if (
          this.paramOrctoConfParcFin === true
              ? this.orctoData.status === "EL"
              : this.orctoData.status === "EL" || this.orctoData.status === "CP"
      ) {
        this.showModalCondPgto = true;
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de orçamento não permite alteração",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },

    selecionaPedTipo() {
      console.log("selecionaPedTipo");
      if (
          this.paramOrctoConfParcFin === true
              ? this.orctoData.status === "EL"
              : this.orctoData.status === "EL" || this.orctoData.status === "CP"
      ) {
        console.log(this.orctoData.tipo);
        this.showModalPedTipo = true;

        if (this.orctoData.tipo) {
          this.escolheuPedTipo();
        }
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de orçamento não permite alteração",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },

    selecionaNatureza() {
      console.log('selecionaNatureza')
      if (this.paramOrctoConfParcFin === true ? this.orctoData.status === 'EL' : this.orctoData.status === 'EL' || this.orctoData.status === 'CP') {
        console.log(this.orctoData.tipo)
        this.showModalNatureza = true
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de orçamento não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },

    selecionaRepres() {
      console.log("selecionaRepres");
      if (this.orctoData.status === "EL") {
        console.log(this.orctoData.repres);

        this.showModalRepres = true;

        if (this.orctoData.repres) {
          this.escolheuRepres();
        }
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de orçamento não permite alteração",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },

    selecionaTransp() {
      console.log("selecionaTransp");
      if (
          this.paramOrctoConfParcFin === true
              ? this.orctoData.status === "EL"
              : this.orctoData.status === "EL" || this.orctoData.status === "CP"
      ) {
        console.log(this.orctoData.repres);
        this.showModalTransp = true;
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de orçamento não permite alteração",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },

    selecionaOrctoItem() {
      console.log("selecionaOrctoItem");
      if (
          this.paramOrctoConfParcFin === true
              ? this.orctoData.status === "EL"
              : this.orctoData.status === "EL" || this.orctoData.status === "CP"
      ) {
        this.showModalOrctoItem = true;
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de orçamento não permite alteração",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },

    confirmarCliente() {
      console.log("confirmarCliente");
      this.showModalCliente = false;

      console.log("this.paramSugereItens");
      console.log(this.paramSugereItens);

      // if (this.paramSugereItens === true) {
      //   console.log('this.paramSugereItens')
      //   console.log(this.paramSugereItens)
      //   api.get(`${getBaseUrl()}api/cliultitens`, {
      //     params: { coddata: this.orctoData.cliente }
      //   }).then((res) => {
      //     console.log('then axios_confirmarCliente')
      //     console.log(res.data)
      //     this.showModalSugereItens = true
      //     this.orctoItensSugeridos = res.data[0]
      //   })
      // }

      this.salvarOrcamento();
    },

    confirmarDataOrcamento() {
      console.log("confirmarDataOrcamento");
      this.salvarOrcamento();
      this.showModalDataOrcamento = false;
    },

    confirmarFormaPgto() {
      console.log("confirmarFormaPgto");
      this.salvarOrcamento();
      this.showModalCondPgto = false;
    },

    confirmarPedTipo() {
      console.log("confirmarPedTipo");
      this.showModalPedTipo = false;
    },

    confirmarRepres() {
      console.log("confirmarRepres");
      if (this.loadingRepres) {
        return;
      }

      /**
       * O representante pode ter tabela própria (codtab1/codtab2). Se a troca muda
       * a tabela de preço e já há itens, avisa que os valores serão recalculados
       * (o backend reprecifica ao gravar).
       */
      const tabelaAnterior = resolveTabelaPreco(this.clienteData, this.condPgtoData, this.represSalvo.data);
      const tabelaNova = this.tabPrecoResolvida;
      const temItens = Array.isArray(this.orctoItensData) && this.orctoItensData.length > 0;

      if (
          !temItens
          || (this.orctoData.repres || null) === this.represSalvo.codigo
          || !tabelaNova.tabpreco
          || tabelaNova.tabpreco === tabelaAnterior.tabpreco
      ) {
        this.salvarOrcamento();
        this.showModalRepres = false;
        return;
      }

      const temDescVol = !!this.orctoData.descvolaplica
          || this.orctoItensData.some((item) => Number(item.descvolperc) > 0);

      let html = `<p class="mb-2 text-start">O representante mudou e a tabela de preço passa de <b>${tabelaAnterior.tabpreco || "sem tabela"}</b> para <b>${tabelaNova.tabpreco}</b> (${tabelaNova.origem}).</p>`;
      html += `<p class="mb-0 text-start">Os valores dos ${this.orctoItensData.length} item(ns) serão recalculados pela nova tabela, mantendo o % de desconto negociado.`;
      if (temDescVol) {
        html += " O desconto por volume aplicado será recalculado sobre o novo preço.";
      }
      html += "</p>";

      // fecha o modal antes: ele prende o foco e o alerta ficaria sem clique
      this.showModalRepres = false;
      Swal.fire({
        icon: "warning",
        title: "Representante alterado",
        html,
        showCancelButton: true,
        confirmButtonText: "Recalcular e salvar",
        cancelButtonText: "Manter representante anterior",
      }).then((result) => {
        if (result.isConfirmed) {
          this.salvarOrcamento();
        } else {
          this.cancelarRepres();
        }
      });
    },

    cancelarRepres() {
      this.orctoData.repres = this.represSalvo.codigo;
      this.represData = this.represSalvo.data;
      this.showModalRepres = false;
    },

    confirmarTransp() {
      console.log("confirmarTransp");
      this.showModalTransp = false;
    },

    confirmarOrctoItem() {
      console.log("confirmarOrctoItem");
      this.showModalOrctoItem = false;
    },

    confirmarFrete() {
      console.log("confirmarFrete");
      this.showModalFrete = false;
      this.salvarOrcamento();
    },

    confirmarDesconto() {
      console.log("confirmarDesconto");
      this.showModalDesconto = false;

      this.updating = true;

      this.errosValid = [];
      api
          .post(`${getBaseUrl()}api/orctodesc`, {
            iddata: this.idData,
            percdesc: this.orctoData.percdesc,
          })
          .then((res) => {
            console.log("then axios desconto");
            console.log(res);
            this.orctoData = res.data[0];
            this.updating = false;

            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações salvas com sucesso!",
              showConfirmButton: false,
              timer: 1500,
            });
          })
          .catch((err) => {
            console.log("erro axios");
            // console.log(err)
            // console.log(err.response)
            // console.log(err.response.data.errors)
            let erros = err.response.data.errors;
            console.log(erros);
            console.log(typeof erros);
            let listaErros = [];
            Object.keys(erros).forEach((key) => {
              console.log(key, erros[key]);
              listaErros.push({
                titulo: key,
                mensagem: erros[key],
              });
            });
            this.errosValid = listaErros;
            this.updating = false;
            this.activeTab = 0;
          });
    },

    pesqCliente(evt) {
      console.log("pesqCliente");
      console.log(evt);
      let query = evt;
      if (query.length > 1) {
        api
            .get(`${getBaseUrl()}api/clipesq`, {
              params: { q: query, c: "CL" },
            })
            .then((res) => {
              console.log("then axios");
              console.log(res.data);
              this.dtListPesqCli = res.data;
            });
      }
    },

    pesqCondPgto(evt) {
      console.log("pesqCondPgto");
      console.log(evt);
      let query = evt;

      console.log(query.length);
      if (query.length > 1) {
        this.loadingCondPgto = true;
        this.loadingFinanc = true;
        this.orctoData.condpgto = "";
        api
            .get(`${getBaseUrl()}api/cpgtopesq`, {
              params: { q: query },
            })
            .then((res) => {
              console.log("then axios");
              console.log(res.data);
              //console.log(res.data.length)
              this.dtListPesqCondPgto = res.data;
            });
      }
    },

    pesqFormaPgto(evt) {
      console.log("pesqFormaPgto");
      console.log(evt);
      let query = evt;
      console.log(query.length);
      if (query.length === 0) {
        // apagou o texto da pesquisa: volta a listar todas
        this.carregarFormaPgtoDisponiveis();
      } else if (query.length > 1) {
        this.loadingFormaPgto = true;
        this.loadingFinanc = true;
        this.orctoData.formapgto = "";
        api
            .get(`${getBaseUrl()}api/fpgtopesq`, {
              params: { q: query },
            })
            .then((res) => {
              console.log("then axios");
              console.log(res.data);
              //console.log(res.data.length)
              this.dtListPesqFormaPgto = res.data;
            });
      }
    },

    carregarNaturezas() {
      console.log('carregarNaturezas')

      this.loadingPedTipo = true
      api.get(`${getBaseUrl()}api/naturpesq`, {
        params: { q: '', t: 'S', f: this.orctoData.empresa }
      }).then((res) => {
        this.dtlistPesqNatureza = Array.isArray(res.data) ? res.data.filter((natureza) => natureza.id) : []
        this.loadingPedTipo = false
      }).catch(() => {
        this.dtlistPesqNatureza = []
        this.loadingPedTipo = false
      })
    },

    pesqNatureza(evt) {
      console.log('pesqNatureza')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1) {
        this.loadingPedTipo = true
        this.orctoData.tipo = ''
        api.get(`${getBaseUrl()}api/naturpesq`, {
          params: { q: query, t: 'S', f: this.orctoData.empresa }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtlistPesqNatureza = res.data
        })
      }
    },

    pesqPedTipo(evt) {
      console.log("pesqPedTipo");
      console.log(evt);
      let query = evt;
      console.log(query.length);
      if (query.length > 1) {
        this.loadingPedTipo = true;
        this.orctoData.tipo = "";
        api
            .get(`${getBaseUrl()}api/tpoprpesq`, {
              params: { q: query, t: "S", f: this.orctoData.empresa },
            })
            .then((res) => {
              console.log("then axios");
              console.log(res.data);
              //console.log(res.data.length)
              this.dtlistPesqPedTipo = res.data;
            });
      }
    },

    pesqRepres(evt) {
      console.log("pesqRepres");
      console.log(evt);

      let query = evt;
      console.log(query.length);
      if (query.length > 1) {
        this.loadingRepres = true;
        this.orctoData.repres = null;

        api.get(`${getBaseUrl()}api/reprpesq`, {
          params: { q: query, t: "S" },
        })
            .then((res) => {
              console.log("then axios reprpesq");
              console.log(res.data);

              if(res.data && res.data.length > 0) {
                this.dtListPesqRepres = res.data;
              }
            });
      }
    },

    pesqTransp(evt) {
      console.log("pesqTransp");
      console.log(evt);
      let query = evt;
      console.log(query.length);
      if (query.length > 1) {
        this.loadingTransp = true;
        this.orctoData.transp = "";
        api
            .get(`${getBaseUrl()}api/transpesq`, {
              params: { q: query },
            })
            .then((res) => {
              console.log("then axios");
              console.log(res.data);
              //console.log(res.data.length)
              this.dtListPesqTransp = res.data;
            });
      }
    },

    pesqFreteCota(evt) {
      console.log("pesqFreteCota");
      console.log(evt);
      let query = evt;
      console.log(query.length);
      if (query.length > 1) {
        // this.loadingTransp = true
        this.orctoData.transp = "";
        api
            .get(`${getBaseUrl()}api/pesqfretecota`, {
              params: { q: query },
            })
            .then((res) => {
              console.log("then axios");
              console.log(res.data);
              //console.log(res.data.length)
              this.dtListPesqFreteCota = res.data;
            });
      }
    },

    pesqOrctoItem(evt) {
      console.log("pesqOrctoItem_0");
      console.log(evt);
      let query = evt;
      console.log(query.length);
      if (query.length > 1) {
        this.dtlistPesqOrctoItem = null;
        this.loadingOrctoItem = true;
        api
            .get(`${getBaseUrl()}api/prodpesq`, {
              params: {
                q: query,
                /**
                 * Cliente + condição definem a tabela de preço usada na busca,
                 * para que o preço exibido já seja o preço de venda deste orçamento.
                 */
                cliente: this.orctoData.cliente,
                condpgto: this.orctoData.condpgto,
                repres: this.orctoData.repres,
              },
            })
            .then((res) => {
              console.log("then axios");
              console.log(res.data);
              // //console.log(res.data.length)
              this.dtlistPesqOrctoItem = res.data;

            this.dtlistPesqOrctoItem.forEach((value) => {
              if (value.imgs) {
                let imgTrat = value.imgs.split(",");
                value.img1 = `${getBaseUrl() + '_IMG'}/peq/${imgTrat[0]}`;
              }
              value["descrcodigo"] =
                value["codigo"] +
                " " +
                value["descricao"] +
                " " +
                value["codbarra"];
            });
          });
      }
    },

    escolheuCli() {
      console.log("escolheuCli");
      this.loadingCliente = true;
      console.log(this.orctoData.cliente);
      api
        .get(`${getBaseUrl()}api/clicod`, {
          params: { coddata: this.orctoData.cliente },
        })
        .then((res) => {
          console.log("then axios");

          // console.log(res.data);
          this.clienteData = res.data[0];
          this.loadingCliente = false;
        });
    },

    escolheuCondPgto() {
      console.log("escolheuCondPgto");
      this.loadingCondPgto = true;
      this.loadingFinanc = true;

      console.log(this.orctoData.condpgto);
      api
        .get(`${getBaseUrl()}api/cpgtocod`, {
          params: { coddata: this.orctoData.condpgto },
        })
        .then((res) => {
          console.log("then axios");
          console.log(res.data);
          this.condPgtoData = res.data[0];

          this.financeiroData.condpgto = this.condPgtoData.codigo

          this.loadingCondPgto = false;
          this.loadingFinanc = false;
        });
    },

    escolheuFormaPgto() {
      console.log("escolheuFormaPgto");
      this.loadingFormaPgto = true;
      this.loadingFinanc = true;
      console.log(this.orctoData.formapgto);
      api
        .get(`${getBaseUrl()}api/fpgtocod`, {
          params: { coddata: this.orctoData.formapgto },
        })
        .then((res) => {
          console.log("then axios");
          console.log(res.data);
          this.formaPgtoData = res.data[0];

          this.financeiroData.formapgto = this.formaPgtoData.codigo

          this.loadingFormaPgto = false;
          this.loadingFinanc = false;
        });
    },

    escolheuPedTipo() {
      console.log("escolheuPedTipo");
      this.loadingPedTipo = true;
      console.log(this.orctoData.tipo);
      api
        .get(`${getBaseUrl()}api/tpoprcod`, {
          params: { coddata: this.orctoData.tipo },
        })
        .then((res) => {
          console.log("then axios_escolheu_ped_tipo");
          console.log(res.data);
          this.pedTipoData = res.data[0];
          this.loadingPedTipo = false;
        });
    },

    escolheuRepres() {
      console.log("escolheuRepres");
      this.loadingRepres = true;
      console.log(this.orctoData.repres);
      api
        .get(`${getBaseUrl()}api/reprcod`, {
          params: { coddata: this.orctoData.repres },
        })
        .then((res) => {
          console.log("then axios_escolheu_repres");
          console.log(res.data);
          // reprcod é restrito a admin: sem retorno, usa o item da pesquisa (traz codtab1/codtab2)
          this.represData = res.data[0]
              || this.dtListPesqRepres.find((r) => r.codigo === this.orctoData.repres)
              || null;
          this.loadingRepres = false;
        });
    },

    escolheuTransp() {
      console.log("escolheuTransp");
      this.loadingTransp = true;
      console.log(this.orctoData.transp);
      api
        .get(`${getBaseUrl()}api/clicod`, {
          params: { coddata: this.orctoData.transp },
        })
        .then((res) => {
          console.log("then axios_escolheu_transp");
          console.log(res.data);
          this.transpData = res.data[0];
          this.loadingTransp = false;
        });
    },

    escolheuFreteCota() {
      console.log("escolheuFreteCota");
      //this.loadingTransp = true
      console.log(this.orctoData.segto);
      api
        .get(`${getBaseUrl()}api/fretecotacod`, {
          params: { coddata: this.orctoData.segto },
        })
        .then((res) => {
          console.log("then axios_escolheu_fretecota");
          console.log(res.data);
          this.freteCotaData = res.data[0];
          //this.loadingTransp = false
        });
    },

    escolheuOrctoItem() {
      console.log("escolheuItem");

      if (!this.podeAdicionarItem) {
        this.orctoItemData = {};
        this.showModalOrctoItem = false;
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Dados de precificação pendentes",
          text: this.tabPrecoResolvida.motivo,
          showConfirmButton: true,
        });
        return;
      }

      this.loadingOrctoItem = true;
      api
        .get(`${getBaseUrl()}api/prodcod`, {
          params: {
            coddata: this.orctoItemData.produto,
            cliente: this.orctoData.cliente,
            condpgto: this.orctoData.condpgto,
            repres: this.orctoData.repres,
          },
        })
        .then((res) => {
          console.log("then axios_escolheu_ped_item");
          console.log(res.data);

          /**
           * Produto sem preço na tabela resolvida não pode ser incluído:
           * o valor viria zerado/indefinido e a venda sairia fora de tabela.
           */
          if (res.data[0] && res.data[0]["sempreco"]) {
            this.orctoItemData = {};
            this.loadingOrctoItem = false;
            Swal.fire({
              position: "center",
              icon: "warning",
              title: "Produto sem preço na tabela do representante",
              text: res.data[0]["msgpreco"],
              showConfirmButton: true,
            });
            return;
          }

          let imgTrat = "";
          if (res.data[0]["imgs"]) {
            // img1 = res.data[0]['imgs']
            imgTrat = res.data[0]["imgs"].split(",");
            // this.produtoData.imgSTrat = `${getBaseUrl()}/uploads/imgprods/peq/${imgTrat[0]}`
          }

          this.orctoItemData = {
            orcamento_id: this.idData,
            produto_id: res.data[0]["id"],
            produto: res.data[0]["codigo"],
            descprod: res.data[0]["descricao"],
            und: res.data[0]["unidade"],
            deflote: res.data[0]['deflote'],
            vlrunitliq: res.data[0]["preco"],
            vlrunitbrt: res.data[0]["preco"],
            vlrtotalliq: res.data[0]["preco"],
            vlrtotalbrt: res.data[0]["preco"],
            saldo: res.data[0]["saldo"],
            pesobrtun: res.data[0]["pesobrt"],
            pesobrttot: res.data[0]["pesobrt"],
            pesoliqun: res.data[0]["pesoliq"],
            pesoliqtot: res.data[0]["pesoliq"],
            cubunt: cubagemItem(res.data[0], 1).cubunt,
            cubtot: cubagemItem(res.data[0], 1).cubtot,

            imgSTrat: `${getBaseUrl()}/uploads/imgprods/peq/${imgTrat[0]}`,
            qtd: 1,

            tabpreco: res.data[0]["tabpreco"],
            tabprecoorigem: res.data[0]["tabprecoorigem"],
          };

          console.log(`orctoItemData: ${this.orctoItemData}`);
          this.loadingOrctoItem = false;
        });
    },

    salvarOrcamento() {
      console.log("salvarOrcamento");

      if (this.orctoData.cliente && this.orctoData.cliente !== "") {
        console.log("salvarOrcamento_00");
        this.updating = true;

        this.errosValid = [];

        /**
         * Associando outros dados
         */
        if(this.financeiroData.banco) {
          this.orctoData.banco_id = this.financeiroData.banco
        }

        if(this.financeiroData.consutil) {
          this.orctoData.consutil = this.financeiroData.consutil
        }

        console.log('orct')
        console.log(this.orctoData)

        api
          .post(`${getBaseUrl()}api/orcamento`, {
            orctoData: this.orctoData,
          })
          .then((res) => {
            console.log("then axios");
            console.log(res);

            let success = res.data[0];

            if (!success) {
              Swal.fire({
                position: "top-end",
                icon: "error",
                title: res.data[1],
                showConfirmButton: false,
                timer: 4000,
              });
            } else {
              this.orctoData = res.data[0];
              this.updating = false;

              /**
               * O backend reprecifica os itens quando o cliente ou a condição de
               * pagamento mudam (a tabela de preço passa a ser outra).
               */
              const recalcPrecos = res.data[1];

              if (recalcPrecos) {
                this.avisaRecalculoPrecos(recalcPrecos);
              } else {
                Swal.fire({
                  position: "top-end",
                  icon: "success",
                  title: "Informações salvas com sucesso!",
                  showConfirmButton: false,
                  timer: 1500,
                }).then(() => {
                  this.orctoSalvo = true;
                });
              }

              if (this.idData === 0) {
                console.log("redirecionar");
                this.$router.replace({
                  path: `/orcamento/editar/${this.orctoData.id}`,
                });
                this.idData = this.orctoData.id;
                this.carregarDados();
              }

              this.carregarDados();
              this.orctoSalvo = true;
            }
          })
          .catch((err) => {
            console.log("erro axios");
            // console.log(err)
            // console.log(err.response)
            // console.log(err.response.data.errors)
            let erros = err.response.data.errors;
            console.log(erros);
            console.log(typeof erros);
            let listaErros = [];
            Object.keys(erros).forEach((key) => {
              console.log(key, erros[key]);
              listaErros.push({
                titulo: key,
                mensagem: erros[key],
              });
            });
            this.errosValid = listaErros;
            this.updating = false;
            this.activeTab = 0;
          });
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Favor selecionar cliente antes de salvar o orçamento",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },

    /**
     * Mostra o resultado da reprecificação disparada por troca de cliente/condição
     * de pagamento: quantos itens mudaram de preço e quais ficaram sem preço na
     * nova tabela (esses continuam com o preço anterior e precisam de cadastro).
     */
    avisaRecalculoPrecos(recalcPrecos) {
      console.log("avisaRecalculoPrecos");
      console.log(recalcPrecos);

      if (recalcPrecos.erro) {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Itens não reprecificados",
          text: recalcPrecos.erro,
          showConfirmButton: true,
        }).then(() => {
          this.orctoSalvo = true;
        });
        return;
      }

      const alterados = recalcPrecos.alterados || [];
      const semPreco = recalcPrecos.sempreco || [];

      if (alterados.length === 0 && semPreco.length === 0) {
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações salvas com sucesso!",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          this.orctoSalvo = true;
        });
        return;
      }

      let html = `<p class="mb-2 text-start">Tabela de preço aplicada: <b>${recalcPrecos.tabpreco}</b> (${recalcPrecos.origem}).</p>`;

      if (alterados.length > 0) {
        html += `<p class="mb-1 text-start">${alterados.length} item(ns) reprecificado(s), mantendo o % de desconto:</p><ul class="text-start">`;
        alterados.forEach((item) => {
          html +=
            `<li>${item.produto} - ${item.descprod}: ` +
            `R$ ${this.formatDecimal(item.vlrunitliqant)} &rarr; R$ ${this.formatDecimal(item.vlrunitliq)}</li>`;
        });
        html += "</ul>";
      }

      if (semPreco.length > 0) {
        html += `<p class="mb-1 mt-3 text-start text-danger">${semPreco.length} item(ns) sem preço na tabela ${recalcPrecos.tabpreco} (valor anterior mantido, favor cadastrar o preço):</p><ul class="text-start">`;
        semPreco.forEach((item) => {
          html += `<li>${item.produto} - ${item.descprod}</li>`;
        });
        html += "</ul>";
      }

      Swal.fire({
        position: "center",
        icon: semPreco.length > 0 ? "warning" : "success",
        title: "Preços recalculados",
        html: html,
        showConfirmButton: true,
      }).then(() => {
        this.orctoSalvo = true;
      });
    },

    carregouGrid(e) {
      console.log("carregouGrid");
      console.log(e)

      if (this.orctoData.id === 0) {
        this.title = "Novo Orçamento";
      } else {
        this.title = `Editando Orçamento: ${this.orctoData.id}`;
      }
    },

    // =====================================================================
    // Apoio ao layout mobile
    // =====================================================================

    /** Itens marcados: vem do grid no desktop e dos cards no mobile. */
    itensSelecionados() {
      if (this.isMobile) {
        return (this.orctoItensData ?? []).filter((item) =>
          this.mobileItensSelecionados.includes(item.id)
        );
      }

      return this.dataGrid ? this.dataGrid.getSelectedRowsData() : [];
    },

    avisaSemItemSelecionado() {
      Swal.fire({
        position: "top-end",
        icon: "warning",
        title: "Nenhum item foi selecionado, favor selecionar.",
        showConfirmButton: false,
        timer: 2000,
      });
    },

    itemSelecionado(id) {
      return this.mobileItensSelecionados.includes(id);
    },

    toggleItemSelecionado(id) {
      const pos = this.mobileItensSelecionados.indexOf(id);

      if (pos >= 0) {
        this.mobileItensSelecionados.splice(pos, 1);
      } else {
        this.mobileItensSelecionados.push(id);
      }
    },

    limparSelecaoItens() {
      this.mobileItensSelecionados = [];
    },

    /** Dispara, no mobile, a mesma ação do botão equivalente do topo. */
    acaoMobile(acao) {
      this.showModalAcoesMobile = false;

      switch (acao) {
        case "salvar":
          this.salvarOrcamento();
          break;
        case "imprimir":
          this.imprimirOrcamento();
          break;
        case "copiar":
          this.copiarOrcamento();
          break;
        case "redirecionar":
          this.redirecionarOrcamentoWMS();
          break;
        case "reverter":
          this.reverterCancelarOrcto();
          break;
        case "cancelar":
          this.cancelarOrcamento();
          break;
        case "novoProduto":
          this.novoProduto();
          break;
        case "cotarFrete":
          this.cotarFrete();
          break;
        case "novoPagamento":
          this.novoPagamento();
          break;
        case "campanha":
          this.showModalAddCampanha = true;
          break;
        case "fechar":
          this.fecharOrcamento();
          break;
        case "agregar":
          this.showModalIndicaPedido = true;
          break;
        case "confirmar":
          this.confirmarOrcamento();
          break;
        default:
          console.log("Ação não definida");
      }
    },

    formatMoeda(value) {
      const value_n = parseFloat(value);

      if (isNaN(value_n)) {
        return "R$ 0,00";
      }

      return value_n.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },

    /** Classe do badge de status usada nos cards mobile. */
    classeStatus(status) {
      switch (status) {
        case "FA":
        case "CO":
        case "FN":
        case "EC":
        case "CF":
          return "badge-soft-success";
        case "CP":
        case "NEM":
          return "badge-soft-info";
        case "EL":
        case "AB":
        case "ES":
          return "badge-soft-warning";
        case "CA":
        case "SC":
          return "badge-soft-danger";
      }

      return "badge-soft-secondary";
    },

    onRowDblClick(row) {
      console.log("onRowDblClick");

      let idRow = row.data.id;
      let idProd = row.data.produto_id;
      let Prod = row.data.produto;

      this.idRow = idRow;
      this.idProd = idProd;
      this.Prod = Prod;
      // this.editarProduto(idProd);
      this.showModalAcao = true;
    },

    onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "desconto") {
          const valdesconto = e.data.desconto;
          let cordesconto = "";

          if (valdesconto > 0.0) {
            cordesconto = "rgba(146,20,0,0.5)";
          } else if (valdesconto <= 0.0) {
            cordesconto = "rgba(33,78,0,0.5)";
          }

          if (cordesconto) {
            e.cellElement.style.cssText = `color: white; background-color: ${cordesconto}`;
          } else {
            e.cellElement.style.cssText = "";
          }
        }

        if (e.column.dataField === "aconferirqtd") {
          const valaconferir = e.data.aconferirqtd;
          const qtd = e.data.qtd;
          let coraconferir = "";

          if (valaconferir > 0.0 && valaconferir === qtd) {
            coraconferir = "";
          } else if (valaconferir > 0.0) {
            coraconferir = "rgba(191,147,9,0.5)";
          } else if (valaconferir === 0.0) {
            coraconferir = "rgba(33,78,0,0.5)";
          }

          if (coraconferir) {
            e.cellElement.style.cssText = `color: white; background-color: ${coraconferir}`;
          } else {
            e.cellElement.style.cssText = "";
          }
        }

        if (e.column.dataField === "conferidoqtd") {
          const valconferir = e.data.conferidoqtd;
          const qtd = e.data.qtd;
          let corconferir = "";

          if (valconferir === 0.0) {
            corconferir = "";
          } else if (valconferir > 0.0 && valconferir < qtd) {
            corconferir = "rgba(191,147,9,0.5)";
          } else if (valconferir === qtd) {
            corconferir = "rgba(33,78,0,0.5)";
          }

          if (corconferir) {
            e.cellElement.style.cssText = `color: white; background-color: ${corconferir}`;
          } else {
            e.cellElement.style.cssText = "";
          }
        }

        if (e.column.dataField === "qtddisp") {
          const valaconferir = e.data.qtddisp;
          const qtd = e.data.qtd;
          let coraconferir = "";

          if (valaconferir > 0.0 && valaconferir === qtd) {
            coraconferir = "";
          } else if (valaconferir > 0.0) {
            coraconferir = "rgba(191,147,9,0.5)";
          } else if (valaconferir === 0.0) {
            coraconferir = "rgba(33,78,0,0.5)";
          }

          if (coraconferir) {
            e.cellElement.style.cssText = `color: white; background-color: ${coraconferir}`;
          } else {
            e.cellElement.style.cssText = "";
          }
        }

        if (e.column.dataField === "qtdlida") {
          const valconferir = e.data.qtdlida;
          const qtd = e.data.qtd;
          let corconferir = "";

          if (valconferir === 0.0) {
            corconferir = "";
          } else if (valconferir > 0.0 && valconferir < qtd) {
            corconferir = "rgba(191,147,9,0.5)";
          } else if (valconferir === qtd) {
            corconferir = "rgba(33,78,0,0.5)";
          }

          if (corconferir) {
            e.cellElement.style.cssText = `color: white; background-color: ${corconferir}`;
          } else {
            e.cellElement.style.cssText = "";
          }
        }

        if (e.column.dataField === "status") {
          const valstatus = e.data.status;
          let corconferir = "";

          if (valstatus === "ES") {
            corconferir = "rgba(6,119,221,0.85)";
          } else if (valstatus === "AB") {
            corconferir = "rgba(191,147,9,0.5)";
          } else if (valstatus === "SE") {
            corconferir = "rgba(33,78,0,0.5)";
          } else if (valstatus === "CP") {
            corconferir = "rgb(51,122,183)";
          } else if (valstatus === "CA") {
            corconferir = "rgba(254,32, 32, 0.5)";
          }

          if (corconferir) {
            e.cellElement.style.cssText = `color: white; background-color: ${corconferir}`;
          } else {
            e.cellElement.style.cssText = "";
          }
        }
      }
    },

    onExporting(e) {
      console.log("onExporting");
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("plan1");
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            this.title + ".xlsx"
          );
        });
      });
      e.cancel = true;
    },

    refeFormTable() {
      console.log("refeFormTable");
      if (this.dataGrid) {
        this.dataGrid.state(null);
      }
    },

    nomeStatus(e) {
      // console.log(`status: ${e}`)

      switch (e) {
        case "FA":
          return "Faturado (FA)";
        case "EL":
          return "Em Elaboração (EL)";
        case "CP":
          return "Conf. Parcial (CP)";
        case "CO":
          return "Confirmado (CO)";
        case "SC":
          return "Solicitação de cancelamento (SC)";
        case "CA":
          return "Cancelado (CA)";
        case "EX":
          return "Exportado (EX)";
      }

      return "Não Definido";
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value);
        return value_n.toLocaleString("pt-BR", {
          style: "decimal",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      }
      return "0,00";
    },

    formatDecimalDuas(value) {
      const value_n = parseFloat(value);
      if (isNaN(value_n)) {
        return "0,00";
      }
      return value_n.toLocaleString("pt-BR", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },

    parseDecimalPtBr(value) {
      if (value === null || value === undefined) {
        return 0;
      }
      let texto = String(value).trim();
      if (!texto) {
        return 0;
      }
      // "1.695,60" -> ponto é separador de milhar; "1695.60" -> ponto é decimal
      texto = texto.includes(",")
        ? texto.replace(/\./g, "").replace(",", ".")
        : texto;
      const value_n = parseFloat(texto);
      return isNaN(value_n) ? 0 : Math.round(value_n * 100) / 100;
    },

    formatBigDecimal(value) {
       //console.log('formatBigDecimal')
       //console.log(value)
       //console.log(typeof value)

      if (value) {
        let value_n = parseFloat(value);
        return value_n.toLocaleString("pt-BR", {
          style: "decimal",
          minimumFractionDigits: 4,
        });
      } else {
        //console.log("bigfloat convertion error");
        return "0,00";
      }
    },

    formatDecimalQuatro(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value);
        return value_n.toLocaleString("pt-BR", {
          style: "decimal",
          minimumFractionDigits: 4,
        });
      }
      return "0,00";
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value);
        return value_n.toLocaleString("pt-BR", {
          style: "decimal",
          minimumFractionDigits: 0,
        });
      }
      return 0.0;
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss";
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime;
    },

    formatDate(value) {
      // console.log('value formatDate')
      var dateString = value;
      var momentObj = moment(dateString, "YYYY-MM-DD");
      // console.log(momentObj)
      const formatSaida = "DD/MM/YYYY";
      let dateTime = momentObj.format(formatSaida);
      // console.log(dateTime)
      return dateTime;
    },

    formatBoolean(e){
      //console.log('formatBoolean: ')
      //console.log(e.value)

      if(e.value === false){
        return "Não"
      } else {
        return "Sim"
      }
    }
  },
};
</script>

<template>
  <Layout>
    <PageHeader
      :title="title"
      :items="items"
      :status="nomeStatus(orctoData.status)"
    />

    <Loader v-if="updating" style="min-height: 400px"> </Loader>

    <div class="row" v-if="!updating">
      <div class="col-lg-12" v-if="!isMobile">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-start flex-wrap gap-2">
              <b-button
                variant="outline-primary"
                class="mx-2"
                @click="salvarOrcamento"
                :disabled="orctoData.status === 'CO'"
              >
                <i class="bx bx-save font-size-16 align-middle me-2"></i>
                Salvar Alterações
              </b-button>

              <b-button
                variant="outline-info"
                class="mx-2"
                v-if="idData > 0 && orctoData.status !== 'SC'"
                @click="imprimirOrcamento"
              >
                <i class="bx bx-printer font-size-16 align-middle me-2"></i>
                Imprimir
              </b-button>

              <b-button
                variant="outline-info"
                class="mx-2"
                v-if="idData > 0 && orctoData.status !== 'SC'"
                @click="copiarOrcamento"
              >
                <i class="bx bx-copy font-size-16 align-middle me-2"></i>
                Copiar
              </b-button>

              <b-button variant="outline-primary" class="mx-2" v-if="idData > 0" @click="redirecionarOrcamentoWMS">
                <i class="bx bxs-directions font-size-16 align-middle me-2"></i>
                Redirecionar
              </b-button>

              <!--              <b-button variant="outline-info" class="mx-2" v-if="idData > 0" @click="copiarOrcamento02">-->
              <!--                <i class="bx bx-copy font-size-16 align-middle me-2" ></i>-->
              <!--                Copiar - 02-->
              <!--              </b-button>-->

              <b-button
                variant="outline-success"
                class="mx-2"
                @click="reverterCancelarOrcto"
                v-if="orctoData.status === 'SC'"
              >
                <i class="bx bx-arrow-back font-size-16 align-middle me-2"></i>
                Não cancelar orçamento
              </b-button>

              <b-button
                variant="outline-danger"
                class="mx-2"
                @click="cancelarOrcamento"
                :disabled="orctoData.id === 0 || orctoData.status === 'CO' || orctoData.status === 'CP' && orctoData.status === 'CA'"
              >
                <i class="bx bxs-trash font-size-16 align-middle me-2"></i>
                Cancelar orçamento
              </b-button>

              <b-button
                variant="outline-warning"
                class="mx-2"
                @click="novoProduto"
                :disabled="orctoData.id === 0 || orctoData.status === 'CO' || !podeAdicionarItem"
                :title="podeAdicionarItem ? 'Adicionar item ao orçamento' : tabPrecoResolvida.motivo"
              >
                <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
                Novo Produto
              </b-button>

              <!--<b-button variant="outline-primary" class="mx-2" @click="auditoria" :disabled="orctoData.id === 0" v-if="orctoData.status !== 'SC'">
                <i class="bx bx-search-alt font-size-16 align-middle me-2"></i>
                Auditoria
              </b-button>-->

              <b-button
                variant="outline-info"
                class="mx-2"
                @click="cotarFrete"
                :disabled="orctoData.id === 0 || orctoData.status === 'EL'"
              >
                <i class="bx bxs-truck font-size-16 align-middle me-2"></i>
                Cotar Frete
              </b-button>

              <b-button
                variant="outline-success"
                class="mx-2"
                @click="novoPagamento"
                :disabled="orctoData.id === 0 || orctoData.status !== 'EL'"
              >
                <i
                  class="bx bxs-dollar-circle font-size-16 align-middle me-2"
                ></i>
                Novo Pagamento
              </b-button>

              <b-button
                variant="outline-info"
                class="mx-2"
                @click="showModalAddCampanha = true"
                :disabled="orctoData.id === 0 || orctoData.status === 'CO' || orctoData.status === 'CP'"
                v-if="flagCampanhaParam"
              >
                <i class="bx bx-sticker font-size-16 align-middle me-2"></i>
                Adicionar Campanha
              </b-button>

              <b-button variant="outline-danger" class="mx-2" @click="fecharOrcamento" v-if="orctoData.id > 0 && (orctoData.status === 'CP' || orctoData.status === 'EL')">
                <i class="bx bx-x font-size-16 align-middle me-2"></i>
                Fechar Orçamento
              </b-button>

              <b-button variant="outline-info" class="mx-2" @click="showModalIndicaPedido = true"
                :disabled="orctoData.status !== 'EL'"
                v-if="flagAgregacaoPedido"
              >
                <i class="bx bx-analyse font-size-16 align-middle me-2"></i>
                Agregar a pedido
              </b-button>

              <!--                    <span-->
              <!--                        class="avatar-title rounded-circle bg-soft bg-warning text-warning font-size-22"-->
              <!--                    >-->
              <!--                      <i class="mdi mdi-cash"></i>-->
              <!--                    </span>-->
              <div class="flex-grow-1 align-self-center">
                <div class="text-muted">
                  <!--                  <h5>R$ 4.855.745,00 (recebíveis hoje)</h5>-->
                  <!--                  <p class="mb-1">R$ 978.444,00 a pagar hoje</p>-->
                  <!--                  <p class="mb-0">Id no: #SK0234</p>-->
                </div>
              </div>

              <button
                class="btn btn-success"
                @click="confirmarOrcamento"
                :disabled="orctoData.id === 0 || orctoData.status === 'CO' || orctoData.status === 'CP' || disableButton"
                v-if="
                  orctoItensData &&
                  orctoItensData.length > 0"
              >
                <i class="mdi mdi-rocket-launch me-1 text-end"></i> SUCESSO!
              </button>
            </div>
          </div>
        </div>
      </div>

      <b-alert
        v-for="(erro, i) in errosValid"
        :key="`alerta-${i}`"
        show
        dismissible
        variant="danger"
      >
        <i class="mdi mdi-alert me-2"></i>Pendente validação de campo:
        {{ erro.titulo }} -- {{ erro.mensagem[0] }} -- favor ajustar e tentar
        novamente.
      </b-alert>

      <div class="col-xl-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex">
              <div class="me-3">
                <!--                <img-->
                <!--                    src="@/assets/images/users/avatar-2.jpg"-->
                <!--                    alt=""-->
                <!--                    class="avatar-sm rounded-circle img-thumbnail"-->
                <!--                />-->
                <span
                  v-if="clienteData"
                  class="avatar-title rounded-circle"
                  style="max-height: 55px; min-width: 55px"
                  >{{ clienteData.codigo }}
                </span>
              </div>
              <div class="flex-grow-1">
                <div class="d-flex flex-wrap gap-2">
                  <div class="flex-grow-1">
                    <h6 class="mb-1 text-muted">Cliente:</h6>
                    <div class="text-muted">
                      <a
                        href="javascript: void(0);"
                        v-if="!clienteData"
                        @click="selecionaCli"
                      >
                        <h5 class="mb-1 text-info">Selecionar cliente ...</h5>
                      </a>

                      <a
                        href="javascript: void(0);"
                        v-if="clienteData"
                        v-b-tooltip.hover
                        placement="top"
                        title="Alterar cliente"
                        @click="selecionaCli"
                      >
                        <h5 class="mb-1">
                          {{ clienteData.codigo }} - {{ clienteData.nome }}
                        </h5>
                        <p class="mb-0">
                          {{ clienteData.cidade }}, {{ clienteData.estado }}
                        </p>
                      </a>
                    </div>
                  </div>

                  <router-link
                    :to="`/cliente/editar/${clienteData.id}`"
                    class="ms-2"
                    v-if="clienteData"
                    target="_blank"
                  >
                    Detalhes Cliente
                    <i class="mdi mdi-arrow-right ms-1"></i>
                  </router-link>
                </div>

                <hr />

                <div>
                  <h6 class="mb-1 text-muted">Representante:</h6>
                  <div class="text-muted">
                    <a
                      href="javascript: void(0);"
                      v-if="!represData"
                      @click="selecionaRepres"
                    >
                      <h5 class="mb-1 text-info">
                        Selecionar representante ...
                      </h5>
                    </a>

                    <a
                      href="javascript: void(0);"
                      v-if="represData"
                      v-b-tooltip.hover
                      placement="top"
                      title="Alterar Representante"
                      @click="selecionaRepres"
                    >
                      <h5 class="mb-1">
                        {{ represData.codigo }} - {{ represData.descricao }}
                      </h5>
                      <p class="mb-0">
                        {{ represData.cidade }}, {{ represData.estado }}
                      </p>
                    </a>
                  </div>
                </div>

                <hr />
                <div class="row">
                  <h4>Totais</h4>
                  <div class="col-4">
                    <div>
                      <p class="text-muted text-truncate mb-2">Valor total</p>
                      <h6 class="mb-0">
                        R$
                        {{
                          orctoData.valorliq ??
                          formatDecimal(orctoData.valorliq)
                        }}
                      </h6>
                    </div>
                  </div>

                  <div class="col-4">
                    <div>
                      <p class="text-muted text-truncate mb-2">Peso total</p>
                      <h6 class="mb-0">
                        {{
                          orctoData.pesobrt ?? formatDecimal(orctoData.pesobrt)
                        }}
                        kg
                      </h6>
                    </div>
                  </div>

                  <div class="col-4">
                    <div>
                      <p class="text-muted text-truncate mb-2">Cubagem</p>
                      <h6 class="mb-0">
                        {{
                          orctoData.cubtot ?? formatDecimal(orctoData.cubtot)
                        }}
                        m³
                      </h6>
                    </div>
                  </div>
                </div>
                <br>

                <!--Campanha orcamento-->
                <div class="row" v-if="flagCampanhaParam">
                  <hr>
                  <div class="d-flex">
                    <h4>Campanha Selecionada</h4>
                    <i v-if="this.orctoData.status === 'EL' || this.orctoData.status === 'CP'" style="cursor:pointer" class="bx bx-x font-size-20 align-middle me-2 text-danger mt-1"
                    @click="removerCampanha"
                    title="Remover Campanha"></i>
                  </div>

                  <div class="col-4">
                    <div>
                      <p class="text-muted text-truncate mb-2">Código</p>
                      <h6 class="mb-0">{{ campanhaSelected.codigo }}</h6>
                    </div>
                  </div>

                  <div class="col-8">
                    <div>
                      <p class="text-muted mb-2">Descrição</p>
                      <h6 class="mb-0">{{ campanhaSelected.descricao }}</h6>
                    </div>
                  </div>
                </div>

                <!--pedido agregado-->
                <div class="row" v-if="orctoData.agregped_id && orctoData.agregped_id > 0">
                  <hr>
                  <div class="d-flex">
                    <h4>Pedido Associado</h4>
                    <i v-if="this.orctoData.status === 'EL' || this.orctoData.status === 'CP'" variant="outline-danger" style="cursor:pointer" class="bx bx-x font-size-20 align-middle me-2 text-danger mt-1"
                      @click="removerPedAssoc"
                      title="Remover pedido associado"></i>
                  </div>

                  <div class="col-4">
                    <div>
                      <p class="text-muted text-truncate mb-2">ID Pedido a agregar</p>
                      <h6 class="mb-0">{{ orctoData.agregped_id ?? "-" }}</h6>
                    </div>
                  </div>
                  <br>
                </div>



              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <!--natureza da operação-->
            <div class="row">
              <div class="d-flex" v-if="orctoData.tipo">
                <h4>Natureza da operação</h4>
                <i style="cursor:pointer" class="bx bx-x font-size-20 align-middle me-2 text-danger mt-1"
                @click="removerNatureza"
                title="Remover Natureza da operação"
                v-if="naturezaData.id || orctoData.tipo"></i>
              </div>

              <h6 class="text-muted" style="cursor:pointer" v-if="orctoData.tipo !== null || orctoData.tipo !== ''">
                <i class="bx bx-pencil font-size-20 align-middle mx-2"
                @click="editarNaturezas"></i>
                Acessar Naturezas
              </h6>

              <div class="mt-1">
                <div class="mt-2 d-flex" v-if="naturezaData.cfopicms">
                    <p class="text-muted ms-1">CFOP: </p>
                    <span class="mx-1"></span>
                    <h6 class="mt-1">{{ naturezaData.cfopicms }}</h6>
                </div>

                <div class="d-flex" v-if="naturezaData.descricao">
                    <p class="text-muted">Descrição: </p>
                    <span class="mx-1"></span>
                    <h6 class="mt-1">{{ naturezaData.descricao }}</h6>
                </div>
              </div>

              <b-button variant="outline-warning" class="mx-2" @click="showModalNatureza = true"
                :disabled="orctoData.status !== 'EL'"
              >
                <i class="bx bx-dollar font-size-16 align-middle me-2"></i>
                {{ orctoData.idData === 0 ? 'Selecionar Natureza de Operação' : 'Alterar Natureza de Operação'  }}
              </b-button>
            </div>

            <hr />
            <div class="row">
              <div class="d-flex" v-if="orctoData.tipo">
                <h4>Dados Financeiros:</h4>
                <h6 class="text-muted ms-auto"
                    style="cursor:pointer;"
                    v-if="orctoData.tipo !== null || orctoData.tipo !== ''"
                    @click="editarFinanceiro">
                  <i class="bx bx-pencil font-size-12 align-middle mx-1"/>
                  Editar Dados Financeiros
                </h6>
              </div>

              <div class="row">
                <div class="d-flex col-sm-6 mt-2">
                  <h6 class="">Cond. Pgto:
                    <span class="text-muted ms-2">{{ financeiroData?.condpgto }}</span>
                  </h6>
                </div>

                <div class="d-flex col-sm-6 mt-2">
                  <h6 class="">Forma Pgto:
                    <span class="text-muted ms-2" style="">{{ financeiroData?.formapgto}}</span>
                  </h6>
                </div>

                <div class="d-flex col-sm-6">
                  <h6 class="">Banco:
                    <span class="text-muted ms-2" style="">( {{ financeiroData?.banco}} - {{ financeiroData?.descricao}} )</span>
                  </h6>
                </div>

                <div class="d-flex col-sm-6">
                  <h6 class="">Cons. dia útel::
                    <span class="text-muted ms-2" style="">{{ financeiroData?.consutil}}</span>
                  </h6>
                </div>

                <div class="d-flex col-sm-12 mt-2">
                  <h6 class="" v-if="tabPrecoResolvida.ok">
                    Tabela de Preço:
                    <span v-if="tabPrecoResolvida.tabpreco" class="badge badge-pill badge-soft-success font-size-11 ms-2">
                      {{ tabPrecoResolvida.tabpreco }} ({{ tabPrecoResolvida.origem }})
                    </span>
                    <span v-else class="badge badge-pill badge-soft-secondary font-size-11 ms-2">
                      representante sem tabela
                    </span>
                  </h6>
                  <h6 class="text-danger" v-else>
                    <i class="bx bx-error-circle font-size-14 align-middle me-1"/>
                    {{ tabPrecoResolvida.motivo }}
                  </h6>
                </div>
              </div>
            </div>

            <hr />
            <h4>Outros dados Orçamento:</h4>
            <div class="row text-end">
              <b-dropdown
                toggle-class="text-muted font-size-16 p-0"
                variant="white"
                right
                class="ms-auto"
                menu-class="dropdown-menu-end"
              >
                <template #button-content>
                  <i class="mdi mdi-dots-horizontal"></i>
                </template>
                <b-dropdown-item href="#" @click="selecionaCli"
                  >Alterar Cliente</b-dropdown-item>

                <!--<b-dropdown-item href="#" @click="editaDataOrcamento"
                >Alterar Data do Orçamento</b-dropdown-item>-->

<!--                <b-dropdown-item href="#" @click="selecionaFormaPgto"
                  >Alterar Forma de Pagamento</b-dropdown-item
                >-->
                <b-dropdown-divider></b-dropdown-divider>
                <!--<b-dropdown-item href="#" @click="selecionaPedTipo"
                  >Alterar Tipo de Operação</b-dropdown-item
                >-->
                <b-dropdown-item href="#" @click="selecionaRepres"
                  >Alterar Representante</b-dropdown-item
                >
                <b-dropdown-item href="#" @click="selecionaTransp"
                  >Alterar Transportadora</b-dropdown-item
                >
              </b-dropdown>
            </div>

            <div>
              <div>
                <!--                <div class="d-flex mb-1 align-items-baseline">
                  <div class="d-flex">
                    <i style="cursor:pointer; font-size: 1rem;" class="bx bx-x text-danger"
                      @click="orctoData.formapgto = null"
                      title="Remover tipo pagamento"
                      v-if="orctoData.formapgto !== null || orctoData.formapgto !== ''"></i>
                    <h6 >Condição de pagamento: </h6>
                  </div>

                  <a
                    href="javascript: void(0);"
                    v-if="formaPgtoData"
                    v-b-tooltip.hover
                    placement="top"
                    title="Alterar forma de pagamento"
                    @click="selecionaFormaPgto"
                    class="mx-3"
                  >
                    <p class="text-muted">
                      {{ formaPgtoData != null ? `${formaPgtoData.descricao} (cód.: ${orctoData.formapgto})` : "Selecionar tipo pagamento" }}
                    </p>
                  </a>
                </div>-->
                <div class="d-flex mb-1 align-items-baseline">
                  <div class="d-flex">
                    <i style="cursor:pointer; font-size: 1rem;" class="bx bx-x text-danger"
                      v-if="orctoData.transp !== null || orctoData.transp !== ''"
                      @click="orctoData.transp = null"
                      title="Remover transportadora"></i>
                      <h6 >Transportadora: </h6>
                  </div>

                  <a
                    href="javascript: void(0);"
                    v-b-tooltip.hover
                    placement="top"
                    title="Alterar transportadora"
                    @click="alteraTransp"
                    class="mx-3"
                  >
                    <p class="text-muted">
                        {{ transportadora.cnpj != null ? transportadora.nome + ' - ' + transportadora.cnpj : "Sem Transportadora" }}
                      <i class="mdi mdi-truck-outline ms-1"></i>
                    </p>
                  </a>
                </div>
              </div>

              <div class="d-flex mb-1 align-items-baseline">
                <div class="d-flex">
                  <i style="cursor:pointer; font-size: 1rem;" class="bx bx-x text-danger"
                    @click="orctoData.repres = null"
                    title="Remover representante"
                    v-if="orctoData.repres !== null || orctoData.repres !== ''"></i>
                    <h6 >Representante: </h6>
                </div>
                <a
                  href="javascript: void(0);"
                  v-b-tooltip.hover
                  placement="top"
                  title="Alterar representante"
                  @click="selecionaRepres"
                  class="mx-3"
                >
                  <p class="text-muted" v-if="Array.isArray(represData) && represData.length > 0 && represData.includes(represData.descricao)">
                    {{ orctoData.repres != null ? represData.descricao : "Sem Representante" }}
                  </p>
                </a>
              </div>
            </div>

            <hr />

            <div class="d-flex flex-wrap">
              <div>
                <a
                  href="javascript: void(0);"
                  v-b-tooltip.hover
                  placement="top"
                  title="Alterar observações"
                  @click="alteraObs"
                >
                  <p class="text-warning mb-0">
                    <span>
                      {{
                        orctoData.obs != null
                          ? orctoData.obs
                          : "Observações do Pedido"
                      }}
                      <i class="mdi mdi-chat-alert ms-1"></i>
                    </span>
                  </p>
                </a>
              </div>
            </div>

            <div v-if="orctoData.obsnf" class="d-flex flex-wrap text-end">
              <div>
                <a
                  href="javascript: void(0);"
                  v-b-tooltip.hover
                  placement="top"
                  title="Alterar observações"
                  @click="alteraObs"
                >
                  <p class="text-black mb-0">
                    <span>
                      {{
                        orctoData.obsnf != null
                          ? orctoData.obsnf
                          : "Observações da Nota Fiscal"
                      }}
                      <i class="mdi mdi-chat-alert ms-1"></i>
                    </span>
                  </p>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="card" v-if="orctoData">
          <div class="card-body">
            <h4 class="card-title mb-3">Detalhamento do orçamento</h4>

            <div class="d-flex justify-content-sm-between">
              <div class="col-4">
                <div>
                  <p class="text-muted text-truncate mb-2">Data do orçamento</p>
                  <h6 class="mb-0">{{ formatDate(orctoData.dtemissao) }}</h6>
                </div>
              </div>

              <div class="col-4">
                <div>
                  <p class="text-muted text-truncate mb-2">Código</p>
                  <h6 class="mb-0">{{ orctoData.codigo }}</h6>
                </div>
              </div>
            </div>
            <hr />

            <div class="table-responsive">
              <table class="table mb-0">
                <tbody>
                  <tr>
                    <td>Usuário</td>
                    <td class="float-end">{{ orctoData.created_by }}</td>
                  </tr>

                  <tr>
                    <td>Valor Total Bruto</td>
                    <td class="float-end">
                      R$ {{ formatDecimalDuas(orctoData.valorbrt) }}
                    </td>
                  </tr>

                  <tr>
                    <td>Qtd. Total Produtos</td>
                    <td class="float-end">
                      {{ formatInteger(this.countOrctoItens) }}
                    </td>
                  </tr>



                  <tr>
                    <td>Qtd. Total Itens</td>
                    <td class="float-end">
                      {{ formatDecimal(this.qtdTotalItens) }} und.
                    </td>
                  </tr>

                  <tr>
                    <td>Valor Desconto Itens</td>
                    <td class="float-end">
                      R$ {{ formatDecimalDuas(orctoData.desconto) }}
                    </td>
                  </tr>

                  <tr>
                    <td>Valor Total Produtos</td>
                    <td class="float-end">
                      R$ {{ formatDecimalDuas(orctoData.valorprd) }}
                    </td>
                  </tr>

                  <tr>
                    <td>Desconto Pedido</td>
                    <!--                  <td class="float-end">R$ {{ formatDecimal(orctoData.desconto) }}</td>-->

                    <td class="d-flex float-end">
                      <div class="d-flex justify-content-end">
                        <i class="font-size-16 bx-fade-left"></i>
                      </div>

                      <!-- LINK DE MODAL PARA ALTERAÇÃO DO PERCENTUAL DE DESCONTO DESABILITADO -->
                      <!-- <a href="javascript: void(0);"
                       v-b-tooltip.hover
                       placement="top"
                       title="Alterar porcentagem de desconto"> -->
                      <p class="mb-0">
                        <span>
                          {{
                            orctoData.percdesc != null
                              ? formatDecimal(orctoData.percdesc)
                              : "0,00"
                          }}
                          %
                        </span>
                      </p>
                      <!-- </a> -->
                    </td>
                  </tr>

                  <tr>
                    <td>Margem Bruta (média)</td>
                    <td class="float-end">
                      {{ formatDecimal(orctoData.margem) }} %
                    </td>
                  </tr>

                  <tr>
                    <td>Valor Frete</td>
                    <td class="float-end d-flex">
                      <div class="d-flex justify-content-end">
                        <i class="font-size-16 bx-fade-left"></i>
                      </div>

                      <div v-b-tooltip.hover placement="top">
                        <p class="mb-0">
                          <span>
                            R$
                            {{
                              orctoData.valorfrt != null
                                ? formatDecimalDuas(orctoData.valorfrt)
                                : "0,00"
                            }}
                            <!--@click="alteraFrete" - Função desabilitada porque Evandro pediu para deixar o valor da cotação realizada! - Pablo>-->
                          </span>
                        </p>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <a
                        href="javascript: void(0);"
                        v-b-tooltip.hover
                        placement="top"
                        title="Editar código de carga"
                        @click="abrirModalCarga"
                      >
                        Carga ({{ orctoData.carga }})
                      </a>
                    </td>
                    <td class="float-end d-flex">
                      <div class="d-flex justify-content-end">
                        <i class="font-size-16 bx-fade-left"></i>
                      </div>

                      <div v-b-tooltip.hover placement="top">
                        <p class="mb-0">
                          <span>
                            <h6 class="mb-0">
                              {{
                                orctoData.cubcarga ??
                                formatDecimal(orctoData.cubcarga)
                              }}
                              m³
                            </h6>
                          </span>
                        </p>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <th>Valor Total Líquido</th>
                    <th class="float-end">
                      R$ {{ formatDecimalDuas(orctoData.valorliq) }}
                    </th>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="card" v-if="orctoData">
          <div class="card-body">
            <h4 class="card-title mb-3">Pagamentos</h4>

          </div>

          <div class="card-body">
            <h4 class="card-title mb-3">Pagamentos</h4>

            <div class="table-responsive">
              <table class="table mb-0">
                <tbody>
                  <tr v-for="data in orctoFinansData" :key="data.id">
                    <td>
                      <a
                        href="javascript: void(0);"
                        v-b-tooltip.hover
                        placement="top"
                        title="Editar pagamento"
                        @click="alteraPagamento(data)"
                      >
                        {{ data.formapgtodesc }} | {{ data.obs }}
                      </a>
                    </td>

                    <td class="float-end">
                      <a
                        href="javascript: void(0);"
                        v-b-tooltip.hover
                        placement="top"
                        title="Editar pagamento"
                        @click="alteraPagamento(data)"
                      >
                        {{ formatDecimal(data.valor) }}
                      </a>
                    </td>
                  </tr>

                  <tr>
                    <td>Valor Total Pagamentos</td>
                    <td class="float-end">
                      R$ {{ formatDecimal(valorTotalFinanc) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- end table-responsive -->
          </div>
        </div>
      </div>

      <div class="col-xl-8">
        <div class="card">
          <div class="card-body">
            <div class="m-tabs" v-if="isMobile">
              <button
                v-for="tab in tabs"
                :key="tab.name"
                type="button"
                class="m-tabs__item"
                :class="{ active: currentTab === tab.name }"
                @click="selectTab(tab.name)"
              >
                {{ tab.label }}
              </button>
            </div>

            <ul class="nav nav-tabs" v-else>
              <li class="nav-item" v-for="tab in tabs" :key="tab.name">
                <a
                  class="nav-link"
                  :class="{ active: currentTab === tab.name }"
                  href="javascript:void(0);"
                  @click="selectTab(tab.name)"
                >
                  {{ tab.label }}
                </a>
              </li>
            </ul>

            <!-- Painéis -->
            <div v-if="currentTab === 'ItensOrcamento'">
              <div class="row">
                <div class="card-body">
                  <!-- ====== Desconto por volume (descontoproduto) ====== -->
                  <div
                    v-if="descontoVolume && descontoVolume.regras && descontoVolume.regras.length"
                    class="alert mb-3"
                    :class="descontoVolume.qtdaplicadas > 0 ? 'alert-success' : 'alert-info'"
                  >
                    <div class="form-check form-switch mb-2">
                      <input
                        id="descVolAplica"
                        :checked="!!descontoVolume.aplica"
                        class="form-check-input"
                        type="checkbox"
                        :disabled="!descontoVolume.editavel || salvandoDescVolAplica"
                        @change="alteraDescVolAplica($event.target.checked)"
                      />
                      <label class="form-check-label fw-semibold" for="descVolAplica">
                        Aplicar desconto por volume neste orçamento
                      </label>
                    </div>
                    <div
                      class="d-flex align-items-center justify-content-between flex-wrap gap-2"
                      role="button"
                      @click="toggleDetalheDescVol"
                    >
                      <div>
                        <i class="mdi mdi-sale font-size-16 align-middle me-1"></i>
                        <template v-if="descontoVolume.qtdaplicadas > 0">
                          <strong>
                            {{ descontoVolume.qtdaplicadas }}
                            {{ descontoVolume.qtdaplicadas === 1 ? "regra de desconto por volume aplicada" : "regras de desconto por volume aplicadas" }}
                          </strong>
                          &mdash; economia de R$ {{ formatDecimalDuas(descontoVolume.totaleconomia) }} neste orçamento.
                        </template>
                        <template v-else-if="!descontoVolume.aplica && descontoVolume.regras.some((r) => r.atingida)">
                          <strong>Desconto por volume atingido, mas não aplicado.</strong>
                        </template>
                        <template v-else>
                          <strong>Nenhuma regra de desconto por volume atingida.</strong>
                        </template>
                        <span v-if="descVolProxima">
                          Faltam {{ formatDecimal(descVolProxima.falta) }} un. para
                          {{ formatDecimal(descVolProxima.desconto) }}% em
                          {{ descVolProxima.alvolabel }}{{ descVolProxima.alvodesc ? ` - ${descVolProxima.alvodesc}` : "" }}.
                        </span>
                      </div>
                      <span class="text-nowrap small fw-semibold">
                        {{ showDetalheDescVol ? "Ocultar detalhes" : "Ver detalhes" }}
                        <i :class="showDetalheDescVol ? 'mdi mdi-chevron-up' : 'mdi mdi-chevron-down'"></i>
                      </span>
                    </div>

                    <div v-if="showDetalheDescVol" class="mt-3">
                      <div
                        v-for="regra in descontoVolume.regras"
                        :key="regra.chave"
                        class="border rounded bg-white text-body p-2 mb-2"
                      >
                        <div class="d-flex justify-content-between flex-wrap gap-2">
                          <div>
                            <strong>{{ regra.descricao || regra.codigo }}</strong>
                            <span class="text-muted small ms-1">({{ regra.codigo }})</span>
                            <div class="small">
                              <strong>{{ regra.alvolabel }}</strong>{{ regra.alvodesc ? ` - ${regra.alvodesc}` : "" }}
                              (volume somado):
                              a partir de {{ formatDecimal(regra.quantidade) }} un.,
                              {{ formatDecimal(regra.desconto) }}% de desconto.
                              Quantidade no orçamento: <strong>{{ formatDecimal(regra.qtdatual) }}</strong>.
                            </div>
                          </div>
                          <div>
                            <span v-if="regra.aplicada" class="badge bg-success font-size-12">Aplicada</span>
                            <span v-else-if="regra.atingida && !descontoVolume.aplica" class="badge bg-secondary font-size-12">Atingida, não aplicada</span>
                            <span v-else-if="regra.atingida" class="badge bg-secondary font-size-12">Atingida, não acumula</span>
                            <span v-else class="badge bg-warning font-size-12">Faltam {{ formatDecimal(regra.falta) }} un.</span>
                          </div>
                        </div>

                        <div v-if="regra.itens.length" class="table-responsive mt-2">
                          <table class="table table-sm align-middle mb-0">
                            <thead class="table-light">
                              <tr>
                                <th>Produto</th>
                                <th class="text-end">Qtd</th>
                                <th class="text-end">Unit. sem desconto</th>
                                <th class="text-end">Unit. com desconto</th>
                                <th class="text-end">Economia</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="item in regra.itens" :key="item.id">
                                <td>{{ item.produto }} - {{ item.descprod }}</td>
                                <td class="text-end">{{ formatDecimal(item.qtd) }}</td>
                                <td class="text-end">R$ {{ formatDecimalDuas(item.vlrunitbase) }}</td>
                                <td class="text-end">R$ {{ formatDecimalDuas(item.vlrunitliq) }}</td>
                                <td class="text-end">R$ {{ formatDecimalDuas(item.economia) }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        <div v-if="regra.preteridos.length" class="small text-muted mt-1">
                          Não acumula com o desconto de produto:
                          <span v-for="(prt, i) in regra.preteridos" :key="prt.produto">
                            {{ i > 0 ? ", " : "" }}{{ prt.produto }} ({{ formatDecimal(prt.perc) }}% pela regra {{ prt.regra }})
                          </span>.
                        </div>
                      </div>

                      <div class="small">
                        O desconto do produto tem prioridade sobre o do grupo e os dois não acumulam.
                        Ao alterar ou excluir itens o preço é recalculado pela nova quantidade.
                        <span v-if="!descontoVolume.editavel">
                          Orçamento fora de elaboração: os preços não são mais recalculados.
                        </span>
                      </div>
                    </div>
                  </div>

                  <!--                  <div class="table-responsive">
                    <table class="table align-middle mb-0 table-nowrap">
                      <thead class="table-light">
                      <tr>
                        <th>Produtos ({{ orctoItensData !== null ? orctoItensData.length : 0 }})</th>
                        <th>Descrição</th>
                        <th class="text-center">Valor Unit.(R$)</th>
                        <th class="text-center">Peso total</th>
                        <th class="text-center">Cubagem total</th>
                        <th class="text-center">Quantidade</th>
                        <th class="text-center">A conferir</th> &lt;!&ndash; saldo restante de wmsos &ndash;&gt;
                        <th class="text-center">Margem(%)</th>
                        <th class="text-center">Desconto unitário(R$)</th>
                        <th class="text-center">Total Líquido(R$)</th>
                        <th class="text-center">Ações</th>
                      </tr>
                      </thead>
                      <tbody>

                      <tr v-for="data in orctoItensData" :key="data.id">

                        <td>
                          <h5 class="text-muted mb-0">{{ data.produto }} </h5>

                          <img v-if="data.img1" :src="data.img1" alt="product-img" title="product-img" class="avatar-md" />

                          <div class="mb-3" v-else>
                            <i class="bx bxs-camera-off h2 text-warning" title="Produto sem foto"></i>
                          </div>

                        </td>

                        <td>
                          <h5 class="font-size-14 text-truncate">
                            <a href="javascript: void(0);" class="text-body fw-bold text-wrap"
                               @click="editarProduto(data.id)">
                              {{ data.descprod }}
                            </a>
                          </h5>
                          <p class="mb-0">
                            &lt;!&ndash;                      Saldo:&ndash;&gt;
                            &lt;!&ndash;                      <span class="fw-medium"> {{ formatInteger(data.id)  }} </span>&ndash;&gt;
                          </p>
                        </td>

                        <td class="text-end">{{ formatDecimal(data.vlrunitbrt) }}</td>
                        <td class="text-center">{{ formatDecimal(data.pesobrttot) }}Kg</td>
                        <td class="text-center">{{ data.cubtot }}m³</td>
                        <td class="text-center">{{ formatDecimal(data.qtd) }}</td>
                        <td class="center">
                          <i class="bx bx-package"></i>
                          <span :class="data.aconferirqtd > 1 ? 'badge-soft-warning' :
                                      data.aconferirqtd == 0 ? 'badge-soft-success' :
                                      'badge-soft-danger'
                          ">
                          {{ formatDecimal(data.aconferirqtd) }}
                        </span>
                        </td>
                        <td class="text-center">{{ formatDecimal(data.margem) }}</td>

                        <td class="text-end">
                      <span class="badge badge-pill badge-soft-success font-size-11" v-if="data.desconto !== 0.00"
                            :class="data.desconto < 0.00 ? 'badge-soft-success' :
                          data.desconto > 0 ? 'badge-soft-danger' : ''">
                        {{ formatDecimal(data.desconto) }}
                      </span>
                          <span v-else>
                        0.00
                      </span>
                        </td>

                        <td class="text-end">{{ formatDecimal(data.vlrtotalliq) }}</td>

                        <td class="text-end">

                          <a href="javascript:void(0);" class="action-icon text-success mx-2"
                             @click="detalhesProduto(data.produto_id)">
                            <i class="mdi mdi-eye font-size-18"></i>
                          </a>

                          <a href="javascript:void(0);" v-if="orctoData.status === 'EL'"
                             class="action-icon text-warning mx-2" @click="editarProduto(data.id)">
                            <i class="mdi mdi-pencil-outline font-size-18"></i>
                          </a>

                          <a href="javascript:void(0);" v-if="orctoData.status === 'EL'"
                             class="action-icon text-danger mx-2" @click="deletarOrctoItem(data.id)">
                            <i class="mdi mdi-trash-can font-size-18"></i>
                          </a>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>-->
                  <div v-if="!isMobile">
                    <DxToolbar>
                      <DxItem location="before" widget="dxButton">
                        <DxButton
                          icon="refresh"
                          hint="Redefinir formatação de tabela para padrão"
                          :on-click="refeFormTable"
                        />
                      </DxItem>

                      <DxItem location="before" widget="dxButton">
                        <DxButton
                            icon="clear"
                            hint="Desconsiderar validação de item no fluxo de saldo"
                            text="Desconsiderar validação de item"
                            :on-click="desconsiderarSaldoItens"
                        />
                      </DxItem>

                      <DxItem location="before" widget="dxButton">
                        <DxButton
                            icon="revert"
                            hint="Reconsiderar validação de item no fluxo de saldo"
                            text="Reconsiderar validação de item"
                            :on-click="reconsiderarSaldoItens"
                        />
                      </DxItem>
                    </DxToolbar>
                  </div>

                  <Loader v-if="updating" style="min-height: 300px"> </Loader>

                  <!-- ====== Itens do orçamento: cards no mobile ====== -->
                  <div v-if="isMobile && !updating">
                    <div class="d-flex align-items-center flex-wrap gap-2 mb-2">
                      <span
                        class="badge bg-primary font-size-12"
                        v-if="mobileItensSelecionados.length > 0"
                      >
                        {{ mobileItensSelecionados.length }} selecionado(s)
                      </span>

                      <a
                        href="javascript: void(0);"
                        class="font-size-12"
                        v-if="mobileItensSelecionados.length > 0"
                        @click="limparSelecaoItens"
                      >
                        limpar
                      </a>

                      <b-button
                        size="sm"
                        variant="outline-secondary"
                        class="ms-auto"
                        @click="desconsiderarSaldoItens"
                      >
                        <i class="bx bx-x-circle align-middle me-1"></i>
                        Desconsiderar saldo
                      </b-button>

                      <b-button
                        size="sm"
                        variant="outline-secondary"
                        @click="reconsiderarSaldoItens"
                      >
                        <i class="bx bx-revision align-middle me-1"></i>
                        Reconsiderar
                      </b-button>
                    </div>

                    <div class="m-list">
                      <div
                        v-for="item in orctoItensData"
                        :key="item.id"
                        class="m-card"
                        :class="{ 'is-selected': itemSelecionado(item.id) }"
                      >
                        <div class="m-card__head">
                          <label class="m-card__check mb-0">
                            <input
                              type="checkbox"
                              class="form-check-input mt-0"
                              :checked="itemSelecionado(item.id)"
                              @change="toggleItemSelecionado(item.id)"
                            />
                          </label>

                          <h5 class="m-card__id">
                            {{ item.sequenc }} &middot; {{ item.produto }}
                          </h5>

                          <span
                            class="badge badge-pill badge-soft-warning font-size-11 m-card__head-spacer"
                            v-if="item.desconsidsaldo"
                          >
                            Saldo desconsiderado
                          </span>
                        </div>

                        <p class="m-card__title">{{ item.descprod }}</p>
                        <p class="m-card__subtitle" v-if="item.lote">
                          Lote: {{ item.lote }}
                        </p>

                        <div class="m-card__grid m-card__grid--3">
                          <div class="m-field">
                            <span class="m-field__label">Qtd.</span>
                            <span class="m-field__value">
                              {{ formatDecimal(item.qtd) }} {{ item.und }}
                            </span>
                          </div>
                          <div class="m-field">
                            <span class="m-field__label">Vlr. unit.</span>
                            <span class="m-field__value">
                              {{ formatMoeda(item.vlrunitbrt) }}
                            </span>
                          </div>
                          <div class="m-field">
                            <span class="m-field__label">Desconto</span>
                            <span class="m-field__value">
                              {{ formatMoeda(item.desconto) }}
                            </span>
                          </div>

                          <div class="m-field">
                            <span class="m-field__label">Peso</span>
                            <span class="m-field__value">
                              {{ formatDecimal(item.pesobrttot) }} kg
                            </span>
                          </div>
                          <div class="m-field">
                            <span class="m-field__label">Cubagem</span>
                            <span class="m-field__value">
                              {{ formatBigDecimal(item.cubtot) }} m³
                            </span>
                          </div>
                          <div class="m-field">
                            <span class="m-field__label">Margem</span>
                            <span class="m-field__value">
                              {{ formatDecimal(item.margem) }} %
                            </span>
                          </div>

                          <div class="m-field">
                            <span class="m-field__label">Conferido</span>
                            <span class="m-field__value">
                              {{ formatDecimal(item.conferidoqtd) }}
                            </span>
                          </div>
                          <div class="m-field">
                            <span class="m-field__label">Saldo</span>
                            <span class="m-field__value">
                              {{ formatDecimal(item.aconferirqtd) }}
                            </span>
                          </div>
                        </div>

                        <div class="m-card__foot">
                          <span class="m-card__total">
                            {{ formatMoeda(item.vlrtotalliq) }}
                          </span>

                          <span class="m-card__actions">
                            <b-button
                              variant="outline-success"
                              size="sm"
                              title="Detalhes do produto"
                              @click="detalhesProduto(item.produto_id)"
                            >
                              <i class="mdi mdi-eye font-size-16"></i>
                            </b-button>

                            <b-button
                              variant="outline-warning"
                              size="sm"
                              title="Editar item"
                              v-if="podeEditarItens"
                              @click="editarProduto(item.id)"
                            >
                              <i class="mdi mdi-pencil-outline font-size-16"></i>
                            </b-button>

                            <b-button
                              variant="outline-danger"
                              size="sm"
                              title="Excluir item"
                              v-if="podeEditarItens"
                              @click="deletarOrctoItem(item.id)"
                            >
                              <i class="mdi mdi-trash-can font-size-16"></i>
                            </b-button>
                          </span>
                        </div>
                      </div>

                      <div
                        class="m-empty"
                        v-if="!orctoItensData || orctoItensData.length === 0"
                      >
                        Nenhum item adicionado a este orçamento.
                      </div>
                    </div>
                  </div>

                  <div class="mt-2" v-if="!updating && !isMobile">
                    <DxDataGrid
                      ref="dataGridRefKey"
                      :data-source="orctoItensData"
                      :show-borders="true"
                      :focused-row-enabled="true"
                      :keyExpr="'id'"
                      :column-auto-width="true"
                      :show-row-lines="true"
                      :allow-column-reordering="true"
                      :allow-column-resizing="true"
                      :row-alternation-enabled="true"
                      @cell-prepared="onCellPrepared"
                      @row-dbl-click="onRowDblClick"
                      @content-ready="carregouGrid"
                      @exporting="onExporting"
                    >
                      <DxRemoteOperations
                        :filtering="true"
                        :paging="true"
                        :sorting="true"
                        :summary="true"
                        :grouping="false"
                        :group-paging="false"
                      />

                      <DxColumnChooser :enabled="true" />
                      <DxColumnFixing :enabled="true" />
                      <DxFilterRow :visible="true" />

                      <DxSelection mode="multiple" />
                      <DxExport
                        :enabled="true"
                        :allow-export-selected-data="true"
                      />
                      <DxStateStoring
                        :enabled="true"
                        type="sessionStorage"
                        storage-key="strWmsOsEntradaList"
                      />

                      <DxGroupPanel :visible="true" />
                      <DxGrouping />

                      <DxColumn
                          data-field="sequenc"
                          caption="Seq"
                          sort-order="asc"
                          data-type="text"
                          alignment="left"
                          :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                          :allowHeaderFiltering="true"
                      />

                      <DxColumn
                        data-field="produto"
                        caption="Produto"
                        data-type="text"
                        alignment="left"
                        :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="true"
                      />

                      <DxColumn
                        data-field="descprod"
                        caption="Descrição"
                        data-type="text"
                        alignment="left"
                        :filter-operations="[
                          'contains',
                          'notcontains',
                          'startswith',
                          'endswith',
                          '=',
                          '<>',
                        ]"
                        :allow-sorting="false"
                        :allowHeaderFiltering="true"
                      />

                      <DxColumn
                          :width="110"
                          data-field="qtd"
                          caption="Quantidade"
                          alignment="right"
                          :format="formatDecimal"
                          :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                          :allowHeaderFiltering="false"
                      />

                      <DxColumn
                        data-field="lote"
                        caption="Lote(s)"
                        data-type="text"
                        alignment="center"
                        :filter-operations="[
                          'contains',
                          'notcontains',
                          'startswith',
                          'endswith',
                          '=',
                          '<>',
                        ]"
                        :allow-sorting="false"
                        :allowHeaderFiltering="true"
                      />

                      <DxColumn
                          data-field="desconsidsaldo"
                          caption="Desconsiderar saldo"
                          data-type="text"
                          alignment="left"
                          :customize-text="formatBoolean"
                          :filter-operations="[
                          'contains',
                          'notcontains',
                          'startswith',
                          'endswith',
                          '=',
                          '<>',
                        ]"
                          :allow-sorting="false"
                          :allowHeaderFiltering="true"
                      />

                      <DxColumn
                          data-field="und"
                          caption="Unidade"
                          data-type="text"
                          alignment="center"
                          :filter-operations="[
                          'contains',
                          'notcontains',
                          'startswith',
                          'endswith',
                          '=',
                          '<>',
                        ]"
                          :allow-sorting="false"
                          :allowHeaderFiltering="true"
                      />

                      <DxColumn
                        :width="110"
                        data-field="vlrunitbrt"
                        caption="Valor Unit. (R$)"
                        alignment="right"
                        :format="formatDecimal"
                        :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="false"
                      />

                      <DxColumn
                        :width="110"
                        data-field="pesobrttot"
                        caption="Peso Total (Kg)"
                        alignment="right"
                        :format="formatDecimal"
                        :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="false"
                      />

                      <DxColumn
                        :width="110"
                        data-field="cubtot"
                        caption="Cubagem Total (m3)"
                        alignment="right"
                        :format="formatBigDecimal"
                        :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="false"
                      />

                      <DxColumn
                        :width="110"
                        data-field="conferidoqtd"
                        caption="Conferido"
                        alignment="right"
                        :format="formatDecimal"
                        :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="false"
                      />

                      <DxColumn
                        :width="110"
                        data-field="aconferirqtd"
                        caption="Saldo"
                        alignment="right"
                        :format="formatDecimal"
                        :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="false"
                      />

                      <DxColumn
                        :width="110"
                        data-field="margem"
                        caption="Margem (%)"
                        alignment="right"
                        :format="formatDecimal"
                        :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="false"
                      />

                      <DxColumn
                        :width="110"
                        data-field="desconto"
                        caption="Desconto Unit. (R$)"
                        alignment="right"
                        :format="formatDecimal"
                        :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="false"
                      />

                      <DxColumn
                        :width="110"
                        data-field="descvolperc"
                        caption="Desc. Volume (%)"
                        alignment="right"
                        :format="formatDecimal"
                        :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="false"
                      />

                      <DxColumn
                        :width="110"
                        data-field="vlrtotalliq"
                        caption="Total Liq. (R$)"
                        alignment="right"
                        :format="formatDecimal"
                        :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="false"
                      />

                      <DxColumn
                          data-field="ncm"
                          caption="NCM"
                          data-type="text"
                          alignment="center"
                          :filter-operations="[
                          'contains',
                          'notcontains',
                          'startswith',
                          'endswith',
                          '=',
                          '<>',
                        ]"
                          :allow-sorting="false"
                          :allowHeaderFiltering="true"
                      />

                      <DxColumn
                          data-field="codbarras"
                          caption="Código de barras"
                          data-type="text"
                          alignment="center"
                          :filter-operations="[
                          'contains',
                          'notcontains',
                          'startswith',
                          'endswith',
                          '=',
                          '<>',
                        ]"
                          :allow-sorting="false"
                          :allowHeaderFiltering="true"
                      />

                      <DxColumn
                          data-field="coddun14"
                          caption="Dun-14"
                          data-type="text"
                          :visible="true"
                      />

                      <DxPager
                        :visible="true"
                        :show-page-size-selector="true"
                        :allowed-page-sizes="[10, 30, 50, 100]"
                        :show-navigation-buttons="true"
                        :show-info="true"
                      />
                    </DxDataGrid>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="currentTab === 'SaldosConferencia'">
              <div class="row">
                <div class="card-body">
                  <template v-if="wmsositens.length > 0">
                    <div class="card">
                      <div v-if="!isMobile">
                        <DxToolbar>
                          <DxItem location="before" widget="dxButton">
                            <DxButton
                              icon="refresh"
                              hint="Redefinir formatação de tabela para padrão"
                              :on-click="refeFormTable"
                            />
                          </DxItem>
                        </DxToolbar>
                      </div>

                      <Loader v-if="updating" style="min-height: 300px">
                      </Loader>

                      <!-- ====== Saldos de conferência: cards no mobile ====== -->
                      <div class="m-list mt-2" v-if="isMobile && !updating">
                        <div
                          v-for="saldo in wmsositens"
                          :key="saldo.produto_id"
                          class="m-card"
                        >
                          <div class="m-card__head">
                            <h5 class="m-card__id">{{ saldo.produto }}</h5>
                            <span class="badge badge-soft-info font-size-11 m-card__head-spacer">
                              OS #{{ saldo.wmsos_id }}
                            </span>
                          </div>

                          <p class="m-card__title">{{ saldo.descprod }}</p>

                          <div class="m-card__grid m-card__grid--3">
                            <div class="m-field">
                              <span class="m-field__label">Total</span>
                              <span class="m-field__value">{{ formatDecimal(saldo.qtd) }}</span>
                            </div>
                            <div class="m-field">
                              <span class="m-field__label">Conferidos</span>
                              <span class="m-field__value">{{ formatDecimal(saldo.qtdlida) }}</span>
                            </div>
                            <div class="m-field">
                              <span class="m-field__label">Pendentes</span>
                              <span class="m-field__value">{{ formatDecimal(saldo.qtddisp) }}</span>
                            </div>
                          </div>

                          <div class="m-card__foot">
                            <span class="font-size-12 text-muted">
                              Unidade: {{ saldo.und ?? '-' }} &middot; {{ saldo.updated_by ?? '-' }}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div class="mt-2" v-if="!updating && !isMobile">
                        <DxDataGrid
                          ref="dataGridRefKey"
                          :data-source="wmsositens"
                          :show-borders="true"
                          :focused-row-enabled="true"
                          :keyExpr="'produto_id'"
                          :column-auto-width="true"
                          :show-row-lines="true"
                          :allow-column-reordering="true"
                          :allow-column-resizing="true"
                          :row-alternation-enabled="true"
                          @cell-prepared="onCellPrepared"
                          @row-dbl-click="onRowDblClick"
                          @content-ready="carregouGrid"
                          @exporting="onExporting"
                        >
                          <DxRemoteOperations
                            :filtering="true"
                            :paging="true"
                            :sorting="true"
                            :summary="true"
                            :grouping="false"
                            :group-paging="false"
                          />

                          <DxColumnChooser :enabled="true" />
                          <DxColumnFixing :enabled="true" />
                          <DxFilterRow :visible="true" />

                          <DxSelection mode="multiple" />
                          <DxExport
                            :enabled="true"
                            :allow-export-selected-data="true"
                          />
                          <DxStateStoring
                            :enabled="true"
                            type="sessionStorage"
                            storage-key="strWmsOsEntradaList"
                          />

                          <DxGroupPanel :visible="true" />
                          <DxGrouping />

                          <DxColumn
                            data-field="wmsos_id"
                            caption="WmsOs ID"
                            sort-order="desc"
                            data-type="number"
                            alignment="left"
                            :filter-operations="[
                              '=',
                              '<>',
                              '<',
                              '>',
                              '<=',
                              '>=',
                            ]"
                            :allowHeaderFiltering="true"
                          />

                          <DxColumn
                            data-field="produto"
                            caption="Produto"
                            sort-order="desc"
                            data-type="number"
                            alignment="center"
                            :filter-operations="[
                              '=',
                              '<>',
                              '<',
                              '>',
                              '<=',
                              '>=',
                            ]"
                            :allowHeaderFiltering="true"
                          />

                          <DxColumn
                            data-field="descprod"
                            caption="Descrição"
                            data-type="text"
                            alignment="left"
                            :filter-operations="[
                              'contains',
                              'notcontains',
                              'startswith',
                              'endswith',
                              '=',
                              '<>',
                            ]"
                            :allow-sorting="false"
                            :allowHeaderFiltering="true"
                          />

                          <DxColumn
                            :width="110"
                            data-field="und"
                            caption="Valor Unit. (R$)"
                            alignment="right"
                            :format="formatDecimal"
                            :filter-operations="[
                              '=',
                              '<>',
                              '<',
                              '>',
                              '<=',
                              '>=',
                            ]"
                            :allowHeaderFiltering="false"
                          />

                          <DxColumn
                            :width="110"
                            data-field="qtd"
                            caption="Total Itens"
                            alignment="center"
                            :format="formatDecimal"
                            :filter-operations="[
                              '=',
                              '<>',
                              '<',
                              '>',
                              '<=',
                              '>=',
                            ]"
                            :allowHeaderFiltering="false"
                          />

                          <DxColumn
                            :width="110"
                            data-field="qtdlida"
                            caption="Conferidos"
                            alignment="right"
                            :format="formatDecimal"
                            :filter-operations="[
                              '=',
                              '<>',
                              '<',
                              '>',
                              '<=',
                              '>=',
                            ]"
                            :allowHeaderFiltering="false"
                          />

                          <DxColumn
                            :width="110"
                            data-field="qtddisp"
                            caption="Pendentes"
                            alignment="right"
                            :format="formatDecimal"
                            :filter-operations="[
                              '=',
                              '<>',
                              '<',
                              '>',
                              '<=',
                              '>=',
                            ]"
                            :allowHeaderFiltering="false"
                          />

                          <DxColumn
                            data-field="updated_by"
                            caption="User"
                            data-type="text"
                            alignment="right"
                            :filter-operations="[
                              'contains',
                              'notcontains',
                              'startswith',
                              'endswith',
                              '=',
                              '<>',
                            ]"
                            :allow-sorting="false"
                            :allowHeaderFiltering="true"
                          />

                          <DxPager
                            :visible="true"
                            :show-page-size-selector="true"
                            :allowed-page-sizes="[10, 30, 50, 100]"
                            :show-navigation-buttons="true"
                            :show-info="true"
                          />
                        </DxDataGrid>
                      </div>

                      <!--                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th>WmsOs Id</th>
                          <th>Produto ({{ wmsositens.length > 0 ? wmsositens.length : 0 }})</th>
                          <th class="text-center">Nome</th>
                          <th class="text-center">Unidade</th>
                          <th class="text-center">Total itens</th>
                          <th class="text-center">Conferidos</th>
                          <th class="text-center">Pendentes</th>
                          <th class="text-center">user</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="wmsositem in wmsositens" :key="wmsositem.produto_id">
                          <td class="text-start">{{ wmsositem.wmsos_id }}</td>
                          <td class="text-start">{{ wmsositem.produto }}</td>
                          <td class="text-end">{{ wmsositem.descprod }}</td>
                          <td class="text-end">{{ wmsositem.und }}</td>
                          <td class="text-end">{{ wmsositem.qtd }}</td>
                          <td class="text-end">{{ wmsositem.qtdlida }}</td>
                          <td class="text-end">{{ wmsositem.qtddisp }}</td>
                          <td class="text-end">{{ wmsositem.updated_by ?? '-' }}</td>
                        </tr>
                        </tbody>
                      </table>-->
                    </div>
                  </template>
                  <template v-else>
                    <b-alert variant="warning" show>
                      <h4 class="alert-heading">Tudo certo por aqui!</h4>
                      <p>
                        Nenhuma conferência atrelada à esse orçamento foi
                        realizada!
                      </p>
                    </b-alert>
                  </template>
                </div>
              </div>
            </div>
            <div v-if="currentTab === 'OSRelacionadas'">
              <div class="row">
                <div class="card-body">
                  <template v-if="wmsos.length > 0">
                    <div class="card">
                      <div v-if="!isMobile">
                        <DxToolbar>
                          <DxItem location="before" widget="dxButton">
                            <DxButton
                              icon="refresh"
                              hint="Redefinir formatação de tabela para padrão"
                              :on-click="refeFormTable"
                            />
                          </DxItem>
                        </DxToolbar>
                      </div>

                      <Loader v-if="updating" style="min-height: 300px">
                      </Loader>

                      <!-- ====== OS relacionadas: cards no mobile ====== -->
                      <div class="m-list mt-2" v-if="isMobile && !updating">
                        <div v-for="os in wmsos" :key="os.id" class="m-card">
                          <div class="m-card__head">
                            <h5 class="m-card__id">OS #{{ os.id }}</h5>
                            <span
                              class="badge badge-pill font-size-11 m-card__head-spacer"
                              :class="classeStatus(os.status)"
                            >
                              {{ os.status }}
                            </span>
                          </div>

                          <div class="m-card__grid">
                            <div class="m-field">
                              <span class="m-field__label">Criada em</span>
                              <span class="m-field__value">{{ os.created_at_formatted ?? '-' }}</span>
                            </div>
                            <div class="m-field">
                              <span class="m-field__label">Iniciada por</span>
                              <span class="m-field__value">{{ os.created_by ?? '-' }}</span>
                            </div>
                            <div class="m-field">
                              <span class="m-field__label">Atualizada em</span>
                              <span class="m-field__value">{{ os.updated_at_formatted ?? '-' }}</span>
                            </div>
                            <div class="m-field">
                              <span class="m-field__label">Atualizada por</span>
                              <span class="m-field__value">{{ os.updated_by ?? '-' }}</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="mt-2" v-if="!updating && !isMobile">
                        <DxDataGrid
                          ref="dataGridRefKey"
                          :data-source="wmsos"
                          :show-borders="true"
                          :focused-row-enabled="true"
                          :keyExpr="'id'"
                          :column-auto-width="true"
                          :show-row-lines="true"
                          :allow-column-reordering="true"
                          :allow-column-resizing="true"
                          :row-alternation-enabled="true"
                          @cell-prepared="onCellPrepared"
                          @row-dbl-click="onRowDblClick"
                          @content-ready="carregouGrid"
                          @exporting="onExporting"
                        >
                          <DxRemoteOperations
                            :filtering="true"
                            :paging="true"
                            :sorting="true"
                            :summary="true"
                            :grouping="false"
                            :group-paging="false"
                          />

                          <DxColumnChooser :enabled="true" />
                          <DxColumnFixing :enabled="true" />
                          <DxFilterRow :visible="true" />

                          <DxSelection mode="multiple" />
                          <DxExport
                            :enabled="true"
                            :allow-export-selected-data="true"
                          />
                          <DxStateStoring
                            :enabled="true"
                            type="sessionStorage"
                            storage-key="strWmsOsEntradaList"
                          />

                          <DxGroupPanel :visible="true" />
                          <DxGrouping />

                          <DxColumn
                            data-field="id"
                            caption="WmsOs ID"
                            sort-order="desc"
                            data-type="number"
                            alignment="left"
                            :filter-operations="[
                              '=',
                              '<>',
                              '<',
                              '>',
                              '<=',
                              '>=',
                            ]"
                            :allowHeaderFiltering="true"
                          />

                          <DxColumn
                            data-field="status"
                            caption="Status"
                            data-type="text"
                            alignment="center"
                            :filter-operations="[
                              'contains',
                              'notcontains',
                              'startswith',
                              'endswith',
                              '=',
                              '<>',
                            ]"
                            :allow-sorting="false"
                            :allowHeaderFiltering="true"
                          />

                          <DxColumn
                            data-field="created_at_formatted"
                            caption="Data de Criação"
                            alignment="right"
                            data-type="datetime"
                            format="dd/MM/yyyy"
                            :filter-operations="[
                              '=',
                              '<>',
                              '<',
                              '>',
                              '<=',
                              '>=',
                            ]"
                            :allowHeaderFiltering="true"
                          />

                          <DxColumn
                            data-field="created_by"
                            caption="Iniciado por"
                            data-type="text"
                            alignment="center"
                            :filter-operations="[
                              'contains',
                              'notcontains',
                              'startswith',
                              'endswith',
                              '=',
                              '<>',
                            ]"
                            :allow-sorting="false"
                            :allowHeaderFiltering="true"
                          />

                          <DxColumn
                            data-field="updated_at_formatted"
                            caption="Última Atualização"
                            alignment="right"
                            data-type="datetime"
                            format="dd/MM/yyyy"
                            :filter-operations="[
                              '=',
                              '<>',
                              '<',
                              '>',
                              '<=',
                              '>=',
                            ]"
                            :allowHeaderFiltering="true"
                          />

                          <DxColumn
                            data-field="updated_by"
                            caption="Atualizado por"
                            data-type="text"
                            alignment="left"
                            :filter-operations="[
                              'contains',
                              'notcontains',
                              'startswith',
                              'endswith',
                              '=',
                              '<>',
                            ]"
                            :allow-sorting="false"
                            :allowHeaderFiltering="true"
                          />

                          <DxPager
                            :visible="true"
                            :show-page-size-selector="true"
                            :allowed-page-sizes="[10, 30, 50, 100]"
                            :show-navigation-buttons="true"
                            :show-info="true"
                          />
                        </DxDataGrid>
                      </div>

                      <!--                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th>WmsOs ({{ wmsos.length > 0 ? wmsos.length : 0 }})</th>
                          <th class="text-center">Status</th>
                          <th class="text-center">Data criação</th>
                          <th class="text-center">Iniciado por</th>
                          <th class="text-center">Última atualização</th>
                          <th class="text-center">Atualizador por</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="os in wmsos" :key="os.id">
                          <h5 class="font-size-14 text-truncate">
                            <a href="javascript: void(0);" class="text-body fw-bold text-wrap"
                               @click="redirecionaPedido(os.id)">
                              {{ os.id }}
                            </a>
                          </h5>
                          <td class="text-start">{{ os.status }}</td>
                          <td class="text-end">{{ os.created_at_formatted }}</td>
                          <td class="text-end">{{ os.created_by }}</td>
                          <td class="text-end">{{ os.updated_at_formatted }}</td>
                          <td class="text-end">{{ os.updated_by ?? '-' }}</td>
                        </tr>
                        </tbody>
                      </table>-->
                    </div>
                  </template>
                  <template v-else>
                    <b-alert variant="warning" show>
                      <h4 class="alert-heading">Tudo certo por aqui!</h4>
                      <p>Não existe nenhum pedido atrelado à esse orçamento!</p>
                    </b-alert>
                  </template>
                </div>
              </div>
            </div>

            <!--            <div>
              <DxToolbar>

                <DxItem
                    location="before"
                    widget="dxButton">
                  <DxButton
                      icon="refresh"
                      hint="Redefinir formatação de tabela para padrão"
                      :on-click="refeFormTable"/>
                </DxItem>

              </DxToolbar>
            </div>

            <Loader v-if="updating" style="min-height: 300px;">
            </Loader>

            <div class="mt-2" v-if="!updating">
              <DxDataGrid
                  ref="dataGridRefKey"
                  :data-source="orctoItensData"
                  :show-borders="true"
                  :focused-row-enabled="true"
                  :keyExpr="'id'"
                  :column-auto-width="true"
                  :show-row-lines="true"
                  :allow-column-reordering="true"
                  :allow-column-resizing="true"
                  :row-alternation-enabled="true"
                  @cell-prepared="onCellPrepared"
                  @row-dbl-click="onRowDblClick"
                  @content-ready="carregouGrid"
                  @exporting="onExporting">

                <DxRemoteOperations
                    :filtering="true"
                    :paging="true"
                    :sorting="true"
                    :summary="true"
                    :grouping="false"
                    :group-paging="false"
                />


                <DxColumnChooser :enabled="true"/>
                <DxColumnFixing :enabled="true"/>
                <DxFilterRow :visible="true"/>


                <DxSelection mode="multiple"/>
                <DxExport
                    :enabled="true"
                    :allow-export-selected-data="true"/>
                <DxStateStoring
                    :enabled="true"
                    type="sessionStorage"
                    storage-key="strWmsOsEntradaList"/>

                <DxGroupPanel :visible="true"/>
                <DxGrouping/>

                <DxColumn
                    data-field="produto"
                    caption="Produto"
                    sort-order="desc"
                    data-type="number"
                    alignment="center"
                    :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                    :allowHeaderFiltering="true"/>

                <DxColumn
                    data-field="descprod"
                    caption="Descrição"
                    data-type="text"
                    alignment="center"
                    :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                    :allow-sorting="false"
                    :allowHeaderFiltering="true"/>

                <DxColumn
                    :width="110"
                    data-field="vlrunitbrt"
                    caption="Valor Unit. (R$)"
                    alignment="center"
                    :format="formatDecimal"
                    :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                    :allowHeaderFiltering="false"/>

                <DxColumn
                    :width="110"
                    data-field="pesobrttot"
                    caption="Peso Total (Kg)"
                    alignment="center"
                    :format="formatDecimal"
                    :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                    :allowHeaderFiltering="false"/>

                <DxColumn
                    :width="110"
                    data-field="cubtot"
                    caption="Cubagem Total (m3)"
                    alignment="center"
                    :format="formatDecimal"
                    :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                    :allowHeaderFiltering="false"/>

                <DxColumn
                    :width="110"
                    data-field="qtd"
                    caption="Quantidade"
                    alignment="center"
                    :format="formatDecimal"
                    :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                    :allowHeaderFiltering="false"/>

                 <DxColumn
                    :width="110"
                    data-field="conferidoqtd"
                    caption="Conferido"
                    alignment="center"
                    :format="formatDecimal"
                    :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                    :allowHeaderFiltering="false"/>

                 <DxColumn
                    :width="110"
                    data-field="aconferirqtd"
                    caption="A Conferir"
                    alignment="center"
                    :format="formatDecimal"
                    :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                    :allowHeaderFiltering="false"/>

                <DxColumn
                    :width="110"
                    data-field="margem"
                    caption="Margem (%)"
                    alignment="center"
                    :format="formatDecimal"
                    :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                    :allowHeaderFiltering="false"/>

                <DxColumn
                    :width="110"
                    data-field="desconto"
                    caption="Desconto Unit. (R$)"
                    alignment="center"
                    :format="formatDecimal"
                    :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                    :allowHeaderFiltering="false"/>

                <DxColumn
                    :width="110"
                    data-field="vlrtotalliq"
                    caption="Total Liq. (R$)"
                    alignment="center"
                    :format="formatDecimal"
                    :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                    :allowHeaderFiltering="false"/>

                <DxPager
                    :visible="true"
                    :show-page-size-selector="true"
                    :allowed-page-sizes="[10, 30, 50, 100]"
                    :show-navigation-buttons="true"
                    :show-info="true"/>

              </DxDataGrid>
            </div>-->
          </div>
        </div>
      </div>
    </div>

    <!-- ================================================================ -->
    <!-- Mobile: barra de ações fixa no rodapé + modal com as demais ações -->
    <!-- ================================================================ -->
    <template v-if="isMobile && !updating">
      <div style="height: 76px"></div>

      <div class="m-actionbar">
        <b-button
          variant="primary"
          :disabled="orctoData.status === 'CO'"
          @click="salvarOrcamento"
        >
          <i class="bx bx-save font-size-18 me-1"></i>
          Salvar
        </b-button>

        <b-button
          variant="outline-warning"
          :disabled="
            orctoData.id === 0 ||
            orctoData.status === 'CO' ||
            !podeAdicionarItem
          "
          :title="podeAdicionarItem ? 'Adicionar item ao orçamento' : tabPrecoResolvida.motivo"
          @click="novoProduto"
        >
          <i class="bx bx-plus-circle font-size-18 me-1"></i>
          Item
        </b-button>

        <b-button
          variant="outline-secondary"
          class="m-actionbar__more"
          title="Mais ações"
          @click="showModalAcoesMobile = true"
        >
          <i class="bx bx-dots-horizontal-rounded font-size-20"></i>
        </b-button>
      </div>
    </template>

    <b-modal title="Ações do orçamento" v-model="showModalAcoesMobile" hide-footer>
      <div class="d-grid gap-2">
        <b-button
          variant="success"
          v-if="orctoItensData && orctoItensData.length > 0"
          :disabled="
            orctoData.id === 0 ||
            orctoData.status === 'CO' ||
            orctoData.status === 'CP' ||
            disableButton
          "
          @click="acaoMobile('confirmar')"
        >
          <i class="mdi mdi-rocket-launch font-size-16 align-middle me-2"></i>
          Confirmar Orçamento
        </b-button>

        <b-button
          variant="outline-info"
          v-if="idData > 0 && orctoData.status !== 'SC'"
          @click="acaoMobile('imprimir')"
        >
          <i class="bx bx-printer font-size-16 align-middle me-2"></i>
          Imprimir
        </b-button>

        <b-button
          variant="outline-info"
          v-if="idData > 0 && orctoData.status !== 'SC'"
          @click="acaoMobile('copiar')"
        >
          <i class="bx bx-copy font-size-16 align-middle me-2"></i>
          Copiar
        </b-button>

        <b-button
          variant="outline-primary"
          v-if="idData > 0"
          @click="acaoMobile('redirecionar')"
        >
          <i class="bx bxs-directions font-size-16 align-middle me-2"></i>
          Redirecionar
        </b-button>

        <b-button
          variant="outline-info"
          :disabled="orctoData.id === 0 || orctoData.status === 'EL'"
          @click="acaoMobile('cotarFrete')"
        >
          <i class="bx bxs-truck font-size-16 align-middle me-2"></i>
          Cotar Frete
        </b-button>

        <b-button
          variant="outline-success"
          :disabled="orctoData.id === 0 || orctoData.status !== 'EL'"
          @click="acaoMobile('novoPagamento')"
        >
          <i class="bx bxs-dollar-circle font-size-16 align-middle me-2"></i>
          Novo Pagamento
        </b-button>

        <b-button
          variant="outline-info"
          v-if="flagCampanhaParam"
          :disabled="
            orctoData.id === 0 ||
            orctoData.status === 'CO' ||
            orctoData.status === 'CP'
          "
          @click="acaoMobile('campanha')"
        >
          <i class="bx bx-sticker font-size-16 align-middle me-2"></i>
          Adicionar Campanha
        </b-button>

        <b-button
          variant="outline-info"
          v-if="flagAgregacaoPedido"
          :disabled="orctoData.status !== 'EL'"
          @click="acaoMobile('agregar')"
        >
          <i class="bx bx-analyse font-size-16 align-middle me-2"></i>
          Agregar a pedido
        </b-button>

        <hr class="my-1" />

        <b-button
          variant="outline-success"
          v-if="orctoData.status === 'SC'"
          @click="acaoMobile('reverter')"
        >
          <i class="bx bx-arrow-back font-size-16 align-middle me-2"></i>
          Não cancelar orçamento
        </b-button>

        <b-button
          variant="outline-danger"
          v-if="orctoData.id > 0 && (orctoData.status === 'CP' || orctoData.status === 'EL')"
          @click="acaoMobile('fechar')"
        >
          <i class="bx bx-x font-size-16 align-middle me-2"></i>
          Fechar Orçamento
        </b-button>

        <b-button
          variant="outline-danger"
          :disabled="
            orctoData.id === 0 ||
            orctoData.status === 'CO' ||
            (orctoData.status === 'CP' && orctoData.status === 'CA')
          "
          @click="acaoMobile('cancelar')"
        >
          <i class="bx bxs-trash font-size-16 align-middle me-2"></i>
          Cancelar orçamento
        </b-button>
      </div>
    </b-modal>

    <b-modal
      size="md"
      :title="Prod != null ? `Ações -  (Prod.: ${Prod}) ` : 'Ações'"
      v-model="showModalAcao"
      centered
      hide-footer
    >
      <div class="d-flex flex-wrap justify-content-between gap-2 mt-2 mb-2">
        <b-button
          variant="outline-success"
          class="action-icon text-success flex-fill"
          @click="detalhesProduto(idProd)"
        >
          <i class="mdi mdi-eye font-size-18"></i>
          Detalhes
        </b-button>

        <b-button
          variant="outline-warning"
          v-if="
            paramOrctoConfParcFin === true
              ? orctoData.status === 'EL'
              : orctoData.status === 'EL' || orctoData.status === 'CP'
          "
          class="action-icon text-warning flex-fill"
          @click="editarProduto(idRow)"
        >
          <i class="mdi mdi-pencil-outline font-size-18"></i>
          Editar
        </b-button>

        <b-button
          variant="outline-danger"
          v-if="
            paramOrctoConfParcFin === true
              ? orctoData.status === 'EL'
              : orctoData.status === 'EL' || orctoData.status === 'CP'
          "
          class="action-icon text-danger flex-fill"
          @click="deletarOrctoItem(idRow)"
        >
          <i class="mdi mdi-trash-can font-size-18"></i>
          Deletar
        </b-button>
      </div>
    </b-modal>

    <b-modal
      size="lg"
      :title="
        clienteData != null
          ? `Detalhes Cliente (${clienteData.nome})`
          : 'Detalhes Cliente'
      "
      v-model="showModalCliente"
      centered
      hide-footer
    >
      <div class="col-md-12">
        <div class="mb-3">
          <span>Selecionar Novo Cliente</span>

          <multiselect
            id="inputCliente"
            @search-change="pesqCliente"
            @select="escolheuCli"
            v-model="orctoData.cliente"
            placeholder="Pesquisar cliente"
            :options="dtListPesqCli"
            :searchable="true"
            label="nome"
            track-by="nome"
            value-prop="codigo"
          >
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4">
                    {{ slotProps.option.cnpj }}
                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
                <div class="align-items-end text-end align-content-end">
                  {{ slotProps.option.cidade }} - {{ slotProps.option.estado }}
                </div>
              </div>
            </template>
          </multiselect>
        </div>
      </div>

      <div class="row" v-if="loadingCliente">
        <div class="col-12 text-center">
          <b-spinner
            type="grow"
            class="m-6 mx-2"
            variant="secondary"
            role="status"
          >
          </b-spinner>
          <b-spinner
            type="grow"
            class="m-6 mx-2"
            variant="secondary"
            role="status"
          >
          </b-spinner>
          <b-spinner
            type="grow"
            class="m-6 mx-2"
            variant="secondary"
            role="status"
          >
          </b-spinner>
        </div>
      </div>

      <div v-if="!loadingCliente && clienteData">
        <router-link :to="`/cliente/detalhe/${clienteData.id}`" target="_blank">
          <p class="mb-2">
            Código:
            <span class="text-primary"> {{ clienteData.codigo }} </span>
          </p>
        </router-link>
        <p class="mb-2" v-if="orctoData.cliender === 1">
          <span class="text-muted"> Entregar: </span>
          <span>
            {{ clienteData.rua }}, {{ clienteData.numero }},
            {{ clienteData.bairro }}
          </span>
          <span> | </span>
          <span> {{ clienteData.cidade }} - {{ clienteData.estado }} </span>
        </p>

        <p class="mb-2" v-if="orctoData.cliender === 2">
          <span class="text-muted"> Entregar: </span>
          <span>
            {{ pessoaEnderData.rua1 }}, {{ pessoaEnderData.numero1 }},
            {{ pessoaEnderData.bairro1 }}
          </span>
          <span> | </span>
          <span>
            {{ pessoaEnderData.cidade1 }} - {{ pessoaEnderData.estado1 }}
          </span>
        </p>

        <p class="mb-2" v-if="orctoData.cliender === 3">
          <span class="text-muted"> Entregar: </span>
          <span>
            {{ pessoaEnderData.rua2 }}, {{ pessoaEnderData.numero2 }},
            {{ pessoaEnderData.bairro2 }}
          </span>
          <span> | </span>
          <span>
            {{ pessoaEnderData.cidade2 }} - {{ pessoaEnderData.estado2 }}
          </span>
        </p>

        <p class="mb-4"></p>

        <p class="mb-4">
          <span> {{ clienteData.tel1 }} / {{ clienteData.email }}</span>
        </p>
      </div>

      <div v-if="clienteData && showSelecionarEnder">
        <div class="mb-2">
          <label>Selecionar Endereço de Entrega:</label>

          <div class="row">
            <div class="col-xl-4 col-sm-4">
              <div class="mb-3">
                <label class="card-radio-label mb-2">
                  <input
                    type="radio"
                    v-model="orctoData.cliender"
                    :value="1"
                    name="currency"
                    id="buycurrencyoption1"
                    class="card-radio-input"
                    checked
                  />
                  <div class="card-radio">
                    <div>
                      <i
                        class="mdi mdi-office-building-marker-outline font-size-24 text-warning align-middle me-2"
                      ></i>
                      <span
                        >{{ clienteData.cidade }} -
                        {{ clienteData.estado }}</span
                      >
                    </div>
                  </div>
                </label>

                <div>
                  <p class="text-muted mb-1 text-wrap">
                    {{ clienteData.rua }}, {{ clienteData.numero }}
                  </p>
                  <h5 class="font-size-16">
                    {{ clienteData.bairro }} - {{ clienteData.cep }}
                  </h5>
                </div>
              </div>
            </div>

            <div class="col-xl-4 col-sm-4" v-if="pessoaEnderData">
              <div class="mb-3">
                <label class="card-radio-label mb-2">
                  <input
                    type="radio"
                    v-model="orctoData.cliender"
                    :value="2"
                    name="currency"
                    id="buycurrencyoption2"
                    class="card-radio-input"
                  />
                  <div class="card-radio">
                    <div>
                      <i
                        class="mdi mdi-office-building-marker-outline font-size-24 text-primary align-middle me-2"
                      ></i>
                      <span
                        >{{ pessoaEnderData.cidade1 }} -
                        {{ pessoaEnderData.estado1 }}</span
                      >
                    </div>
                  </div>
                </label>
                <div>
                  <p class="text-muted mb-1">
                    {{ pessoaEnderData.rua1 }}, {{ pessoaEnderData.numero1 }}
                  </p>
                  <h5 class="font-size-16">
                    {{ pessoaEnderData.bairro1 }} - {{ pessoaEnderData.cep1 }}
                  </h5>
                </div>
              </div>
            </div>

            <div
              class="col-xl-4 col-sm-4"
              v-if="pessoaEnderData && pessoaEnderData.cidade2"
            >
              <div class="mb-3">
                <label class="card-radio-label mb-2">
                  <input
                    type="radio"
                    v-model="orctoData.cliender"
                    :value="3"
                    name="currency"
                    id="buycurrencyoption3"
                    class="card-radio-input"
                  />

                  <div class="card-radio">
                    <div>
                      <i
                        class="mdi mdi-home font-size-24 text-info align-middle me-2"
                      ></i>
                      <span
                        >{{ pessoaEnderData.cidade2 }} -
                        {{ pessoaEnderData.estado2 }}</span
                      >
                    </div>
                  </div>
                </label>

                <div>
                  <p class="text-muted mb-1">
                    {{ pessoaEnderData.rua2 }}, {{ pessoaEnderData.numero2 }}
                  </p>
                  <h5 class="font-size-16">
                    {{ pessoaEnderData.bairro2 }} - {{ pessoaEnderData.cep2 }}
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div class="text-start mt-5">
          <a
            href="javascript: void(0);"
            @click="showSelecionarEnder = !showSelecionarEnder"
          >
            <i class="bx bx-pencil font-size-16 align-middle me-2"></i>
            Alterar Endereço de Entrega
          </a>
        </div>
      </div>

      <div>
        <div class="text-start mt-3">
          <router-link to="/cliente/editar/0" target="_blank">
            <i class="bx bx-plus font-size-16 align-middle me-2"></i>
            Cadastrar Novo Cliente
          </router-link>
        </div>
      </div>

      <div v-if="!loadingCliente && clienteData">
        <div class="text-end mt-0">
          <b-button variant="light" @click="showModalCliente = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>

          <b-button
            type="submit"
            variant="success"
            class="ms-1"
            @click="confirmarCliente"
          >
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal
      title="Detalhes Tipo de operação"
      v-model="showModalPedTipo"
      centered
      hide-footer
    >
      <div class="col-md-12">
        <div class="mb-3">
          <span>Selecionar Novo Tipo de Operação</span>

          <multiselect
            id="tipooperacao"
            @search-change="pesqPedTipo"
            @select="escolheuPedTipo"
            v-model="orctoData.tipo"
            placeholder="Pesquisar tipo de operação"
            :options="dtlistPesqPedTipo"
            :searchable="true"
            label="descricao"
            track-by="descricao"
            value-prop="codigo"
          >
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4"> </span>
                </div>
                <div class="mt-2 font-size-20">
                  {{ slotProps.option.descricao }}
                </div>
                <span class="mx-4"> </span>
                <div class="align-items-end text-end align-content-end">
                  {{ formatDateTime(slotProps.option.created_at) }}
                </div>
              </div>
            </template>
          </multiselect>
        </div>
      </div>

      <div class="row" v-if="loadingPedTipo">
        <div class="col-12 text-center">
          <b-spinner
            type="grow"
            class="m-6 mx-2"
            variant="secondary"
            role="status"
          >
          </b-spinner>
          <b-spinner
            type="grow"
            class="m-6 mx-2"
            variant="secondary"
            role="status"
          >
          </b-spinner>
          <b-spinner
            type="grow"
            class="m-6 mx-2"
            variant="secondary"
            role="status"
          >
          </b-spinner>
        </div>
      </div>

      <div v-if="!loadingPedTipo && pedTipoData">
        <p class="mb-2">Tipo de Operação Atual</p>
        <router-link :to="`/tiposopera/list`" target="_blank">
          <p class="mb-2">
            Código:
            <span class="text-primary"> {{ pedTipoData.codigo }} </span>
          </p>

          <p class="mb-2">
            Descrição:
            <span class="text-primary"> {{ pedTipoData.descricao }} </span>
          </p>
        </router-link>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalPedTipo = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button
            type="submit"
            variant="success"
            class="ms-1"
            @click="confirmarPedTipo"
          >
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal title="Detalhes Natureza operação" v-model="showModalNatureza" centered hide-footer
             @shown="carregarNaturezas">
      <div class="col-md-12">
        <div class="mb-3">
          <span>Selecionar Natureza da Operação</span>

          <multiselect
            id="tiponatureza"
            @search-change="pesqNatureza"
            @select="escolheuNatureza"
            v-model="orctoData.tipo"
            placeholder="Pesquisar Natureza da operação"
            :options="dtlistPesqNatureza"
            :searchable="true"
            label="descricao"
            track-by="descricao"
            value-prop="id">

            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-muted font-size-14">
                    CFOP: {{ slotProps.option.cfopicms ?? 'Sem Cadastrado!' }}
                  </span>
                </div>

                <span class="mx-4"></span>

                <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>

                <span class="mx-4"></span>

                <div class="align-items-end text-end align-content-end">
                  {{ formatDateTime(slotProps.option.created_at) }}
                </div>
              </div>
            </template>
          </multiselect>
        </div>
      </div>

      <div class="row" v-if="loadingPedTipo">
        <div class="col-12 text-center">
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
        </div>
      </div>

      <div class="text-end mt-5">
          <b-button variant="light" @click="showModalNatureza = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button
            variant="success"
            class="ms-1"
            @click="showModalNatureza = false"
          >
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
    </b-modal>

    <b-modal title="Editar Dados Financeiros" v-model="showModalFinanceiroData" centered hide-footer>
      <div class="row mt-3">
        <div class="col-md-6">
          <div class="mb-3">
            <label for="condpgto">Condição de Pagamento</label>
            <multiselect id="condpgto"
                         ref="selectCondPgtoFinanceiro"
                         @search-change="pesqCondPgto"
                         @select="escolheuCondPgto"
                         v-model="orctoData.condpgto"
                         placeholder="Pesquisar condição de pagamento"
                         :options="dtListPesqCondPgto"
                         :searchable="true"
                         label="descricao"
                         class="multiselect-size"
                         track-by="codigo"
                         value-prop="codigo">
              <template #option="slotProps">
                <div class="row">
                  <div>
                    <span class="text-info">
                      {{ slotProps.option.codigo }}
                    </span>
                    <span class="ms-2" >
                      {{ slotProps.option.descricao }}
                    </span>
                  </div>
                </div>
              </template>
            </multiselect>
          </div>
        </div>


        <div class="col-md-6">
          <div class="mb-3">
            <label for="formapgto">Forma de Pagamento</label>
            <multiselect id="formapgto"
                         @open="carregarFormaPgtoDisponiveis()"
                         @search-change="pesqFormaPgto"
                         @select="escolheuFormaPgto"
                         v-model="orctoData.formapgto"
                         placeholder="Pesquisar forma de pagamento"
                         :options="dtListPesqFormaPgto"
                         :searchable="true"
                         label="descricao"
                         class="multiselect-size"
                         track-by="codigo"
                         value-prop="codigo">
              <template #option="slotProps">
                <div class="row">
                  <div>
                    <span class="text-info">
                      {{ slotProps.option.codigo }}
                    </span>
                    <span class="ms-2" >
                      {{ slotProps.option.descricao }}
                    </span>
                  </div>
                </div>
              </template>
            </multiselect>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="banco">Instituição bancária</label>
            <multiselect id="inputFinConta"
                         @search-change="pesqConta"
                         @select="escolheuConta"
                         v-model="financeiroData.banco_id"
                         placeholder="Selecione a Inst. Bancária"
                         :options="dtListPesqConta"
                         :searchable="true"
                         label="descricao"
                         class="multiselect-size"
                         track-by="id"
                         value-prop="id">
              <template #option="slotProps">
                <div class="row">
                  <div>
                    <span class="text-info">
                      {{ slotProps.option.id }}
                    </span>
                    <span class="font-size-10 mx-1 me-4">
                       (banco: {{ slotProps.option.banco }})
                    </span>
                    <span class="" >
                      {{ slotProps.option.descricao }}
                    </span>
                  </div>
                </div>
              </template>
            </multiselect>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <div class="mb-4 align-items-end align-content-start float-start mx-4">
              <label for="consutil">Considerar apenas dias úteis</label>
              <b-form-checkbox switch size="lg" v-model="financeiroData.consutil">
                {{ financeiroData.consutil === false ? 'Desativado' : 'Ativado' }}
              </b-form-checkbox>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-if="loadingFinanc">
        <div class="col-12 text-center">
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
        </div>
      </div>

      <div v-if="!loadingFinanc && financeiroData">
        <div class="row mt-4">
          <h6 class="mb-2 col-md-12">Condição de Pagamento Atual:</h6>

          <div class="col-md-6">
            <p class="mb-2">
              Cond. Pgto:
              <span class="text-primary"> {{ financeiroData.condpgto }} </span>
            </p>

            <p class="mb-2">
              Forma Pgto:
              <span class="text-primary"> {{ financeiroData.formapgto }} </span>
            </p>
          </div>

          <div class="col-md-6">
            <p class="mb-2">
              Banco:
              <span class="text-primary"> {{ financeiroData.banco }} </span>
            </p>

            <p class="mb-2">
              Cons. dia útel:
              <span class="text-primary"> {{ financeiroData.consutil }} </span>
            </p>
          </div>

        </div>




        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalFinanceiroData = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confirmarFinanceiro">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>

    <b-modal
      size="lg"
      title="Alterar Observações"
      v-model="showModalObs"
      centered
      hide-footer
    >
      <div class="col-md-12">
        <div class="mb-3">
          <label for="obs">Observações do Pedido</label>
          <textarea
            id="obs"
            v-model="orctoData.obs"
            type="text"
            rows="3"
            class="form-control"
            placeholder="Observações do Pedido"
          />
        </div>

        <div class="mb-3">
          <label for="obsnf">Observações da Nota Fiscal</label>
          <textarea
            id="obsnf"
            v-model="orctoData.obsnf"
            type="text"
            rows="3"
            class="form-control"
            placeholder="Observações da Nota Fiscal"
          />
        </div>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalObs = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button
            type="submit"
            variant="success"
            class="ms-1"
            @click="showModalObs = false"
          >
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal
      title="Alterar Valor de Frete"
      v-model="showModalFrete"
      centered
      hide-footer
    >
      <div class="col-md-12">
        <div class="mb-3">
          <label for="valorfrt">Favor informar o valor do frete</label>
          <input
            id="valorfrt"
            v-model="orctoData.valorfrt"
            type="number"
            class="form-control"
            placeholder="Valor do frete (R$)"
          />
        </div>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalFrete = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button
            type="submit"
            variant="success"
            class="ms-1"
            @click="confirmarFrete"
          >
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal
      title="Alterar Porcentagem de Desconto"
      v-model="showModalDesconto"
      centered
      hide-footer
    >
      <div class="col-md-12">
        <div class="mb-3">
          <label for="percdesc"
            >Favor informar a nova porcentagem de desconto (%)</label
          >
          <input
            id="percdesc"
            v-model="orctoData.percdesc"
            type="number"
            class="form-control"
            placeholder="Porcentagem de Desconto (%)"
          />
        </div>

        <!--        <b-alert show dismissible variant="danger" >-->
        <!--          <i class="mdi mdi-alert me-2"></i>Todos os produtos serão recalculados-->
        <!--        </b-alert>-->

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalDesconto = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>

          <b-button
            type="submit"
            variant="success"
            class="ms-1"
            @click="confirmarDesconto"
          >
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal
      title="Auditoria"
      v-model="showModalAuditoria"
      centered
      hide-footer
    >
      <div class="row">
        <div class="col-md-6">
          <div class="mb-3">
            <label for="created_by">Usuário Criação</label>
            <input
              id="created_by"
              v-model="orctoData.created_by"
              type="text"
              class="form-control"
              :disabled="true"
              placeholder="Usuário Criação"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label for="created_at">Criado em</label>
            <input
              id="created_at"
              v-model="orctoData.created_at"
              type="datetime-local"
              class="form-control"
              :disabled="true"
              placeholder="Criado em"
            />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="mb-3">
            <label for="updated_by">Usuário Atualização</label>
            <input
              id="updated_by"
              v-model="orctoData.updated_by"
              type="text"
              class="form-control"
              :disabled="true"
              placeholder="Usuário Atualização"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label for="updated_at">Atualizado em</label>
            <input
              id="updated_at"
              v-model="orctoData.updated_at"
              type="datetime-local"
              class="form-control"
              :disabled="true"
              placeholder="Atualizado em"
            />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="text-end mt-5">
            <b-button variant="light" @click="showModalAuditoria = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Fechar
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      title="Detalhes Representante"
      v-model="showModalRepres"
      centered
      hide-footer
    >
      <div class="col-md-12">
        <div class="mb-3">
          <span>Selecionar Novo Representante</span>

          <multiselect
            id="repres"
            @search-change="pesqRepres"
            @select="escolheuRepres"
            v-model="orctoData.repres"
            placeholder="Pesquisar representante"
            :options="dtListPesqRepres"
            :searchable="true"
            label="descricao"
            track-by="descricao"
            value-prop="codigo"
          >
            <template #option="slotProps">
              <div class="row">
                <div v-if="slotProps.option.codigo">
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4"> </span>
                </div>
                <div class="mt-2 font-size-20" v-if="slotProps.option.descricao">
                  {{ slotProps.option.descricao }}
                </div>
                <span class="mx-4"> </span>
                <span class="mx-4"> </span>
                <div class="align-items-end text-end align-content-end">
                  {{ formatDateTime(slotProps.option.created_at) }}
                </div>
              </div>
            </template>
          </multiselect>
        </div>
      </div>

      <div class="row" v-if="loadingRepres">
        <div class="col-12 text-center">
          <b-spinner
            type="grow"
            class="m-6 mx-2"
            variant="secondary"
            role="status"
          >
          </b-spinner>
          <b-spinner
            type="grow"
            class="m-6 mx-2"
            variant="secondary"
            role="status"
          >
          </b-spinner>
          <b-spinner
            type="grow"
            class="m-6 mx-2"
            variant="secondary"
            role="status"
          >
          </b-spinner>
        </div>
      </div>

      <div v-if="!loadingRepres && represData">
        <p class="mb-2">Representante Atual</p>
        <router-link :to="`/tiposopera/list`" target="_blank">
          <p class="mb-2">
            Código:
            <span class="text-primary"> {{ represData.codigo }} </span>
          </p>

          <p class="mb-2">
            Nome:
            <span class="text-primary"> {{ represData.descricao }} </span>
          </p>
        </router-link>

        <div class="text-end mt-5">
          <b-button variant="light" @click="cancelarRepres">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button
            type="submit"
            variant="success"
            class="ms-1"
            @click="confirmarRepres"
          >
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal
      title="Detalhes Transportadora"
      v-model="showModalTransp"
      centered
      hide-footer
    >
      <div class="col-md-12">
        <div class="mb-3">
          <span>Selecionar Nova Transportadora</span>

          <multiselect
            id="repres"
            @search-change="pesqTransp"
            @select="escolheuTransp"
            v-model="orctoData.transp"
            placeholder="Pesquisar transportadora"
            :options="dtListPesqTransp"
            :searchable="true"
            label="nome"
            track-by="nome"
            value-prop="codigo"
          >
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4"> </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
                <span class="mx-4"> </span>
                <span class="mx-4"> </span>
                <div class="align-items-end text-end align-content-end">
                  {{ formatDateTime(slotProps.option.created_at) }}
                </div>
              </div>
            </template>
          </multiselect>
        </div>
      </div>

      <div class="row" v-if="loadingTransp">
        <div class="col-12 text-center">
          <b-spinner
            type="grow"
            class="m-6 mx-2"
            variant="secondary"
            role="status"
          >
          </b-spinner>
          <b-spinner
            type="grow"
            class="m-6 mx-2"
            variant="secondary"
            role="status"
          >
          </b-spinner>
          <b-spinner
            type="grow"
            class="m-6 mx-2"
            variant="secondary"
            role="status"
          >
          </b-spinner>
        </div>
      </div>

      <div class="col-md-12">
        <div class="mb-3">
          <span>Seguimento Frete</span>

          <multiselect
            id="repres"
            @search-change="pesqFreteCota"
            @select="escolheuFreteCota"
            v-model="orctoData.segto"
            placeholder="Pesquisar seguimento"
            :options="dtListPesqFreteCota"
            :searchable="true"
            label="nome"
            track-by="nome"
            value-prop="codigo"
          >
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4"> </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
                <span class="mx-4"> </span>
                <span class="mx-4"> </span>
                <div class="align-items-end text-end align-content-end">
                  {{ formatDateTime(slotProps.option.created_at) }}
                </div>
              </div>
            </template>
          </multiselect>
        </div>
      </div>

      <div v-if="!loadingTransp && transpData">
        <p class="mb-2">Transportadora Atual</p>
        <router-link :to="`/tiposopera/list`" target="_blank">
          <p class="mb-2">
            Código:
            <span class="text-primary"> {{ transpData.codigo }} </span>
          </p>

          <p class="mb-2">
            Nome:
            <span class="text-primary"> {{ transpData.nome }} </span>
          </p>
        </router-link>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalTransp = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button
            type="submit"
            variant="success"
            class="ms-1"
            @click="confirmarTransp"
          >
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal
      size="lg"
      :title="
        orctoItemData.id != null
          ? `Editar Item do Orçamento (${orctoItemData.id})`
          : 'Criar Novo Item no Orçamento'
      "
      v-model="showModalOrctoItem"
      @shown="focusProdOrctoItem"
      hide-footer
    >
      <div class="col-md-12">
        <div class="mb-3">
          <span>Selecionar Novo Produto</span>
          <multiselect
            id="prodorctoitem"
            ref="focusThis"
            @search-change="pesqOrctoItem"
            @select="escolheuOrctoItem"
            v-model="orctoItemData.produto"
            placeholder="Pesquisar novo produto"
            :options="dtlistPesqOrctoItem"
            :searchable="true"
            label="descricao"
            class="multiselect-size"
            track-by="descrcodigo"
            value-prop="codigo"
          >
            <template #option="slotProps" v-if="dtlistPesqOrctoItem">
              <div class="row" style="min-width: 100%">
                <div style="min-width: 100%">
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4">
                    {{ slotProps.option.unidade }}
                  </span>
                  <span class="float-end text-danger" v-if="slotProps.option.sempreco">
                    sem preço na tabela {{ slotProps.option.tabpreco }}
                  </span>
                  <span class="float-end text-warning" v-else>
                    R$ {{ formatDecimal(slotProps.option.preco) }}
                  </span>
                </div>

                <div class="col-12">
                  <span class="mt-5 font-size-15">
                    {{ slotProps.option.descricao }}
                  </span>
                  <span class="float-end">
                    <!--                    R$ {{ formatDecimal(slotProps.option.preco) }}-->
                  </span>
                </div>
                <div
                  class="align-items-end text-end align-content-end float-end"
                >
                  <div v-if="!slotProps.option.imgSTrat" class="avatar-xs">
                    <span class="avatar-title rounded-circle">{{
                      slotProps.option.id
                    }}</span>
                  </div>
                  <div v-if="slotProps.option.imgSTrat">
                    <img
                      class="rounded-circle avatar-xs"
                      :src="slotProps.option.img1"
                      alt
                    />
                  </div>

                  <span class="float-end">
                    <span
                      v-if="slotProps.option.saldo > 0"
                      class="avatar-title rounded-circle bg-success avatar-xs p-1"
                    >
                      <span class="">{{
                        formatInteger(slotProps.option.saldo)
                      }}</span>
                    </span>

                    <span
                      v-else
                      class="avatar-title rounded-circle bg-danger avatar-xs p-1"
                    >
                      <span class="">{{
                        formatDecimal(slotProps.option.preco)
                      }}</span>
                    </span>
                  </span>
                </div>
              </div>
            </template>
          </multiselect>
        </div>
      </div>
      <div class="row" v-if="loadingOrctoItem">
        <div class="col-12 text-center">
          <b-spinner
            type="grow"
            class="m-6 mx-2"
            variant="secondary"
            role="status"
          >
          </b-spinner>
          <b-spinner
            type="grow"
            class="m-6 mx-2"
            variant="secondary"
            role="status"
          >
          </b-spinner>
          <b-spinner
            type="grow"
            class="m-6 mx-2"
            variant="secondary"
            role="status"
          >
          </b-spinner>
        </div>
      </div>

      <div v-if="!loadingOrctoItem && orctoItemData && orctoItemData.descprod">
        <router-link
          :to="`/produto/editar/${orctoItemData.produto_id}`"
          target="_blank"
        >
          <div class="row">
            <div class="col-lg-6">
              <div class="card mini-stats-wid">
                <div class="card-body" style="min-height: 160px">
                  <div class="d-flex flex-wrap">
                    <div class="me-2">
                      <p class="text-muted mb-2">
                        {{ orctoItemData.descprod }}
                      </p>
                      <h5 class="mb-0">
                        saldo: {{ formatInteger(orctoItemData.saldo) }} ({{
                          orctoItemData.und
                        }})
                      </h5>
                    </div>
                    <h1>IMG2 {{ orctoItemData.img1 }}</h1>
                    <div class="avatar-sm ms-auto">
                      <div
                        class="avatar-sm ms-auto"
                        v-if="!orctoItemData.imgSTrat"
                      >
                        <div
                          class="avatar-title bg-light rounded-circle text-primary font-size-20"
                        >
                          <i class="bx bx-camera-off"></i>
                        </div>
                      </div>

                      <div
                        class="avatar-sm ms-auto"
                        v-if="orctoItemData.imgSTrat"
                      >
                        <div
                          class="avatar-title bg-light rounded-circle text-primary font-size-20"
                        >
                          <img
                            class="rounded-circle avatar-xs"
                            :src="orctoItemData.imgSTrat"
                            alt
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="card mini-stats-wid">
                <div class="card-body" style="min-height: 155px">
                  <div class="d-flex flex-wrap">
                    <div class="me-2">
                      <span class="text-muted mb-2">Código: </span>
                      <span class="text-info">
                        {{ orctoItemData.produto }}
                      </span>
                    </div>
                    <div class="">
                      <p class="text-muted mb-2">Preço de Tabela (Bruto)</p>
                      <h5 class="mb-0 mt-3">
                        R$ {{ formatDecimal(orctoItemData.vlrunitbrt) }}
                      </h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div
                        class="avatar-title bg-light rounded-circle text-primary font-size-20"
                      >
                        <i class="bx bx-money"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </router-link>

        <form class="needs-validation" @submit.prevent="confOrctoItem">
          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="vlrunitliq">Valor Unitário</label>
                <input
                  id="vlrunitliq"
                  v-model="orctoItemData.vlrunitliq"
                  type="number"
                  class="form-control text-end"
                  placeholder="Valor unitário líquido"
                  :class="{
                    'is-invalid':
                      submitOrctoItem && v$.orctoItemData.vlrunitliq.$error,
                  }"
                />
                <div
                  v-if="submitOrctoItem && v$.orctoItemData.vlrunitliq.$error"
                  class="invalid-feedback"
                >
                  <span v-if="v$.orctoItemData.vlrunitliq.required.$message">{{
                    v$.orctoItemData.vlrunitliq.required.$message
                  }}</span>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="mb-3">
                <label for="qtd">Quantidade</label>
                <input
                  id="qtd"
                  v-model="orctoItemData.qtd"
                  type="number"
                  class="form-control text-end"
                  placeholder="Quantidade"
                  :class="{
                    'is-invalid':
                      submitOrctoItem && v$.orctoItemData.qtd.$error,
                  }"
                />
                <div
                  v-if="submitOrctoItem && v$.orctoItemData.qtd.$error"
                  class="invalid-feedback"
                >
                  <span v-if="v$.orctoItemData.qtd.required.$message">{{
                    v$.orctoItemData.qtd.required.$message
                  }}</span>
                </div>
              </div>
            </div>

            <div class="col-md-4" v-if="orctoItemData.deflote && empresaData.tipoestoque === 'PADRAO'">
              <div class="mb-3">
                <label for="lote">Lotes</label>
                <multiselect
                  id="lotes"
                  @search-change="pesqLotes"
                  v-model="orctoItemData.lote"
                  placeholder="Selecionar lotes"
                  :options="dtListLotes"
                  :searchable="true"
                  label="lote"
                  track-by="lote"
                  value-prop="lote"
                >
                  <template #option="slotProps">
                    <div class="row">
                      <div class="mt-2 font-size-14">
                        {{ `${slotProps.option.lote}(${slotProps.option.endwms}): ${slotProps.option.saldo}` }}
                      </div>
                      <div class="mt-2 font-size-20">
                      </div>
                    </div>
                  </template>
                </multiselect>
              </div>
            </div>

            <div class="col-md-4" v-if="empresaData.tipoestoque === 'DESCON'">
              <div class="mb-3">
                <label for="lote">Lotes</label>
                  <input
                      id="qtd"
                      v-model="orctoItemData.lote"
                      type="text"
                      class="form-control text-end"
                      placeholder="Lote"
                  />
              </div>
            </div>
          </div>
        </form>

        <div class="row text-end" v-if="messageValidacaoItem !== ''">
          <div class="col-md-12">
            <span class="text-danger"> {{ messageValidacaoItem }} * </span>
          </div>
        </div>

        <div class="row">
          <div class="text-end mt-5">
            <b-button variant="light" @click="showModalOrctoItem = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Cancelar
            </b-button>
            <b-button
              variant="success"
              class="ms-1"
              @click="confOrctoItem"
              :disabled="messageValidacaoItem !== ''"
            >
              <!--confOrctoItem | orctoitemUpdate-->
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
              Confirmar
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>

<!--    Ajuste de condição de pagamento e forma de pagamento em modal dados financeiro

    <b-modal
      title="Detalhes Pagamento"
      v-model="showModalCondPgto"
      centered
      hide-footer
    >
      <div class="col-md-12 mt-2">
        <div class="mb-3">
          <span>Selecionar Nova Forma de Pagamento</span>

          <multiselect
            id="formapgto"
            @search-change="pesqFormaPgto"
            @select="escolheuFormaPgto"
            v-model="orctoData.formapgto"
            placeholder="Pesquisar forma de pagamento"
            :options="dtListPesqFormaPgto"
            :searchable="true"
            label="descricao"
            track-by="descricao"
            value-prop="codigo"
          >
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4"> </span>
                </div>
                <div class="mt-2 font-size-20">
                  {{ slotProps.option.descricao }}
                </div>
                <span class="mx-4"> </span>
                <span class="mx-4"> </span>
                <div class="align-items-end text-end align-content-end">
                  {{ formatDateTime(slotProps.option.created_at) }}
                </div>
              </div>
            </template>
          </multiselect>
        </div>
      </div>

      <div class="col-md-12 mt-2">
        <div class="mb-3">
          <span>Selecionar Nova Condição de Pagamento</span>

          <multiselect
            id="condpgto"
            @search-change="pesqCondPgto"
            @select="escolheuCondPgto"
            v-model="orctoData.condpgto"
            placeholder="Pesquisar condição de pagamento"
            :options="dtListPesqCondPgto"
            :searchable="true"
            label="descricao"
            track-by="descricao"
            value-prop="codigo"
          >
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4"> </span>
                </div>
                <div class="mt-2 font-size-20">
                  {{ slotProps.option.descricao }}
                </div>

                <span class="mx-4"> </span>
                <span class="mx-4"> </span>
                <div class="align-items-end text-end align-content-end">
                  {{ formatDateTime(slotProps.option.created_at) }}
                </div>
              </div>
            </template>
          </multiselect>
        </div>
      </div>

      <div class="row" v-if="loadingCondPgto">
        <div class="col-12 text-center">
          <b-spinner
            type="grow"
            class="m-6 mx-2"
            variant="secondary"
            role="status"
          >
          </b-spinner>
          <b-spinner
            type="grow"
            class="m-6 mx-2"
            variant="secondary"
            role="status"
          >
          </b-spinner>
          <b-spinner
            type="grow"
            class="m-6 mx-2"
            variant="secondary"
            role="status"
          >
          </b-spinner>
        </div>
      </div>

      <div v-if="!loadingCondPgto && condPgtoData && formaPgtoData">
        <div class="mt-2">
          <p class="mb-2">Forma de Pagamento Atual</p>

          <p class="mb-2">
            Código:
            <span class="text-primary"> {{ formaPgtoData.codigo }} </span>
          </p>

          <p class="mb-2">
            Descrição:
            <span class="text-primary"> {{ formaPgtoData.descricao }} </span>
          </p>
        </div>

        <div class="mt-4">
          <p class="mb-2">Condição de Pagamento Atual</p>

          <p class="mb-2">
            Código:
            <span class="text-primary"> {{ condPgtoData.codigo }} </span>
          </p>

          <p class="mb-2">
            Descrição:
            <span class="text-primary"> {{ condPgtoData.descricao }} </span>
          </p>
        </div>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalCondPgto = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button
            type="submit"
            variant="success"
            class="ms-1"
            @click="confirmarFormaPgto"
          >
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>-->

    <b-modal
      title="Alterar Data Orçamento"
      v-model="showModalDataOrcamento"
      centered
      hide-footer
    >
      <div class="col-md-12 mt-2">
        <div class="mb-3">
          <!-- <span>Selecionar Nova Data Orçamento</span> -->
          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="novaDtOracamento"
                  >Selecionar Nova Data Orçamento</label
                >
                <input
                  id="novaDtOracamento"
                  v-model="orctoData.dtemissao"
                  type="date"
                  class="form-control"
                  placeholder="Data Orçamento"
                  :class="{ 'is-invalid': submittedPeriodo && !dtIniFiltro }"
                />
                <div
                  v-if="submittedPeriodo && !dtIniFiltro"
                  class="invalid-feedback"
                >
                  <span>Campo data início obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-if="loadingCondPgto">
        <div class="col-12 text-center">
          <b-spinner
            type="grow"
            class="m-6 mx-2"
            variant="secondary"
            role="status"
          >
          </b-spinner>
          <b-spinner
            type="grow"
            class="m-6 mx-2"
            variant="secondary"
            role="status"
          >
          </b-spinner>
          <b-spinner
            type="grow"
            class="m-6 mx-2"
            variant="secondary"
            role="status"
          >
          </b-spinner>
        </div>
      </div>

      <div v-if="!loadingCondPgto && condPgtoData && formaPgtoData">
        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalCondPgto = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button
            type="submit"
            variant="success"
            class="ms-1"
            @click="confirmarDataOrcamento"
          >
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal
      size="xl"
      title="Cotação de Frete"
      v-model="showModalCotarFrete"
      centered
      hide-footer
    >
      <div class="col-md-12">
        <div class="row" v-if="loadingCotarFrete">
          <div class="col-12 text-center">
            <b-spinner
              type="grow"
              class="m-6 mx-2"
              variant="secondary"
              role="status"
            >
            </b-spinner>
            <b-spinner
              type="grow"
              class="m-6 mx-2"
              variant="secondary"
              role="status"
            >
            </b-spinner>
            <b-spinner
              type="grow"
              class="m-6 mx-2"
              variant="secondary"
              role="status"
            >
            </b-spinner>
          </div>
        </div>

        <div class="m-list" v-if="cotaFreteListData && isMobile">
          <div
            v-for="data in cotaFreteListData"
            :key="data.WSOut_MovSim_ID"
            class="m-card"
          >
            <div class="m-card__head">
              <h5 class="m-card__id">{{ data.WSOut_Transp_Nome }}</h5>

              <span
                class="badge badge-soft-success font-size-11 m-card__head-spacer"
                v-if="data.menorvalor"
              >
                Menor valor
              </span>
              <span
                class="badge badge-soft-info font-size-11"
                v-if="data.menorprazo"
              >
                Menor prazo
              </span>
            </div>

            <p class="m-card__subtitle">
              {{ data.WSOut_Transp_CNPJ }}
              <span v-if="data.WSOut_Transp_Email">
                &middot; {{ data.WSOut_Transp_Email }}
              </span>
            </p>

            <div class="m-card__grid m-card__grid--3">
              <div class="m-field">
                <span class="m-field__label">Frete %</span>
                <span class="m-field__value">
                  {{ formatDecimal((data.WSOut_Frete_Val / orctoData.valorliq) * 100) }}
                </span>
              </div>
              <div class="m-field">
                <span class="m-field__label">Frete kg</span>
                <span class="m-field__value">
                  {{ formatDecimal((data.WSOut_Frete_Val / orctoData.peso) * 100) }}
                </span>
              </div>
              <div class="m-field">
                <span class="m-field__label">Prazo</span>
                <span class="m-field__value">{{ data.WSOut_Prazo_Dias }} dias</span>
              </div>
            </div>

            <div class="m-card__foot">
              <span class="m-card__total">
                R$ {{ formatDecimal(data.WSOut_Frete_Val) }}
              </span>

              <span class="m-card__actions">
                <b-button
                  variant="outline-success"
                  size="sm"
                  title="Definir valor orçamento frete"
                  @click="escolherFrete(data.WSOut_MovSim_ID, data.WSOut_Transp_CNPJ, data.WSOut_Frete_Val)"
                >
                  <i class="mdi mdi-check-outline font-size-16 me-1"></i>
                  Escolher
                </b-button>
              </span>
            </div>
          </div>
        </div>

        <div class="table-responsive" v-if="cotaFreteListData && !isMobile">
          <table class="table table-centered table-nowrap">
            <thead>
              <tr>
                <th scope="col">Ações</th>
                <th scope="col">TranspNome</th>
                <th scope="col" class="">Frete R$</th>
                <th scope="col" class="">Frete %</th>
                <th scope="col" class="">Frete KG</th>

                <th scope="col" class="text-end">PrazoDias</th>

                <th scope="col">TranspCNPJ</th>
                <th scope="col">TranspEmail</th>
                <th scope="col" class="text-end">Mov.Cot.ID</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="data in cotaFreteListData" :key="data.id">
                <td>
                  <a
                    href="javascript:void(0);"
                    v-b-tooltip.hover
                    class="action-icon text-info mx-2"
                    title="Definir valor orçamento frete"
                    @click="escolherFrete(data.WSOut_MovSim_ID,data.WSOut_Transp_CNPJ, data.WSOut_Frete_Val)"
                  >
                    <i class="mdi mdi-check-outline font-size-18"></i>
                  </a>
                </td>

                <td>
                  {{ data.WSOut_Transp_Nome }}
                </td>

                <td class="text-end">
                  <i
                    class="bx bxs-dollar-circle font-size-18 bx-fade-right text-success"
                    v-if="data.menorvalor"
                  ></i>
                  {{ formatDecimal(data.WSOut_Frete_Val) }}
                </td>

                <td class="text-end">
                  <i
                    class="bx bxs-dollar-circle font-size-18 bx-fade-right text-success"
                    v-if="data.menorvalor"
                  ></i>
                  {{
                    formatDecimal(
                      (data.WSOut_Frete_Val / orctoData.valorliq) * 100
                    )
                  }}
                </td>

                <td class="text-end">
                  <i
                    class="bx bxs-dollar-circle font-size-18 bx-fade-right text-success"
                    v-if="data.menorvalor"
                  ></i>
                  {{
                    formatDecimal((data.WSOut_Frete_Val / orctoData.peso) * 100)
                  }}
                </td>

                <!--              <td>-->
                <!--                <div>-->
                <!--                  <h5 class="text-truncate font-size-14">-->
                <!--                    {{ formatDateTime(data.WSOut_DataH) }}-->
                <!--                  </h5>-->
                <!--                </div>-->
                <!--              </td>-->

                <td class="text-end">
                  <i
                    class="bx bxs-calendar font-size-18 bx-fade-right text-info"
                    v-if="data.menorprazo"
                  ></i>
                  {{ data.WSOut_Prazo_Dias }}
                </td>

                <!--              <td class="text-end">-->
                <!--                {{ data.WSOut_Indic }}-->
                <!--              </td>-->
                <!--              <td class="text-end">-->
                <!--                {{ data.WSOut_MovCot_ID }}-->
                <!--              </td>-->
                <!--              <td class="text-end">-->
                <!--                {{ data.WSOut_MovSim_ID }}-->
                <!--              </td>-->
                <!--              <td>-->
                <!--                {{ data.WSOut_NotaS }}-->
                <!--              </td>-->

                <td>
                  {{ data.WSOut_Transp_CNPJ }}
                </td>
                <td>
                  {{ data.WSOut_Transp_Email }}
                </td>
                <td class="text-end">
                  {{ data.WSOut_MovCot_ID }}
                </td>
              </tr>

              <!--            <tr>-->
              <!--              <td colspan="4">-->
              <!--                <h6 class="m-0 text-end">Quantidade Total Volumes:</h6>-->
              <!--              </td>-->
              <!--              <td class="text-end"> {{ formatDecimal(0.00) }}</td>-->
              <!--            </tr>-->

              <!--            <tr>-->
              <!--              <td colspan="4">-->
              <!--                <h6 class="m-0 font-size-14  text-end">Peso Total Volumes:</h6>-->
              <!--              </td>-->
              <!--              <td class="font-size-14 text-end"> {{ formatDecimal(0.00) }}</td>-->
              <!--            </tr>-->
            </tbody>
          </table>
        </div>

        <!--        <div class="mb-3">-->
        <!--          <label for="obs">Observações do Pedido</label>-->
        <!--          <textarea-->
        <!--              id="obs"-->
        <!--              v-model="orctoData.obs"-->
        <!--              type="text"-->
        <!--              rows="3"-->
        <!--              class="form-control"-->
        <!--              placeholder="Observações do Pedido"/>-->
        <!--        </div>-->

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalCotarFrete = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button
            type="submit"
            variant="success"
            class="ms-1"
            @click="showModalCotarFrete = false"
          >
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal
      size="lg"
      :title="
        orctoFinanData.id != null
          ? `Editar Pagamento do Orçamento (${orctoFinanData.id})`
          : 'Criar Novo Pagamento no Orçamento'
      "
      v-model="showModalOrctoFinan"
      hide-footer
    >
      <div>
        <form class="needs-validation" @submit.prevent="confOrctoFinanc">
          <div class="row">
            <div class="col-md-6 mt-2">
              <div class="mb-3">
                <span>Forma de Pagamento</span>
                <multiselect
                  id="formapgto"
                  @search-change="pesqFormaPgto"
                  @select="escolheuFormaPgto"
                  v-model="orctoFinanData.formapgto"
                  placeholder="Pesquisar forma de pagamento"
                  :options="dtListPesqFormaPgto"
                  :searchable="true"
                  label="descricao"
                  track-by="descricao"
                  :style="
                    submitOrctoFinanc && !orctoFinanData.formapgto
                      ? 'border: 1px solid #f86c6b !important;'
                      : ''
                  "
                  value-prop="codigo"
                >
                  <template #option="slotProps">
                    <div class="row">
                      <div>
                        <span class="text-info">
                          {{ slotProps.option.codigo }}
                        </span>
                        <span class="mx-4"> </span>
                      </div>
                      <div class="mt-2 font-size-20">
                        {{ slotProps.option.descricao }}
                      </div>
                      <span class="mx-4"></span>
                      <span class="mx-4"></span>
                      <div class="align-items-end text-end align-content-end">
                        {{ formatDateTime(slotProps.option.created_at) }}
                      </div>
                    </div>
                  </template>
                </multiselect>
                <div v-if="submitOrctoFinanc && !orctoFinanData.formapgto">
                  <span class="text-danger font-size-11"
                    >Campo Forma de Pagamento obrigatório, favor
                    preencher.</span
                  >
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="mb-3">
                <label for="valor">Valor</label>
                <input
                  id="valor"
                  v-model="orctoFinanData.valor"
                  type="number"
                  class="form-control text-end"
                  placeholder="Valor"
                  :class="{
                    'is-invalid': submitOrctoFinanc && !orctoFinanData.valor,
                  }"
                />
                <div
                  v-if="submitOrctoFinanc && !orctoFinanData.valor"
                  class="invalid-feedback"
                >
                  <span> Campo valor obrigatório, favor preencher. </span>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="mb-3">
              <label for="obs">Observações</label>
              <textarea
                id="obs"
                v-model="orctoFinanData.obs"
                type="text"
                rows="3"
                class="form-control"
                placeholder="Observações"
              />
            </div>
          </div>
        </form>

        <div class="row text-end" v-if="messageValidacaoItem !== ''">
          <div class="col-md-12">
            <span class="text-danger"> {{ messageValidacaoItem }} * </span>
          </div>
        </div>

        <div class="row">
          <div class="text-end mt-5">
            <b-button variant="light" @click="showModalOrctoFinan = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Cancelar
            </b-button>

            <b-button
              variant="outline-danger"
              class="ms-1"
              @click="excluirFinanc"
              v-if="orctoFinanData.id > 0"
            >
              <i class="bx bx-trash font-size-16 align-middle me-2"></i>
              Excluir Lançamento
            </b-button>

            <b-button
              variant="success"
              class="ms-1"
              @click="confOrctoFinanc"
              :disabled="messageValidacaoItem !== ''"
            >
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
              Confirmar
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      size="md"
      title="Detalhamento de Carga"
      v-model="showModalCarga"
      hide-footer
    >
      <div>
        <form class="needs-validation" @submit.prevent="confCodCarga">
          <div class="row">
            <div class="col-md-12">
              <div class="mb-3">
                <label for="carga">Código de Carga</label>
                <input
                  id="carga"
                  v-model="orctoData.carga"
                  type="text"
                  class="form-control text-end"
                  placeholder="Código de Carga"
                  :class="{ 'is-invalid': submitCodCarga && !orctoData.carga }"
                />
                <div
                  v-if="submitCodCarga && !orctoData.carga"
                  class="invalid-feedback"
                >
                  <span>
                    Campo código de carga obrigatório, favor preencher.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </form>

        <div class="row">
          <div class="row" v-if="loadingCargas">
            <div class="col-12 text-center">
              <b-spinner
                type="grow"
                class="m-6 mx-2"
                variant="secondary"
                role="status"
              >
              </b-spinner>
              <b-spinner
                type="grow"
                class="m-6 mx-2"
                variant="secondary"
                role="status"
              >
              </b-spinner>
              <b-spinner
                type="grow"
                class="m-6 mx-2"
                variant="secondary"
                role="status"
              >
              </b-spinner>
            </div>
          </div>
        </div>

        <div class="row mt-2">
          <span>Todas as Cargas</span>

          <div class="table-responsive">
          <table class="table align-middle mb-0 mt-2 table-nowrap">
            <thead class="table-light">
              <tr>
                <th>Carga</th>
                <th class="text-end">m³</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="data in cargasData" :key="data.carga">
                <td class="text-start">{{ data.carga }}</td>
                <td class="text-end">{{ formatDecimalQuatro(data.cubtot) }}</td>
              </tr>
            </tbody>
          </table>
          </div>
        </div>

        <div class="row">
          <div class="text-end mt-5">
            <b-button variant="light" @click="showModalCarga = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Cancelar
            </b-button>
            <b-button variant="success" class="ms-1" @click="confCodCarga">
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
              Confirmar
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      title="Sugestão de Itens"
      v-model="showModalSugereItens"
      size="xl"
      centered
      hide-footer
    >
      <div class="sug-wrap">
      <div class="sug-topo">
      <!-- Banner sempre visível: ao rolar a lista ele se recolhe numa linha (expansível). -->
      <div
        v-if="descVolPrevia.length"
        class="alert py-2 mb-2 sug-descvol"
        :class="[
          descVolPreviaAtingidas.length ? 'alert-success' : 'alert-info',
          { 'is-compacto': descVolCompacto },
        ]"
      >
        <div class="d-flex align-items-center justify-content-between gap-2">
          <div
            class="sug-descvol__titulo flex-grow-1 text-truncate"
            :role="descVolRolado ? 'button' : null"
            @click="descVolRolado && (descVolExpandido = !descVolExpandido)"
          >
            <i class="mdi mdi-sale font-size-16 align-middle me-1"></i>
            <strong>Desconto por volume</strong>
            <span v-if="descVolCompacto" class="small ms-1">
              &middot; {{ descVolPreviaAtingidas.length }} atingida(s)
              <template v-if="descVolPreviaProximas.length">
                &middot; {{ descVolPreviaProximas.length }} próxima(s)
              </template>
            </span>
          </div>
          <div class="form-check form-switch mb-0 flex-shrink-0">
            <input
              id="descVolAplicaSug"
              v-model="descVolAplicaSug"
              class="form-check-input"
              type="checkbox"
              @change="calculaTotalItemSug"
            />
            <label class="form-check-label fw-semibold" for="descVolAplicaSug">
              <span class="d-none d-sm-inline">Aplicar desconto por volume</span>
              <span class="d-sm-none">Aplicar</span>
            </label>
          </div>
          <button
            v-if="descVolRolado"
            type="button"
            class="btn btn-sm btn-link p-0 text-reset flex-shrink-0"
            :title="descVolCompacto ? 'Expandir' : 'Recolher'"
            @click="descVolExpandido = !descVolExpandido"
          >
            <i
              class="mdi font-size-20"
              :class="descVolCompacto ? 'mdi-chevron-down' : 'mdi-chevron-up'"
            ></i>
          </button>
        </div>
        <div v-show="!descVolCompacto" class="sug-descvol__detalhe">
          <div v-for="regra in descVolPreviaAtingidas" :key="regra.chave" class="small">
            {{ regra.descricao || regra.codigo }} &mdash; {{ regra.alvolabel }}:
            {{ formatDecimal(regra.qtdatual) }} un., {{ formatDecimal(regra.desconto) }}% de desconto atingido{{ descVolAplicaSug ? "" : " (não aplicado)" }}.
          </div>
          <div v-for="regra in descVolPreviaProximas" :key="regra.chave" class="small">
            {{ regra.descricao || regra.codigo }} &mdash; {{ regra.alvolabel }}:
            {{ formatDecimal(regra.qtdatual) }} un., faltam {{ formatDecimal(regra.falta) }} un. para {{ formatDecimal(regra.desconto) }}% de desconto.
          </div>
          <div class="small text-muted mt-1">
            <template v-if="descVolAplicaSug">
              Prévia: o Valor Total já considera o desconto; o preço final é gravado ao confirmar.
            </template>
            <template v-else>
              O desconto não é aplicado automaticamente: marque "Aplicar desconto por volume" para usá-lo.
            </template>
          </div>
        </div>
      </div>

      <!-- Mobile: totais fixos acima da lista de cards -->
      <div v-if="isMobile" class="sug-totais-m mb-2">
        <div>
          <span>Qtd.</span>
          <strong>{{ formatDecimalDuas(totaisSug.qtd) }}</strong>
        </div>
        <div>
          <span>Cub. m³</span>
          <strong>{{ formatDecimalQuatro(totaisSug.cub) }}</strong>
        </div>
        <div>
          <span>Total</span>
          <strong>{{ formatDecimalDuas(totaisSug.vlr) }}</strong>
        </div>
      </div>
      </div>

      <div class="sug-lista" @scroll="onScrollSugLista">
      <div class="col-md-12">
        <div class="mb-3">
          <div class="sug-cab" v-if="!isMobile">
            <div class="row">
              <div class="col-md-1 sug-c-cod">
                <div>
                  <label>Cód.</label>
                </div>
              </div>
              <div class="col-md-2 sug-c-desc">
                <div>
                  <label>Descrição</label>
                </div>
              </div>
              <div class="col-md-1 sug-c-fam">
                <div>
                  <label>Família</label>
                </div>
              </div>
              <div class="col-md-1 sug-c-ult text-end">
                <div>
                  <label>Últ.</label>
                </div>
              </div>
              <div class="col-md-1 sug-c-qtd text-end">
                <div>
                  <label>Qtd.</label>
                </div>
              </div>
              <div class="col-md-2 sug-c-unit text-end">
                <div>
                  <label>Vlr. Unit.</label>
                </div>
              </div>
              <div class="col-md-1 sug-c-cub text-end">
                <div>
                  <label>Cub. m³</label>
                </div>
              </div>
              <div class="col-md-2 sug-c-tot text-end">
                <div>
                  <label>Vlr. Total</label>
                </div>
              </div>
              <div class="col-md-1 sug-c-del text-end"></div>
            </div>
            <!-- totais das colunas decimais, fixos junto ao cabeçalho -->
            <div class="row sug-totais">
              <div class="sug-c-cod"></div>
              <div class="sug-c-desc text-truncate">
                Totais
                <span class="text-muted fw-normal">
                  ({{ totaisSug.itens }} {{ totaisSug.itens === 1 ? "item" : "itens" }} com qtd.)
                </span>
              </div>
              <div class="sug-c-fam"></div>
              <div class="sug-c-ult"></div>
              <div class="sug-c-qtd text-end">{{ formatDecimalDuas(totaisSug.qtd) }}</div>
              <div class="sug-c-unit"></div>
              <div class="sug-c-cub text-end">{{ formatDecimalQuatro(totaisSug.cub) }}</div>
              <div class="sug-c-tot text-end">{{ formatDecimalDuas(totaisSug.vlr) }}</div>
              <div class="sug-c-del"></div>
            </div>
          </div>

          <!-- ====== Mobile: um card por item, com rótulos ====== -->
          <template v-if="isMobile">
            <div
              v-for="(field, index) in orctoItensSugeridos"
              :key="`m-${field.id}`"
              class="m-item-form"
            >
              <div class="m-item-form__head">
                <div class="flex-grow-1">
                  <p class="m-card__title mb-0">{{ field.descprod }}</p>
                  <p class="m-card__subtitle mb-0">
                    Cód. {{ field.produto }} &middot; ID {{ field.produto_id }}
                    <template v-if="field.familia || field.grupo">
                      &middot; {{ field.familia || field.grupo }}
                    </template>
                  </p>
                </div>

                <b-button
                  variant="outline-danger"
                  size="sm"
                  title="Remover item"
                  @click="deletarItemSug(index)"
                >
                  <i class="mdi mdi-trash-can font-size-16"></i>
                </b-button>
              </div>

              <div class="m-item-form__grid m-item-form__grid--linha">
                <div>
                  <label :for="`sug_qtdultima${field.produto_id}`">Última</label>
                  <input
                    :id="`sug_qtdultima${field.produto_id}`"
                    :value="field.qtdultima"
                    type="number"
                    class="form-control text-end"
                    style="cursor: pointer"
                    readonly
                    title="Toque para copiar para Quantidade"
                    @click="copiaQtdUltima(field)"
                  />
                </div>

                <div>
                  <label :for="`sug_qtd${field.produto_id}`">
                    Qtd.<span v-if="field.und" class="text-muted"> ({{ field.und }})</span>
                  </label>
                  <input
                    :id="`sug_qtd${field.produto_id}`"
                    v-model="field.qtd"
                    type="number"
                    min="0"
                    inputmode="numeric"
                    class="form-control text-end"
                    :class="{ 'is-invalid': submittedItensSugeridos && !field.qtd }"
                    @focus="selecionaConteudo"
                    @input="normalizaQtdSug(field)"
                    @blur="normalizaQtdSug(field, true)"
                    @keydown.enter.prevent="focoProximaQtdSug(field, index)"
                  />
                  <div
                    v-if="submittedItensSugeridos && !field.qtd"
                    class="invalid-feedback"
                  >
                    <span>Quantidade obrigatória.</span>
                  </div>
                </div>

                <div class="is-wide">
                  <label :for="`sug_vlrunit${field.produto_id}`">Vlr. unit.</label>
                  <input
                    :id="`sug_vlrunit${field.produto_id}`"
                    :value="formatDecimalDuas(field.vlrunitliq)"
                    type="text"
                    inputmode="decimal"
                    class="form-control text-end"
                    :class="{ 'is-invalid': submittedItensSugeridos && !field.vlrunit }"
                    @focus="selecionaConteudo"
                    @change="alteraVlrUnitSug(field, $event.target.value)"
                  />
                  <div
                    v-if="submittedItensSugeridos && !field.vlrunit"
                    class="invalid-feedback"
                  >
                    <span>Valor unitário obrigatório.</span>
                  </div>
                </div>

                <div>
                  <label :for="`sug_cubtot${field.produto_id}`">Cub. m³</label>
                  <input
                    :id="`sug_cubtot${field.produto_id}`"
                    :value="formatDecimalQuatro(field.cubtot)"
                    type="text"
                    class="form-control text-end"
                    :disabled="true"
                  />
                </div>

                <div class="is-wide">
                  <label :for="`sug_vlrtotal${field.produto_id}`">Total</label>
                  <input
                    :id="`sug_vlrtotal${field.produto_id}`"
                    :value="formatDecimalDuas(field.vlrtotalliq)"
                    type="text"
                    class="form-control text-end"
                    :disabled="true"
                  />
                </div>
              </div>
            </div>

            <div class="m-empty" v-if="orctoItensSugeridos.length === 0">
              Nenhum item sugerido para este cliente.
            </div>
          </template>

          <template v-else>
          <div
            v-for="(field, index) in orctoItensSugeridos"
            :key="field.id"
            class="row"
          >
            <div class="col-md-1 sug-c-cod text-end">
              <input
                id="sug_produto"
                v-model="field.produto"
                type="text"
                class="form-control"
                placeholder="código"
                :disabled="true"
                :class="{
                  'is-invalid': submittedItensSugeridos && !field.produto,
                }"
              />
              <div
                v-if="submittedItensSugeridos && !field.produto"
                class="invalid-feedback"
              >
                <span>Campo código obrigatório, favor preencher.</span>
              </div>
            </div>
            <div class="col-md-2 sug-c-desc text-end">
              <input
                id="sug_descricao"
                v-model="field.descprod"
                type="text"
                class="form-control"
                placeholder="Descrição"
                :disabled="true"
                :class="{
                  'is-invalid': submittedItensSugeridos && !field.descricao,
                }"
              />
              <div
                v-if="submittedItensSugeridos && !field.descricao"
                class="invalid-feedback"
              >
                <span>Campo descrição obrigatório, favor preencher.</span>
              </div>
            </div>
            <div
              class="col-md-1 sug-c-fam text-truncate align-self-center"
              :title="field.familia"
            >
              <small class="text-muted">{{ field.familia || field.grupo || "-" }}</small>
            </div>
            <div class="col-md-1 sug-c-ult text-end">
              <input
                :id="`sug_qtdultima${field.produto_id}`"
                :value="field.qtdultima"
                type="number"
                class="form-control text-end"
                style="cursor: pointer"
                readonly
                title="Clique para copiar para Quantidade"
                placeholder="Última"
                @click="copiaQtdUltima(field)"
              />
            </div>
            <div class="col-md-1 sug-c-qtd text-end">
              <div class="d-flex align-items-center">
                <input
                  :id="`sug_qtd${field.produto_id}`"
                  v-model="field.qtd"
                  type="number"
                  min="0"
                  class="form-control text-end"
                  placeholder="Quantidade"
                  :class="{ 'is-invalid': submittedItensSugeridos && !field.qtd }"
                  @focus="selecionaConteudo"
                  @input="normalizaQtdSug(field)"
                  @blur="normalizaQtdSug(field, true)"
                  @keydown.enter.prevent="focoProximaQtdSug(field, index)"
                />
                <small v-if="field.und" class="text-muted ms-1 text-nowrap">{{ field.und }}</small>
              </div>
              <div
                v-if="submittedItensSugeridos && !field.qtd"
                class="invalid-feedback"
              >
                <span>Campo quantidade obrigatório, favor preencher.</span>
              </div>
            </div>
            <div class="col-md-2 sug-c-unit text-end">
              <input
                :id="`sug_vlrunit${field.produto_id}`"
                :value="formatDecimalDuas(field.vlrunitliq)"
                type="text"
                inputmode="decimal"
                class="form-control text-end"
                placeholder="Valor Unitário"
                :class="{
                  'is-invalid': submittedItensSugeridos && !field.vlrunit,
                }"
                @focus="selecionaConteudo"
                @change="alteraVlrUnitSug(field, $event.target.value)"
              />
              <div
                v-if="submittedItensSugeridos && !field.vlrunit"
                class="invalid-feedback"
              >
                <span>Campo Valor Unitário obrigatório, favor preencher.</span>
              </div>
            </div>
            <div class="col-md-1 sug-c-cub text-end">
              <input
                :id="`sug_cubtot${field.produto_id}`"
                :value="formatDecimalQuatro(field.cubtot)"
                type="text"
                class="form-control text-end"
                :disabled="true"
                title="Cubagem que o item está somando ao orçamento"
                placeholder="Cubagem"
              />
            </div>
            <div class="col-md-2 sug-c-tot text-end">
              <input
                :id="`sug_vlrtotal${field.produto_id}`"
                :value="formatDecimalDuas(field.vlrtotalliq)"
                type="text"
                class="form-control text-end"
                :disabled="true"
                placeholder="Valor Total"
              />
              <span
                v-if="field.descvolprevperc > 0"
                class="badge bg-success mt-1"
                :title="`Desconto por volume (regra ${field.descvolprevregra})`"
              >-{{ formatDecimal(field.descvolprevperc) }}%</span>
            </div>
            <div class="col-md-1 sug-c-del text-end">
              <div class="button-items">
                <b-button
                  variant="outline-danger"
                  @click="deletarItemSug(index)"
                >
                  <i class="mdi mdi-trash-can d-block font-size-16"></i>
                </b-button>
              </div>
            </div>
          </div>
          </template>
        </div>
      </div>
      </div>
      </div>

      <div>
        <div class="text-end mt-3">
          <b-button variant="light" @click="showModalSugereItens = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>

          <b-button
            type="submit"
            variant="success"
            class="ms-1"
            :disabled="
              !orctoItensSugeridos.length || orctoItensSugeridos.length === 0
            "
            @click="confSugestao"
          >
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar Alterações
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal
      v-model="showErrosLotes"
      id="showErrosLotes"
      size="lg"
      title="Lotes para validação"
      title-class="font-18"
      hide-footer
    >
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>Sequência</th>
                      <th>Código Produto</th>
                      <th>Produto</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="data in listErroLote" :key="data.id">
                      <td>{{ data.sequenc }}</td>
                      <td>{{ data.codprod }}</td>
                      <td>{{ data.descprod }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      v-model="showModalErro"
      id="showModalErro"
      size="lg"
      title="Erro"
      title-class="font-18"
      hide-footer
    >
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div v-if="Array.isArray(errorMessage)">
                <div v-for="data in errorMessage" :key="data.id">
                  <h5>{{data}}</h5>
                  <hr>
                </div>
              </div>

              <div v-else>
                <h5>{{errorMessage}}</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      title="Adicionar Logo Campanha"
      v-model="showModalAddCampanha"
      hide-footer
    >
      <div class="row">
        <div class="mb-3">
          <label class="d-flex" for="campanha">
            <i class="bx bx-search-alt-2 me-1 text-end"></i>
            <h5 class="text-muted">Buscar campanhas salvas</h5>
          </label>
          <multiselect
            id="campanha"
            @search-change="pesqCampanha"
            @select="escolheuCampanha"
            v-model="orctoData.codcampanha"
            :value="orctoData.codcampanha"
            placeholder="Selecionar Campanha"
            :options="dtListCampanhas"
            :searchable="true"
            label="Campanhas"
            track-by="codigo"
            value-prop="codigo"
          >
            <template #option="slotProps">
              <div class="row">
                <div class="mt-2 font-size-20">
                  {{
                    `${slotProps.option.codigo} - ${slotProps.option.descricao}`
                  }}
                </div>
              </div>
            </template>
          </multiselect>
        </div>
      </div>

      <div class="row">
        <div class="card-body">
          <h4 class="card-title">Selecionar novo arquivo</h4>
          <DropZone @change="selectedFile" />
          <span class="file-info mt-1">Arquivo: {{ dropzoneFile.name }}</span>
          <hr />
          <div class="d-flex mt-2">
            <div class="col-md-4 me-2">
              <label for="codcamp">Código Campanha</label>
              <input
                id="codcamp"
                v-model="campanhaData.codigo"
                type="text"
                class="form-control text-start"
                placeholder="Código Campanha"
              />
            </div>

            <div class="col-md-8 me-2">
              <label for="desccamp">Descrição/Nome</label>
              <input
                id="desccamp"
                v-model="campanhaData.descricao"
                type="text"
                class="form-control text-start"
                placeholder="Descrição/Nome"
              />
            </div>
          </div>

          <div v-if="submittedAnexo && !dropzoneFile.name">
            <span class="text-danger font-size-11"
              >Favor selecionar o arquivo e tentar novamente.</span
            >
          </div>
        </div>
      </div>

      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalAddCampanha = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button
          type="submit"
          variant="success"
          class="ms-1"
          @click="validaImportacaoCampanha"
        >
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>

    <!--showModalIndicaPedido-->
    <b-modal title="Agregar Orçamento à pedido" v-model="showModalIndicaPedido" hide-footer>
      <div class="row">
        <div class="mb-3">
          <label class="d-flex" for="pedido">
            <i class="bx bx-search-alt-2  me-1 text-end"></i>
            <h5 class=text-muted>Buscar Pedidos</h5>
          </label>
          <multiselect id="pedido"
                        @search-change="pesqPedido"
                        @select="escolheuPedido"
                        v-model="orctoData.agregped_id"
                        :value="orctoData.agregped_id"
                        placeholder="Selecionar Pedido"
                        :options="dtListPedidos"
                        :searchable="true"
                        label="Pedidos"
                        track-by="id"
                        value-prop="id">
            <template #option="slotProps">
              <div class="row">
                <div class="mt-2 font-size-20">{{ `Cód.(${slotProps.option.id}) - ID(${slotProps.option.codigo}) (${formatDate(slotProps.option.created_at)})` }}</div>
              </div>
            </template>
          </multiselect>
        </div>
      </div>

      <!--<div class="text-end mt-5">
        <b-button variant="light" @click="showModalIndicaPedido = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="validaImportacaoCampanha">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>-->
    </b-modal>

    <b-modal
        v-model="showModalAssociaLotes"
        id="showModalAssociaLotes"
        size="xl"
        title="Associação de lotes"
        title-class="font-18"
        hide-footer
    >
      <div class="row">
        <div class="col-xl-12">
          <!-- ====== Associação de lotes: cards no mobile ====== -->
          <div class="m-list" v-if="isMobile">
            <div
              v-for="data in dtListAssociaLote"
              :key="`m-lote-${data.id}`"
              class="m-item-form"
            >
              <p class="m-card__title mb-0">{{ data.descprod }}</p>
              <p class="m-card__subtitle">
                Cód. {{ data.produto }} &middot; ID {{ data.produto_id }}
                &middot; Qtd. {{ formatDecimal(data.qtd) }}
              </p>

              <label :for="`m-lotes-${data.id}`" class="font-size-11 text-muted">
                LOTE(S)
              </label>
              <multiselect
                :id="`m-lotes-${data.id}`"
                v-model="data.lote"
                :mode="'tags'"
                :options="data.optionsLotes"
                placeholder="Selecionar lotes"
                label="cod"
                track-by="cod"
                value-prop="cod"
              >
                <template #option="slotProps">
                  <div class="row">
                    <div class="mt-2 font-size-16">
                      <span class="text-info">{{ slotProps.option.cod }}</span>
                      <span class="ms-2">
                        {{ `(Qtd: ${slotProps.option.saldo})` }}
                      </span>
                    </div>
                  </div>
                </template>
              </multiselect>
            </div>

            <div class="m-empty" v-if="dtListAssociaLote.length === 0">
              Nenhum item pendente de associação de lote.
            </div>
          </div>

          <div class="card" v-if="!isMobile">
            <div class="card-body">
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                  <tr>
                    <th>Produto</th>
                    <th>Código</th>
                    <th>ID</th>
                    <th>Qtd.</th>
                    <th>Lote</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="data in dtListAssociaLote" :key="data.id">
                    <td class="text-start">{{data.descprod}}</td>
                    <td class="text-start">{{data.produto}}</td>
                    <td class="text-center">{{data.produto_id}}</td>
                    <td class="text-center">{{formatDecimal(data.qtd)}}</td>
                    <td class="text-center" style="width: 200px">
                      <multiselect
                          id="lotes"
                          v-model="data.lote"
                          :mode="'tags'"
                          :options="data.optionsLotes"
                          placeholder="Selecionar lotes"
                          label="cod"
                          track-by="cod"
                          value-prop="cod"
                      >
                        <template #option="slotProps">
                          <div class="row">
                            <div class="mt-2 font-size-16">
                              <span class="text-info">
                                {{ slotProps.option.cod }}
                              </span>
                              <span class="ms-2">
                                {{ `(Qtd: ${slotProps.option.saldo})` }}
                              </span>
                            </div>
                          </div>
                        </template>
                      </multiselect>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div v-if="updatingReserva">
            <h3 class="text-info text-center">Aguarde um momento, estamos reservando os saldos dos produtos...</h3>
          </div>

          <div class="row" v-if="updatingReserva">
            <div class="col-12 text-center">
              <b-spinner type="grow"
                         class="m-6 mx-2"
                         variant="secondary"
                         role="status">
              </b-spinner>
              <b-spinner type="grow"
                         class="m-6 mx-2"
                         variant="secondary"
                         role="status">
              </b-spinner>
              <b-spinner type="grow"
                         class="m-6 mx-2"
                         variant="secondary"
                         role="status">
              </b-spinner>
            </div>
          </div>

          <div class="text-end mt-5">
            <b-button variant="light" @click="showModalAssociaLotes = false" :disabled="updatingReserva">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Cancelar
            </b-button>

            <b-button
                type="submit"
                variant="success"
                class="ms-1"
                @click="gerarReservaSaldos"
                :disabled="updatingReserva"
            >
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
              Confirmar
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
        v-model="showModalMsgUpdating"
        id="showModalMsgUpdating"
        size="lg"
        hide-footer
    >
      <div>
        <h3 class="text-info text-center">Aguarde um momento, estamos processando os dados...</h3>
      </div>

      <div class="row">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>
    </b-modal>

  </Layout>
</template>

<style>
.multiselect-size {
  --ms-max-height: 500px;
}

/* Larguras das colunas da sugestão de itens (Qtd. e Vlr. Unit. iguais). */
@media (min-width: 768px) {
  .sug-c-cod { flex: 0 0 9%; max-width: 9%; }
  .sug-c-desc { flex: 0 0 27%; max-width: 27%; }
  .sug-c-fam { flex: 0 0 5%; max-width: 5%; }
  .sug-c-ult { flex: 0 0 8%; max-width: 8%; }
  .sug-c-qtd,
  .sug-c-unit { flex: 0 0 11%; max-width: 11%; }
  .sug-c-cub { flex: 0 0 9%; max-width: 9%; }
  .sug-c-tot { flex: 0 0 15%; max-width: 15%; }
  .sug-c-del { flex: 0 0 5%; max-width: 5%; }
}

/* Sugestão de itens: banner e totais fixos, só a lista rola. */
.sug-wrap {
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 13rem);
  max-height: calc(100dvh - 13rem);
}
.sug-topo {
  flex: 0 0 auto;
}
.sug-lista {
  flex: 1 1 auto;
  min-height: 12rem;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
}
.sug-descvol__detalhe {
  max-height: 30vh;
  overflow-y: auto;
}
.sug-descvol.is-compacto {
  padding-top: 0.35rem !important;
  padding-bottom: 0.35rem !important;
}
.sug-descvol__titulo[role="button"] {
  cursor: pointer;
}
.sug-cab {
  position: sticky;
  top: 0;
  z-index: 3;
  background: var(--bs-modal-bg, var(--bs-body-bg, #fff));
  border-bottom: 1px solid var(--bs-border-color, #e9ecef);
  margin-bottom: 0.5rem;
}
.sug-totais {
  font-weight: 600;
  font-size: 0.875rem;
  padding: 0.15rem 0 0.35rem;
}
.sug-totais > div {
  padding-left: calc(var(--bs-gutter-x, 1.5rem) * 0.5);
  /* alinha com o texto dos inputs (padding interno do form-control) */
  padding-right: calc(var(--bs-gutter-x, 1.5rem) * 0.5 + 0.75rem);
}
.sug-totais-m {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  border: 1px solid var(--bs-border-color, #e9ecef);
  border-radius: 0.375rem;
  background: var(--bs-light, #f8f9fa);
}
.sug-totais-m > div {
  display: flex;
  flex-direction: column;
  min-width: 0;
  text-align: right;
}
.sug-totais-m span {
  font-size: 0.75rem;
  color: var(--bs-secondary-color, #74788d);
}
.sug-totais-m strong {
  font-size: 0.875rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
